'use strict';

var _objectDestructuringEmpty = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectDestructuringEmpty.js").default;

var _readOnlyError = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/readOnlyError.js").default;

var _toConsumableArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _possibleConstructorReturn = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js").default;

var _getPrototypeOf = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;

var _inherits = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _regeneratorRuntime = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _toPropertyKey = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toPropertyKey.js").default;

var _slicedToArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _defineProperty = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _objectSpread = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _objectWithoutProperties = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _excluded = ["className", "variant"],
    _excluded2 = ["className", "variant", "size", "color", "asChild", "children"],
    _excluded3 = ["className", "variant", "size", "color", "asChild", "children"],
    _excluded4 = ["className"],
    _excluded5 = ["children", "className", "variant"],
    _excluded6 = ["children", "className"],
    _excluded7 = ["children", "value", "className"],
    _excluded8 = ["className"],
    _excluded9 = ["className"],
    _excluded10 = ["className", "children"],
    _excluded11 = ["className"],
    _excluded12 = ["className"],
    _excluded13 = ["className"],
    _excluded14 = ["country", "role", "size", "alt"],
    _excluded15 = ["value", "textValue", "id"],
    _excluded16 = ["optionProps", "labelProps", "descriptionProps"],
    _excluded17 = ["className", "error"],
    _excluded18 = ["className", "asChild", "error", "value", "defaultValue", "onValueChange", "onChange"],
    _excluded19 = ["className"],
    _excluded20 = ["className", "type", "children", "onClick", "value"],
    _excluded21 = ["size"],
    _excluded22 = ["asChild"],
    _excluded23 = ["state", "isExiting"],
    _excluded24 = ["className"],
    _excluded25 = ["className"],
    _excluded26 = ["className"],
    _excluded27 = ["children", "className"],
    _excluded28 = ["className", "children"],
    _excluded29 = ["className"],
    _excluded30 = ["asChild"],
    _excluded31 = ["side", "className", "children"],
    _excluded32 = ["label", "value", "defaultValue", "open", "defaultOpen", "onOpenChange", "onValueChange"],
    _excluded33 = ["onClick"],
    _excluded34 = ["className"],
    _excluded35 = ["children", "className", "side", "shouldFilter"],
    _excluded36 = ["children", "value", "onSelect"],
    _excluded37 = ["className", "error", "focused", "value", "success"],
    _excluded38 = ["className"],
    _excluded39 = ["className"],
    _excluded40 = ["className", "size"],
    _excluded41 = ["className"],
    _excluded42 = ["className"],
    _excluded43 = ["label", "description", "errorMessage", "children", "name", "loading", "icon", "onClear", "error", "size"],
    _excluded44 = ["onValueChange", "value"],
    _excluded45 = ["className", "onValueChange", "value"],
    _excluded46 = ["className", "children"],
    _excluded47 = ["className", "onValueChange", "value", "children"],
    _excluded48 = ["className", "children"],
    _excluded49 = ["className", "children"],
    _excluded50 = ["className", "children"],
    _excluded51 = ["className", "classNames", "showOutsideDays", "value", "onValueChange"],
    _excluded52 = ["className", "align", "sideOffset"],
    _excluded53 = ["id", "value", "label", "open", "name", "error", "placeholder", "fromDate", "toDate", "onValueChange", "onOpenChange"],
    _excluded54 = ["asChild"],
    _excluded55 = ["children", "className"],
    _excluded56 = ["className", "children"],
    _excluded57 = ["className"],
    _excluded58 = ["className"],
    _excluded59 = ["className"],
    _excluded60 = ["className"],
    _excluded61 = ["className"],
    _excluded62 = ["className"],
    _excluded63 = ["className", "children", "arrowPosition", "arrowDirection"],
    _excluded64 = ["className", "children", "asChild"],
    _excluded65 = ["className", "customRender", "placeholder"],
    _excluded66 = ["className", "children", "position"],
    _excluded67 = ["className"],
    _excluded68 = ["className"],
    _excluded69 = ["className", "children", "icon"],
    _excluded70 = ["className"],
    _excluded71 = ["className"],
    _excluded72 = ["asChild", "className"],
    _excluded73 = ["className", "children"],
    _excluded74 = ["className", "children", "href"],
    _excluded75 = ["className", "children", "open", "onOpenChange", "breakpoint"],
    _excluded76 = ["asChild", "className"],
    _excluded77 = ["asChild", "className"],
    _excluded78 = ["callingCode", "id", "label", "onValueChange", "error"],
    _excluded79 = ["label", "description", "errorMessage", "children", "name", "loading", "icon", "onClear", "error"],
    _excluded80 = ["children", "className", "color", "target", "rel"],
    _excluded81 = ["onValueChange", "value"],
    _excluded82 = ["className"],
    _excluded83 = ["className"],
    _excluded84 = ["className"],
    _excluded85 = ["className"],
    _excluded86 = ["className", "children"],
    _excluded87 = ["className", "orientation"],
    _excluded88 = ["children"],
    _excluded89 = ["className", "side", "sideOffset", "children"],
    _excluded90 = ["className", "variant", "onClose"],
    _excluded91 = ["className", "children"],
    _excluded92 = ["className"],
    _excluded93 = ["className"],
    _excluded94 = ["className"],
    _excluded95 = ["className"],
    _excluded96 = ["className"],
    _excluded97 = ["className"],
    _excluded98 = ["className", "position"],
    _excluded99 = ["className", "variant"],
    _excluded100 = ["className"],
    _excluded101 = ["className"],
    _excluded102 = ["id", "title", "description"],
    _excluded103 = ["className"];

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

require('@total-typescript/ts-reset');

var AspectRatioPrimitive = require('@radix-ui/react-aspect-ratio');

var jsxRuntime = require('react/jsx-runtime');

var classVarianceAuthority = require('class-variance-authority');

var React = require('react');

var cn$1 = require('clsx');

var tailwindMerge = require('tailwind-merge');

var reactSlot = require('@radix-ui/react-slot');

var TabsPrimitive = require('@radix-ui/react-tabs');

var reactDeviceDetect = require('react-device-detect');

var reactI18next = require('react-i18next');

var utils = require('@react-aria/utils');

var reactAria = require('react-aria');

var reactStately = require('react-stately');

var ReactDOM = require('react-dom');

var hooks = require('@mozioinc/hooks');

var cmdk = require('cmdk');

var DialogPrimitive = require('@radix-ui/react-dialog');

var CheckboxPrimitive = require('@radix-ui/react-checkbox');

var dateFns = require('date-fns');

var reactDayPicker = require('react-day-picker');

var PopoverPrimitive = require('@radix-ui/react-popover');

var CollapsiblePrimitive = require('@radix-ui/react-collapsible');

var SelectPrimitive = require('@radix-ui/react-select');

var usehooksTs = require('usehooks-ts');

var date = require('@internationalized/date');

var RadioGroupPrimitive = require('@radix-ui/react-radio-group');

var ScrollAreaPrimitive = require('@radix-ui/react-scroll-area');

var TooltipPrimitive = require('@radix-ui/react-tooltip');

var NavigationMenuPrimitive = require('@radix-ui/react-navigation-menu');

var SwitchPrimitives = require('@radix-ui/react-switch');

var ToastPrimitives = require('@radix-ui/react-toast');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n.default = e;
  return Object.freeze(n);
}

var AspectRatioPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(AspectRatioPrimitive);

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

var TabsPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(TabsPrimitive);

var DialogPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(DialogPrimitive);

var CheckboxPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(CheckboxPrimitive);

var PopoverPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(PopoverPrimitive);

var CollapsiblePrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(CollapsiblePrimitive);

var SelectPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(SelectPrimitive);

var RadioGroupPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(RadioGroupPrimitive);

var ScrollAreaPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(ScrollAreaPrimitive);

var TooltipPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(TooltipPrimitive);

var NavigationMenuPrimitive__namespace = /*#__PURE__*/_interopNamespaceDefault(NavigationMenuPrimitive);

var SwitchPrimitives__namespace = /*#__PURE__*/_interopNamespaceDefault(SwitchPrimitives);

var ToastPrimitives__namespace = /*#__PURE__*/_interopNamespaceDefault(ToastPrimitives);

var AspectRatio = AspectRatioPrimitive__namespace.Root;

var cn = function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }

  return tailwindMerge.twMerge(cn$1.clsx(inputs));
};

var badgeVariants = classVarianceAuthority.cva("inline-flex items-center w-max rounded-sm border px-1 py-1.5 text-xs font-normal", {
  variants: {
    variant: {
      primary: "border-transparent bg-primary text-primary-contrast",
      secondary: "border-transparent bg-secondary text-secondary-contrast",
      error: "border-transparent bg-error-300 text-white hover:bg-error-400",
      outline: "text-neutral-800",
      ring: "bg-primary mb-1 text-primary-contrast border-white border-1 ring-1 ring-primary ring-offset-1"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
});
var Badge = React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      variant = _ref2.variant,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    ref: ref,
    className: cn(badgeVariants({
      variant: variant
    }), className)
  }, props));
});
Badge.displayName = "Badge";
var BUTTON_VARIANT = {
  SOLID: "solid",
  OUTLINE: "outline",
  GHOST: "ghost"
};
var BUTTON_COLOR = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  WHITE: "white",
  NEUTRAL: "neutral"
};
var BUTTON_SIZE = {
  SM: "sm",
  MD: "md",
  LG: "lg"
};
var buttonVariants = classVarianceAuthority.cva("inline-flex gap-2 items-center justify-center duration-200 rounded disabled:pointer-events-none disabled:opacity-30", {
  variants: {
    color: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BUTTON_COLOR.PRIMARY, ""), BUTTON_COLOR.SECONDARY, ""), BUTTON_COLOR.ERROR, ""), BUTTON_COLOR.SUCCESS, ""), BUTTON_COLOR.WARNING, ""), BUTTON_COLOR.WHITE, ""), BUTTON_COLOR.NEUTRAL, ""),
    variant: _defineProperty(_defineProperty(_defineProperty({}, BUTTON_VARIANT.SOLID, ""), BUTTON_VARIANT.OUTLINE, "border bg-transparent"), BUTTON_VARIANT.GHOST, "bg-transparent"),
    size: _defineProperty(_defineProperty(_defineProperty({}, BUTTON_SIZE.SM, "px-3 py-1 text-sm"), BUTTON_SIZE.MD, "px-4 py-2 text-base"), BUTTON_SIZE.LG, "px-5 py-3 text-base")
  },
  compoundVariants: [{
    color: BUTTON_COLOR.PRIMARY,
    variant: BUTTON_VARIANT.SOLID,
    class: "bg-primary text-primary-contrast hover:bg-primary-400"
  }, {
    color: BUTTON_COLOR.SECONDARY,
    variant: BUTTON_VARIANT.SOLID,
    class: "bg-secondary text-secondary-contrast hover:bg-secondary-400"
  }, {
    color: BUTTON_COLOR.ERROR,
    variant: BUTTON_VARIANT.SOLID,
    class: "bg-error text-white hover:bg-error-400"
  }, {
    color: BUTTON_COLOR.SUCCESS,
    variant: BUTTON_VARIANT.SOLID,
    class: "bg-success text-white hover:bg-success-400"
  }, {
    color: BUTTON_COLOR.WARNING,
    variant: BUTTON_VARIANT.SOLID,
    class: "bg-warning text-white hover:bg-warning-400"
  }, {
    color: BUTTON_COLOR.WHITE,
    variant: BUTTON_VARIANT.SOLID,
    class: "bg-white text-black hover:bg-neutral-100"
  }, {
    color: BUTTON_COLOR.NEUTRAL,
    variant: BUTTON_VARIANT.SOLID,
    class: "bg-neutral text-black hover:bg-neutral-600"
  }, {
    color: BUTTON_COLOR.PRIMARY,
    variant: [BUTTON_VARIANT.OUTLINE, BUTTON_VARIANT.GHOST],
    class: "text-primary border-primary hover:bg-primary-100/20"
  }, {
    color: BUTTON_COLOR.SECONDARY,
    variant: [BUTTON_VARIANT.OUTLINE, BUTTON_VARIANT.GHOST],
    class: "text-secondary border-secondary hover:bg-secondary-100/20"
  }, {
    color: BUTTON_COLOR.ERROR,
    variant: [BUTTON_VARIANT.OUTLINE, BUTTON_VARIANT.GHOST],
    class: "text-error border-error hover:bg-error-100/20"
  }, {
    color: BUTTON_COLOR.SUCCESS,
    variant: [BUTTON_VARIANT.OUTLINE, BUTTON_VARIANT.GHOST],
    class: "text-success border-success hover:bg-success-100/20"
  }, {
    color: BUTTON_COLOR.WARNING,
    variant: [BUTTON_VARIANT.OUTLINE, BUTTON_VARIANT.GHOST],
    class: "text-warning border-warning hover:bg-warning-100/20"
  }, {
    color: BUTTON_COLOR.WHITE,
    variant: [BUTTON_VARIANT.OUTLINE, BUTTON_VARIANT.GHOST],
    class: "text-white border-white hover:bg-neutral-100/20"
  }, {
    color: BUTTON_COLOR.NEUTRAL,
    variant: [BUTTON_VARIANT.OUTLINE, BUTTON_VARIANT.GHOST],
    class: "text-black border-neutral hover:bg-neutral-100/20"
  }],
  defaultVariants: {
    variant: BUTTON_VARIANT.SOLID,
    size: BUTTON_SIZE.MD,
    color: BUTTON_COLOR.PRIMARY
  }
});
var Button = React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
      variant = _ref3.variant,
      size = _ref3.size,
      color = _ref3.color,
      _ref3$asChild = _ref3.asChild,
      asChild = _ref3$asChild === void 0 ? false : _ref3$asChild,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded2);

  var Comp = asChild ? reactSlot.Slot : "button";
  return /* @__PURE__ */jsxRuntime.jsx(Comp, _objectSpread(_objectSpread({
    className: cn(buttonVariants({
      color: color,
      variant: variant,
      size: size,
      className: className
    })),
    ref: ref
  }, props), {}, {
    children: children
  }));
});
Button.displayName = "Button";
var iconButtonVariants = classVarianceAuthority.cva("", {
  variants: {
    size: _defineProperty(_defineProperty(_defineProperty({}, BUTTON_SIZE.SM, "px-0 py-0 text-lg"), BUTTON_SIZE.MD, "px-1 py-1 text-xl"), BUTTON_SIZE.LG, "px-2 py-2 text-2xl")
  },
  defaultVariants: {
    size: BUTTON_SIZE.MD
  }
});
var IconButton = React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
      variant = _ref4.variant,
      size = _ref4.size,
      color = _ref4.color,
      _ref4$asChild = _ref4.asChild,
      asChild = _ref4$asChild === void 0 ? false : _ref4$asChild,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded3);

  var Comp = asChild ? reactSlot.Slot : "button";
  return /* @__PURE__ */jsxRuntime.jsx(Comp, _objectSpread(_objectSpread({
    className: cn(buttonVariants({
      color: color,
      variant: variant,
      className: className
    }), iconButtonVariants({
      size: size
    })),
    ref: ref
  }, props), {}, {
    children: children
  }));
});
IconButton.displayName = "IconButton";

var _style;

function _extends$x() {
  _extends$x = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$x.apply(this, arguments);
}

var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$x({
    width: "1em",
    height: "1em",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React__namespace.createElement("style", null, "@keyframes spinner_zKoa{to{transform:rotate(360deg)}}@keyframes spinner_YpZS{0%{stroke-dasharray:0 150;stroke-dashoffset:0}47.5%{stroke-dasharray:42 150;stroke-dashoffset:-16}95%,to{stroke-dasharray:42 150;stroke-dashoffset:-59}}")), /*#__PURE__*/React__namespace.createElement("g", {
    style: {
      transformOrigin: "center",
      animation: "spinner_zKoa 2s linear infinite"
    }
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    fill: "none",
    strokeWidth: 3,
    style: {
      strokeLinecap: "round",
      animation: "spinner_YpZS 1.5s ease-in-out infinite"
    }
  })));
};

var Loading = React.forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
      props = _objectWithoutProperties(_ref5, _excluded4);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread({
    ref: ref,
    className: cn("text-primary grid place-items-center text-xl", className),
    role: "progressbar"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntime.jsx(SvgSpinner, {})
  }));
});
Loading.displayName = "Loading";
var TAB_VARIANT = {
  DEFAULT: "default",
  BORDERED: "bordered",
  BOXED: "boxed"
};

var Tabs = function Tabs(_ref6) {
  var children = _ref6.children,
      className = _ref6.className,
      _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? "default" : _ref6$variant,
      props = _objectWithoutProperties(_ref6, _excluded5);

  return /* @__PURE__ */jsxRuntime.jsx(TabsPrimitive__namespace.Root, _objectSpread(_objectSpread({}, props), {}, {
    className: cn("group/tabs", "data-[variant=default]:bg-primary-400 data-[variant=default]:rounded-lg data-[variant=default]:bg-opacity-50", className),
    "data-variant": variant,
    children: children
  }));
};

var TabsList = function TabsList(_ref7) {
  var children = _ref7.children,
      className = _ref7.className;
  return /* @__PURE__ */jsxRuntime.jsx(TabsPrimitive__namespace.List, {
    className: cn("flex gap-2 sm:gap-4", className),
    children: children
  });
};

var TabsTrigger = function TabsTrigger(_ref8) {
  var children = _ref8.children,
      className = _ref8.className,
      props = _objectWithoutProperties(_ref8, _excluded6);

  return /* @__PURE__ */jsxRuntime.jsx(TabsPrimitive__namespace.Trigger, _objectSpread(_objectSpread({}, props), {}, {
    className: cn("relative flex flex-col items-center gap-1 rounded-t-lg px-3 py-2 after:absolute after:-bottom-[0.125rem] after:left-0 after:h-[0.1875rem] after:w-full after:rounded-sm sm:flex-row sm:gap-2 sm:px-4 sm:py-3", "group-data-[variant=default]/tabs:data-[state=active]:text-primary group-data-[variant=default]/tabs:text-primary-contrast group-data-[variant=default]/tabs:data-[state=active]:bg-neutral-100", "group-data-[variant=bordered]/tabs:white group-data-[variant=bordered]/tabs:data-[state=active]:border-primary group-data-[variant=bordered]/tabs:data-[state=active]:text-primary group-data-[variant=bordered]/tabs:data-[state=active]:hover:bg-primary-100/20 group-data-[variant=bordered]/tabs:rounded-full group-data-[variant=bordered]/tabs:border group-data-[variant=bordered]/tabs:border-neutral-700 group-data-[variant=bordered]/tabs:hover:bg-neutral-100", "group-data-[variant=boxed]/tabs:white group-data-[variant=boxed]/tabs:data-[state=active]:bg-primary-500 group-data-[variant=boxed]/tabs:data-[state=active]:text-primary-contrast group-data-[variant=boxed]/tabs:rounded-lg", className),
    children: children
  }));
};

var TabsContent = function TabsContent(_ref9) {
  var children = _ref9.children,
      value = _ref9.value,
      className = _ref9.className,
      props = _objectWithoutProperties(_ref9, _excluded7);

  return /* @__PURE__ */jsxRuntime.jsx(TabsPrimitive__namespace.Content, _objectSpread(_objectSpread({}, props), {}, {
    value: value,
    className: cn("p-5", "group-data-[variant=default]/tabs:rounded-b-lg group-data-[variant=default]/tabs:bg-neutral-100", className),
    children: children
  }));
};

var Card = React.forwardRef(function (_ref10, ref) {
  var className = _ref10.className,
      props = _objectWithoutProperties(_ref10, _excluded8);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    ref: ref,
    className: cn("flex flex-col rounded-lg border bg-white text-black transition-shadow hover:shadow", className)
  }, props));
});
Card.displayName = "Card";
var CardHeader = React.forwardRef(function (_ref11, ref) {
  var className = _ref11.className,
      props = _objectWithoutProperties(_ref11, _excluded9);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    ref: ref,
    className: cn("flex flex-col p-2 sm:p-3", className)
  }, props));
});
CardHeader.displayName = "CardHeader";
var CardTitle = React.forwardRef(function (_ref12, ref) {
  var className = _ref12.className,
      children = _ref12.children,
      props = _objectWithoutProperties(_ref12, _excluded10);

  return /* @__PURE__ */jsxRuntime.jsx("h3", _objectSpread(_objectSpread({
    ref: ref,
    className: cn("text-xl font-semibold", className)
  }, props), {}, {
    children: children
  }));
});
CardTitle.displayName = "CardTitle";
var CardDescription = React.forwardRef(function (_ref13, ref) {
  var className = _ref13.className,
      props = _objectWithoutProperties(_ref13, _excluded11);

  return /* @__PURE__ */jsxRuntime.jsx("p", _objectSpread({
    ref: ref,
    className: cn("text-sm text-black", className)
  }, props));
});
CardDescription.displayName = "CardDescription";
var CardContent = React.forwardRef(function (_ref14, ref) {
  var className = _ref14.className,
      props = _objectWithoutProperties(_ref14, _excluded12);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    ref: ref,
    className: cn("p-2 sm:p-3", className)
  }, props));
});
CardContent.displayName = "CardContent";
var CardFooter = React.forwardRef(function (_ref15, ref) {
  var className = _ref15.className,
      props = _objectWithoutProperties(_ref15, _excluded13);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    ref: ref,
    className: cn("mx-2 flex items-end py-4 sm:mx-3 sm:py-5", className)
  }, props));
});
CardFooter.displayName = "CardFooter";
var countryCodes = ["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LGBT", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "XK", "YE", "YT", "ZA", "ZM", "ZW", "EU", "GB-ENG", "GB-NIR", "GB-SCT", "GB-WLS", "GB-ZET", "US-CA"];
var CDN_FILES = "https://cdn.jsdelivr.net/gh/madebybowtie/FlagKit@2.2/Assets/SVG";

var Flag = function Flag(_ref16) {
  var _ref16$country = _ref16.country,
      country = _ref16$country === void 0 ? "US" : _ref16$country,
      _ref16$role = _ref16.role,
      role = _ref16$role === void 0 ? "img" : _ref16$role,
      _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? 24 : _ref16$size,
      alt = _ref16.alt,
      props = _objectWithoutProperties(_ref16, _excluded14);

  if (country) {
    var countryCode = country.toUpperCase();

    if (countryCodes.includes(country) !== void 0) {
      var flagSrc = "".concat(CDN_FILES, "/").concat(countryCode, ".svg");
      return /* @__PURE__ */jsxRuntime.jsx("img", _objectSpread({
        src: flagSrc,
        role: role,
        alt: alt !== null && alt !== void 0 ? alt : "".concat(countryCode, " Flag"),
        height: size,
        width: size
      }, props));
    }

    return /* @__PURE__ */jsxRuntime.jsx("span", {
      children: countryCode
    });
  }

  return null;
};

var useTranslation = reactI18next.useTranslation;
var slotCallbackSymbol = Symbol("callback");
var defaultSlot = Symbol("default");

var Provider = function Provider(_ref17) {
  var values = _ref17.values,
      children = _ref17.children;

  var _iterator = _createForOfIteratorHelper(values),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value2 = _slicedToArray(_step.value, 2),
          Context = _step$value2[0],
          value = _step$value2[1];

      children = /* @__PURE__ */jsxRuntime.jsx(Context.Provider, {
        value: value,
        children: children
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return children;
};

function useRenderProps(props) {
  var className = props.className,
      style = props.style,
      children = props.children,
      defaultClassName = props.defaultClassName,
      defaultChildren = props.defaultChildren,
      values = props.values;
  return React.useMemo(function () {
    var computedClassName;
    var computedStyle;
    var computedChildren;
    computedClassName = typeof className === "function" ? className(values) : className;
    computedStyle = typeof style === "function" ? style(values) : style;

    if (typeof children === "function") {
      computedChildren = children(values);
    } else if (children == null) {
      computedChildren = defaultChildren;
    } else {
      computedChildren = children;
    }

    return {
      className: computedClassName !== null && computedClassName !== void 0 ? computedClassName : defaultClassName,
      style: computedStyle,
      children: computedChildren,
      "data-rac": ""
    };
  }, [className, style, children, defaultClassName, defaultChildren, values]);
}

function useSlottedContext(context, slot) {
  var ctx = React.useContext(context);

  if (slot === null) {
    return null;
  }

  if (ctx && typeof ctx === "object" && "slots" in ctx && ctx.slots) {
    var availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map(function (p) {
      return "\"".concat(p, "\"");
    }));

    if (!slot && !ctx.slots[defaultSlot]) {
      throw new Error("A slot prop is required. Valid slot names are ".concat(availableSlots, "."));
    }

    var slotKey = slot || defaultSlot;

    if (!ctx.slots[slotKey]) {
      throw new Error("Invalid slot \"".concat(slot, "\". Valid slot names are ").concat(availableSlots, "."));
    }

    return ctx.slots[slotKey];
  }

  return ctx;
}

var useContextProps = function useContextProps(props, ref, context) {
  var ctx = useSlottedContext(context, props.slot) || {};

  var contextRef = ctx.ref,
      callback = ctx[slotCallbackSymbol],
      contextProps = _objectWithoutProperties(ctx, ["ref", slotCallbackSymbol].map(_toPropertyKey));

  var mergedRef = utils.useObjectRef(React.useMemo(function () {
    return utils.mergeRefs(ref, contextRef);
  }, [ref, contextRef]));
  var mergedProps = utils.mergeProps(contextProps, props);
  React.useEffect(function () {
    if (callback) {
      callback(props);
    }
  }, [callback, props]);
  return [mergedProps, mergedRef];
};

function useSlot() {
  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hasSlot = _React$useState2[0],
      setHasSlot = _React$useState2[1];

  var hasRun = React.useRef(false);
  var ref = React.useCallback(function (el) {
    hasRun.current = true;
    setHasSlot(!!el);
  }, []);
  utils.useLayoutEffect(function () {
    if (!hasRun.current) {
      setHasSlot(false);
    }
  }, []);
  return [ref, hasSlot];
}

var useEnterAnimation = function useEnterAnimation(ref) {
  var isReady = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isEntering = _React$useState4[0],
      setEntering = _React$useState4[1];

  useAnimation(ref, isEntering && isReady, React.useCallback(function () {
    return setEntering(false);
  }, []));
  return isEntering && isReady;
};

var useExitAnimation = function useExitAnimation(ref, isOpen) {
  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isExiting = _React$useState6[0],
      setExiting = _React$useState6[1];

  var _React$useState7 = React.useState("idle"),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      exitState = _React$useState8[0],
      setExitState = _React$useState8[1];

  if (!isOpen && ref.current && exitState === "idle") {
    isExiting = true;
    setExiting(true);
    setExitState("exiting");
  }

  if (!ref.current && exitState === "exited") {
    setExitState("idle");
  }

  useAnimation(ref, isExiting, React.useCallback(function () {
    setExitState("exited");
    setExiting(false);
  }, []));
  return isExiting;
};

var useAnimation = function useAnimation(ref, isActive, onEnd) {
  var previousAnimation = React.useRef(null);

  if (isActive && ref.current) {
    previousAnimation.current = window.getComputedStyle(ref.current).animation;
  }

  utils.useLayoutEffect(function () {
    if (isActive && ref.current) {
      var computedStyle = window.getComputedStyle(ref.current);

      if (computedStyle.animationName !== "none" && computedStyle.animation !== previousAnimation.current) {
        var _onAnimationEnd = function onAnimationEnd(event) {
          if (event.target === ref.current) {
            element.removeEventListener("animationend", _onAnimationEnd);
            ReactDOM.flushSync(function () {
              onEnd();
            });
          }
        };

        var element = ref.current;
        element.addEventListener("animationend", _onAnimationEnd);
        return function () {
          element.removeEventListener("animationend", _onAnimationEnd);
        };
      } else {
        onEnd();
      }
    }

    return;
  }, [ref, isActive, onEnd]);
};

if (typeof HTMLTemplateElement !== "undefined") {
  var getFirstChild = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: true,
    enumerable: true,
    get: function get() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : getFirstChild.call(this);
    }
  });
}

var HiddenContext = React.createContext(false);
var hiddenFragment = typeof DocumentFragment !== "undefined" ? new DocumentFragment() : null;

var Hidden = function Hidden(props) {
  var isHidden = React.useContext(HiddenContext);
  var isSSR = reactAria.useIsSSR();

  if (isHidden) {
    return /* @__PURE__ */jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: props.children
    });
  }

  var children = /* @__PURE__ */jsxRuntime.jsx(HiddenContext.Provider, {
    value: true,
    children: props.children
  });
  return isSSR ? /* @__PURE__ */jsxRuntime.jsx("template", {
    "data-react-aria-hidden": true,
    children: children
  }) : ReactDOM.createPortal(children, hiddenFragment);
};

var createHideableComponent = function createHideableComponent(fn) {
  var Wrapper = function Wrapper(props, ref) {
    var isHidden = React.useContext(HiddenContext);

    if (isHidden) {
      return null;
    }

    return fn(props, ref);
  };

  Wrapper.displayName = fn.displayName || fn.name;
  return React.forwardRef(Wrapper);
};

function removeDataAttributes(props) {
  var prefix = /^(data-.*)$/;
  var filteredProps = {};

  for (var prop in props) {
    if (!prefix.test(prop)) {
      filteredProps[prop] = props[prop];
    }
  }

  return filteredProps;
}

var additionalButtonHTMLAttributes = /* @__PURE__ */new Set(["form", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "name", "value"]);
var ButtonContext = React.createContext({});

var ComboBoxButton = function ComboBoxButton(props, ref) {
  var _useContextProps = useContextProps(props, ref, ButtonContext);

  var _useContextProps2 = _slicedToArray(_useContextProps, 2);

  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var ctx = props;

  var _reactAria$useButton = reactAria.useButton(props, ref),
      buttonProps = _reactAria$useButton.buttonProps,
      isPressed = _reactAria$useButton.isPressed;

  var _reactAria$useFocusRi = reactAria.useFocusRing(props),
      focusProps = _reactAria$useFocusRi.focusProps,
      isFocused = _reactAria$useFocusRi.isFocused,
      isFocusVisible = _reactAria$useFocusRi.isFocusVisible;

  var _reactAria$useHover = reactAria.useHover(props),
      hoverProps = _reactAria$useHover.hoverProps,
      isHovered = _reactAria$useHover.isHovered;

  var renderProps = useRenderProps(_objectSpread(_objectSpread({}, props), {}, {
    values: {
      isHovered: isHovered,
      isPressed: isPressed,
      isFocused: isFocused,
      isFocusVisible: isFocusVisible,
      isDisabled: props.isDisabled || false
    },
    defaultClassName: "react-aria-Button"
  }));
  return /* @__PURE__ */jsxRuntime.jsx("button", _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    type: "button"
  }, utils.filterDOMProps(props, {
    propNames: additionalButtonHTMLAttributes
  })), reactAria.mergeProps(buttonProps, focusProps, hoverProps)), renderProps), {}, {
    ref: ref,
    slot: props.slot || void 0,
    "data-disabled": props.isDisabled || void 0,
    "data-pressed": ctx.isPressed || isPressed || void 0,
    "data-hovered": isHovered || void 0,
    "data-focused": isFocused || void 0,
    "data-focus-visible": isFocusVisible || void 0
  }));
};

var _ComboBoxButton = /* @__PURE__ */createHideableComponent(ComboBoxButton);

var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  return __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
};

var NodeValue = /*#__PURE__*/function () {
  function NodeValue(type, key) {
    _classCallCheck(this, NodeValue);

    __publicField(this, "type");

    __publicField(this, "key");

    __publicField(this, "value", null);

    __publicField(this, "level", 0);

    __publicField(this, "hasChildNodes", false);

    __publicField(this, "rendered", null);

    __publicField(this, "textValue", "");

    __publicField(this, "aria-label");

    __publicField(this, "index", 0);

    __publicField(this, "parentKey", null);

    __publicField(this, "prevKey", null);

    __publicField(this, "nextKey", null);

    __publicField(this, "firstChildKey", null);

    __publicField(this, "lastChildKey", null);

    __publicField(this, "props", {});

    this.type = type;
    this.key = key;
  }

  return _createClass(NodeValue, [{
    key: "childNodes",
    get: function get() {
      throw new Error("childNodes is not supported");
    }
  }, {
    key: "clone",
    value: function clone() {
      var node = new NodeValue(this.type, this.key);
      node.value = this.value;
      node.level = this.level;
      node.hasChildNodes = this.hasChildNodes;
      node.rendered = this.rendered;
      node.textValue = this.textValue;
      node["aria-label"] = this["aria-label"];
      node.index = this.index;
      node.parentKey = this.parentKey;
      node.prevKey = this.prevKey;
      node.nextKey = this.nextKey;
      node.firstChildKey = this.firstChildKey;
      node.lastChildKey = this.lastChildKey;
      node.props = this.props;
      return node;
    }
  }]);
}();

var BaseNode = /*#__PURE__*/function (_Symbol$iterator) {
  function BaseNode(ownerDocument) {
    _classCallCheck(this, BaseNode);

    __publicField(this, "_firstChild", null);

    __publicField(this, "_lastChild", null);

    __publicField(this, "_previousSibling", null);

    __publicField(this, "_nextSibling", null);

    __publicField(this, "_parentNode", null);

    __publicField(this, "ownerDocument");

    this.ownerDocument = ownerDocument;
  }

  return _createClass(BaseNode, [{
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var node;
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            node = this.firstChild;

          case 1:
            if (!node) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return node;

          case 4:
            node = node.nextSibling;
            _context.next = 1;
            break;

          case 7:
          case "end":
            return _context.stop();
        }
      }, value, this);
    })
  }, {
    key: "firstChild",
    get: function get() {
      return this._firstChild;
    },
    set: function set(firstChild) {
      this._firstChild = firstChild;
      this.ownerDocument.markDirty(this);
    }
  }, {
    key: "lastChild",
    get: function get() {
      return this._lastChild;
    },
    set: function set(lastChild) {
      this._lastChild = lastChild;
      this.ownerDocument.markDirty(this);
    }
  }, {
    key: "previousSibling",
    get: function get() {
      return this._previousSibling;
    },
    set: function set(previousSibling) {
      this._previousSibling = previousSibling;
      this.ownerDocument.markDirty(this);
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return this._nextSibling;
    },
    set: function set(nextSibling) {
      this._nextSibling = nextSibling;
      this.ownerDocument.markDirty(this);
    }
  }, {
    key: "parentNode",
    get: function get() {
      return this._parentNode;
    },
    set: function set(parentNode) {
      this._parentNode = parentNode;
      this.ownerDocument.markDirty(this);
    }
  }, {
    key: "appendChild",
    value: function appendChild(child) {
      this.ownerDocument.startTransaction();

      if (child.parentNode) {
        child.parentNode.removeChild(child);
      }

      if (this.firstChild == null) {
        this.firstChild = child;
      }

      if (this.lastChild) {
        this.lastChild.nextSibling = child;
        child.index = this.lastChild.index + 1;
        child.previousSibling = this.lastChild;
      } else {
        child.previousSibling = null;
        child.index = 0;
      }

      child.parentNode = this;
      child.nextSibling = null;
      this.lastChild = child;
      this.ownerDocument.markDirty(this);

      if (child.hasSetProps) {
        this.ownerDocument.addNode(child);
      }

      this.ownerDocument.endTransaction();
      this.ownerDocument.queueUpdate();
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(newNode, referenceNode) {
      if (referenceNode == null) {
        return this.appendChild(newNode);
      }

      this.ownerDocument.startTransaction();

      if (newNode.parentNode) {
        newNode.parentNode.removeChild(newNode);
      }

      newNode.nextSibling = referenceNode;
      newNode.previousSibling = referenceNode.previousSibling;
      newNode.index = referenceNode.index;

      if (this.firstChild === referenceNode) {
        this.firstChild = newNode;
      } else if (referenceNode.previousSibling) {
        referenceNode.previousSibling.nextSibling = newNode;
      }

      referenceNode.previousSibling = newNode;
      newNode.parentNode = referenceNode.parentNode;
      var node = referenceNode;

      while (node) {
        node.index++;
        node = node.nextSibling;
      }

      if (newNode.hasSetProps) {
        this.ownerDocument.addNode(newNode);
      }

      this.ownerDocument.endTransaction();
      this.ownerDocument.queueUpdate();
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      if (child.parentNode !== this) {
        return;
      }

      this.ownerDocument.startTransaction();
      var node = child.nextSibling;

      while (node) {
        node.index--;
        node = node.nextSibling;
      }

      if (child.nextSibling) {
        child.nextSibling.previousSibling = child.previousSibling;
      }

      if (child.previousSibling) {
        child.previousSibling.nextSibling = child.nextSibling;
      }

      if (this.firstChild === child) {
        this.firstChild = child.nextSibling;
      }

      if (this.lastChild === child) {
        this.lastChild = child.previousSibling;
      }

      child.parentNode = null;
      child.nextSibling = null;
      child.previousSibling = null;
      child.index = 0;
      this.ownerDocument.removeNode(child);
      this.ownerDocument.endTransaction();
      this.ownerDocument.queueUpdate();
    }
  }, {
    key: "addEventListener",
    value: function addEventListener() {}
  }, {
    key: "removeEventListener",
    value: function removeEventListener() {}
  }]);
}(Symbol.iterator);

var ElementNode = /*#__PURE__*/function (_BaseNode) {
  function ElementNode(type, ownerDocument) {
    var _this2;

    _classCallCheck(this, ElementNode);

    _this2 = _callSuper(this, ElementNode, [ownerDocument]);

    __publicField(_this2, "nodeType", 8);

    __publicField(_this2, "node");

    __publicField(_this2, "_index", 0);

    __publicField(_this2, "hasSetProps", false);

    _this2.node = new NodeValue(type, "react-aria-".concat(++ownerDocument.nodeId));

    _this2.ownerDocument.startTransaction();

    return _this2;
  }

  _inherits(ElementNode, _BaseNode);

  return _createClass(ElementNode, [{
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(index) {
      this._index = index;
      this.ownerDocument.markDirty(this);
    }
  }, {
    key: "level",
    get: function get() {
      if (this.parentNode instanceof ElementNode) {
        return this.parentNode.level + (this.node.type === "item" ? 1 : 0);
      }

      return 0;
    }
  }, {
    key: "updateNode",
    value: function updateNode() {
      var _this$previousSibling, _this$previousSibling2, _this$nextSibling$nod, _this$nextSibling, _this$firstChild$node, _this$firstChild, _this$lastChild$node$, _this$lastChild;

      var node = this.ownerDocument.getMutableNode(this);
      node.index = this.index;
      node.level = this.level;
      node.parentKey = this.parentNode instanceof ElementNode ? this.parentNode.node.key : null;
      node.prevKey = (_this$previousSibling = (_this$previousSibling2 = this.previousSibling) === null || _this$previousSibling2 === void 0 ? void 0 : _this$previousSibling2.node.key) !== null && _this$previousSibling !== void 0 ? _this$previousSibling : null;
      node.nextKey = (_this$nextSibling$nod = (_this$nextSibling = this.nextSibling) === null || _this$nextSibling === void 0 ? void 0 : _this$nextSibling.node.key) !== null && _this$nextSibling$nod !== void 0 ? _this$nextSibling$nod : null;
      node.hasChildNodes = !!this.firstChild;
      node.firstChildKey = (_this$firstChild$node = (_this$firstChild = this.firstChild) === null || _this$firstChild === void 0 ? void 0 : _this$firstChild.node.key) !== null && _this$firstChild$node !== void 0 ? _this$firstChild$node : null;
      node.lastChildKey = (_this$lastChild$node$ = (_this$lastChild = this.lastChild) === null || _this$lastChild === void 0 ? void 0 : _this$lastChild.node.key) !== null && _this$lastChild$node$ !== void 0 ? _this$lastChild$node$ : null;
    }
  }, {
    key: "setProps",
    value: function setProps(obj, ref, rendered) {
      var node = this.ownerDocument.getMutableNode(this);

      var value = obj.value,
          textValue = obj.textValue,
          id = obj.id,
          props = _objectWithoutProperties(obj, _excluded15);

      props.ref = ref;
      node.props = props;
      node.rendered = rendered;
      node.value = value;
      node.textValue = textValue || (typeof rendered === "string" ? rendered : "") || obj["aria-label"] || "";

      if (id != null && id !== node.key) {
        if (this.hasSetProps) {
          throw new Error("Cannot change the id of an item");
        }

        node.key = id;
      }

      if (!this.hasSetProps) {
        this.ownerDocument.addNode(this);
        this.ownerDocument.endTransaction();
        this.hasSetProps = true;
      }

      this.ownerDocument.queueUpdate();
    }
  }, {
    key: "style",
    get: function get() {
      return {};
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute() {}
  }, {
    key: "setAttribute",
    value: function setAttribute() {}
  }, {
    key: "setAttributeNS",
    value: function setAttributeNS() {}
  }, {
    key: "removeAttribute",
    value: function removeAttribute() {}
  }]);
}(BaseNode);

var BaseCollection = /*#__PURE__*/function (_Symbol$iterator2) {
  function BaseCollection() {
    _classCallCheck(this, BaseCollection);

    __publicField(this, "keyMap", /* @__PURE__ */new Map());

    __publicField(this, "firstKey", null);

    __publicField(this, "lastKey", null);

    __publicField(this, "frozen", false);
  }

  return _createClass(BaseCollection, [{
    key: "size",
    get: function get() {
      return this.keyMap.size;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: _Symbol$iterator2,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var node;
      return _regeneratorRuntime.wrap(function value$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            node = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;

          case 1:
            if (!node) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return node;

          case 4:
            node = node.nextKey != null ? this.keyMap.get(node.nextKey) : void 0;
            _context2.next = 1;
            break;

          case 7:
          case "end":
            return _context2.stop();
        }
      }, value, this);
    })
  }, {
    key: "getChildren",
    value: function getChildren(key) {
      var keyMap = this.keyMap;
      return _defineProperty({}, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var parent, node;
        return _regeneratorRuntime.wrap(function _callee$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              parent = keyMap.get(key);
              node = (parent === null || parent === void 0 ? void 0 : parent.firstChildKey) != null ? keyMap.get(parent.firstChildKey) : null;

            case 2:
              if (!node) {
                _context3.next = 8;
                break;
              }

              _context3.next = 5;
              return node;

            case 5:
              node = node.nextKey != null ? keyMap.get(node.nextKey) : void 0;
              _context3.next = 2;
              break;

            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);

      if (!node) {
        return null;
      }

      if (node.prevKey != null) {
        var _node$key, _node;

        node = this.keyMap.get(node.prevKey);

        while (node && node.type !== "item" && node.lastChildKey != null) {
          node = this.keyMap.get(node.lastChildKey);
        }

        return (_node$key = (_node = node) === null || _node === void 0 ? void 0 : _node.key) !== null && _node$key !== void 0 ? _node$key : null;
      }

      return node.parentKey;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);

      if (!node) {
        return null;
      }

      if (node.type !== "item" && node.firstChildKey != null) {
        return node.firstChildKey;
      }

      while (node) {
        if (node.nextKey != null) {
          return node.nextKey;
        }

        if (node.parentKey != null) {
          node = this.keyMap.get(node.parentKey);
        } else {
          return null;
        }
      }

      return null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      return this.firstKey;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var _node$key2, _node3;

      var node = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;

      while (((_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.lastChildKey) != null) {
        var _node2;

        node = this.keyMap.get(node.lastChildKey);
      }

      return (_node$key2 = (_node3 = node) === null || _node3 === void 0 ? void 0 : _node3.key) !== null && _node$key2 !== void 0 ? _node$key2 : null;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var _this$keyMap$get;

      return (_this$keyMap$get = this.keyMap.get(key)) !== null && _this$keyMap$get !== void 0 ? _this$keyMap$get : null;
    }
  }, {
    key: "at",
    value: function at() {
      throw new Error("Not implemented");
    }
  }, {
    key: "clone",
    value: function clone() {
      var Constructor = this.constructor;
      var collection = new Constructor();
      collection.keyMap = new Map(this.keyMap);
      collection.firstKey = this.firstKey;
      collection.lastKey = this.lastKey;
      return collection;
    }
  }, {
    key: "addNode",
    value: function addNode(node) {
      if (this.frozen) {
        throw new Error("Cannot add a node to a frozen collection");
      }

      this.keyMap.set(node.key, node);
    }
  }, {
    key: "removeNode",
    value: function removeNode(key) {
      if (this.frozen) {
        throw new Error("Cannot remove a node to a frozen collection");
      }

      this.keyMap.delete(key);
    }
  }, {
    key: "commit",
    value: function commit(firstKey, lastKey) {
      var isSSR = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.frozen) {
        throw new Error("Cannot commit a frozen collection");
      }

      this.firstKey = firstKey;
      this.lastKey = lastKey;
      this.frozen = !isSSR;
    }
  }]);
}(Symbol.iterator);

var Document = /*#__PURE__*/function (_BaseNode2) {
  function Document(collection) {
    var _this3;

    _classCallCheck(this, Document);

    _this3 = _callSuper(this, Document, [null]);

    __publicField(_this3, "nodeType", 11); // DOCUMENT_FRAGMENT_NODE


    __publicField(_this3, "ownerDocument", _this3);

    __publicField(_this3, "dirtyNodes", /* @__PURE__ */new Set());

    __publicField(_this3, "isSSR", false);

    __publicField(_this3, "nodeId", 0);

    __publicField(_this3, "nodesByProps", /* @__PURE__ */new WeakMap());

    __publicField(_this3, "collection");

    __publicField(_this3, "collectionMutated");

    __publicField(_this3, "mutatedNodes", /* @__PURE__ */new Set());

    __publicField(_this3, "subscriptions", /* @__PURE__ */new Set());

    __publicField(_this3, "transactionCount", 0);

    _this3.collection = collection;
    _this3.collectionMutated = true;
    return _this3;
  }

  _inherits(Document, _BaseNode2);

  return _createClass(Document, [{
    key: "createElement",
    value: function createElement(type) {
      return new ElementNode(type, this);
    }
  }, {
    key: "getMutableNode",
    value: function getMutableNode(element) {
      var node = element.node;

      if (!this.mutatedNodes.has(element)) {
        node = element.node.clone();
        this.mutatedNodes.add(element);
        element.node = node;
      }

      this.markDirty(element);
      return node;
    }
  }, {
    key: "getMutableCollection",
    value: function getMutableCollection() {
      if (!this.isSSR && !this.collectionMutated) {
        this.collection = this.collection.clone();
        this.collectionMutated = true;
      }

      return this.collection;
    }
  }, {
    key: "markDirty",
    value: function markDirty(node) {
      this.dirtyNodes.add(node);
    }
  }, {
    key: "startTransaction",
    value: function startTransaction() {
      this.transactionCount++;
    }
  }, {
    key: "endTransaction",
    value: function endTransaction() {
      this.transactionCount--;
    }
  }, {
    key: "addNode",
    value: function addNode(element) {
      var collection = this.getMutableCollection();

      if (!collection.getItem(element.node.key)) {
        collection.addNode(element.node);

        var _iterator2 = _createForOfIteratorHelper(element),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var child = _step2.value;
            this.addNode(child);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      this.markDirty(element);
    }
  }, {
    key: "removeNode",
    value: function removeNode(node) {
      var _iterator3 = _createForOfIteratorHelper(node),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          child.parentNode = null;
          this.removeNode(child);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var collection = this.getMutableCollection();
      collection.removeNode(node.node.key);
      this.markDirty(node);
    }
  }, {
    key: "getCollection",
    value: function getCollection() {
      if (this.transactionCount > 0) {
        return this.collection;
      }

      this.updateCollection();
      return this.collection;
    }
  }, {
    key: "updateCollection",
    value: function updateCollection() {
      var _iterator4 = _createForOfIteratorHelper(this.dirtyNodes),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _element = _step4.value;

          if (_element instanceof ElementNode && _element.parentNode) {
            _element.updateNode();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      this.dirtyNodes.clear();

      if (this.mutatedNodes.size > 0) {
        var _this$firstChild$node2, _this$firstChild2, _this$lastChild$node$2, _this$lastChild2;

        var collection = this.getMutableCollection();

        var _iterator5 = _createForOfIteratorHelper(this.mutatedNodes),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var element = _step5.value;

            if (element.parentNode) {
              collection.addNode(element.node);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        collection.commit((_this$firstChild$node2 = (_this$firstChild2 = this.firstChild) === null || _this$firstChild2 === void 0 ? void 0 : _this$firstChild2.node.key) !== null && _this$firstChild$node2 !== void 0 ? _this$firstChild$node2 : null, (_this$lastChild$node$2 = (_this$lastChild2 = this.lastChild) === null || _this$lastChild2 === void 0 ? void 0 : _this$lastChild2.node.key) !== null && _this$lastChild$node$2 !== void 0 ? _this$lastChild$node$2 : null, this.isSSR);
        this.mutatedNodes.clear();
      }

      this.collectionMutated = false;
    }
  }, {
    key: "queueUpdate",
    value: function queueUpdate() {
      if (this.dirtyNodes.size === 0 || this.transactionCount > 0) {
        return;
      }

      var _iterator6 = _createForOfIteratorHelper(this.subscriptions),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var fn = _step6.value;
          fn();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(fn) {
      var _this4 = this;

      this.subscriptions.add(fn);
      return function () {
        return _this4.subscriptions.delete(fn);
      };
    }
  }, {
    key: "resetAfterSSR",
    value: function resetAfterSSR() {
      if (this.isSSR) {
        this.isSSR = false;
        this.firstChild = null;
        this.lastChild = null;
        this.nodeId = 0;
      }
    }
  }]);
}(BaseNode);

var useCachedChildren = function useCachedChildren(props) {
  var children = props.children,
      items = props.items,
      idScope = props.idScope,
      addIdAndValue = props.addIdAndValue;
  var cache = React.useMemo(function () {
    return /* @__PURE__ */new WeakMap();
  }, []);
  return React.useMemo(function () {
    if (items && typeof children === "function") {
      var result = [];

      var _iterator7 = _createForOfIteratorHelper(items),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var item = _step7.value;
          var rendered = cache.get(item);

          if (!rendered) {
            rendered = children(item);

            if (rendered.key === null) {
              var _ref19, _rendered$props$id;

              var key = (_ref19 = (_rendered$props$id = rendered.props.id) !== null && _rendered$props$id !== void 0 ? _rendered$props$id : item.key) !== null && _ref19 !== void 0 ? _ref19 : item.id;

              if (key === null) {
                throw new Error("Could not determine key for item");
              }

              if (idScope) {
                key = idScope + ":" + key;
              }

              rendered = React.cloneElement(rendered, addIdAndValue ? {
                key: key,
                id: key,
                value: item
              } : {
                key: key
              });
            }

            cache.set(item, rendered);
          }

          result.push(rendered);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return result;
    } else if (typeof children !== "function") {
      return children;
    } else {
      return;
    }
  }, [children, items, cache, idScope, addIdAndValue]);
};

var useCollectionChildren = function useCollectionChildren(props) {
  return useCachedChildren(_objectSpread(_objectSpread({}, props), {}, {
    addIdAndValue: true
  }));
};

var ShallowRenderContext = React.createContext(false);

var useCollection = function useCollection(props, initialCollection) {
  var _useCollectionDocumen = useCollectionDocument(initialCollection),
      collection = _useCollectionDocumen.collection,
      document = _useCollectionDocumen.document;

  var portal = useCollectionPortal(props, document);
  return {
    portal: portal,
    collection: collection
  };
};

var useCollectionDocument = function useCollectionDocument(initialCollection) {
  var document = React.useMemo(function () {
    return new Document(initialCollection || new BaseCollection());
  }, [initialCollection]);
  var subscribe = React.useCallback(function (fn) {
    return document.subscribe(fn);
  }, [document]);
  var getSnapshot = React.useCallback(function () {
    var collection2 = document.getCollection();

    if (document.isSSR) {
      document.resetAfterSSR();
    }

    return collection2;
  }, [document]);
  var getServerSnapshot = React.useCallback(function () {
    document.isSSR = true;
    return document.getCollection();
  }, [document]);
  var collection = React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return {
    collection: collection,
    document: document
  };
};

var SSRContext = React.createContext(null);
var CollectionDocumentContext = React.createContext(null);

var useCollectionPortal = function useCollectionPortal(props, document) {
  var ctx = React.useContext(CollectionDocumentContext);
  var doc = document !== null && document !== void 0 ? document : ctx;
  var children = useCollectionChildren(props);
  var wrappedChildren = React.useMemo(function () {
    return /* @__PURE__ */jsxRuntime.jsx(ShallowRenderContext.Provider, {
      value: true,
      children: children
    });
  }, [children]);
  return reactAria.useIsSSR() ? /* @__PURE__ */jsxRuntime.jsx(SSRContext.Provider, {
    value: doc,
    children: wrappedChildren
  }) : ReactDOM.createPortal(wrappedChildren, doc);
};

var CollectionPortal = function CollectionPortal(props) {
  return /* @__PURE__ */jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: useCollectionPortal(props)
  });
};

var useCollectionItemRef = function useCollectionItemRef(props, ref, rendered) {
  return React.useCallback(function (element) {
    element === null || element === void 0 || element.setProps(props, ref, rendered);
  }, [props, ref, rendered]);
};

var useSSRCollectionNode = function useSSRCollectionNode(Type, props, ref, rendered, children) {
  var itemRef = useCollectionItemRef(props, ref, rendered);
  var parentNode = React.useContext(SSRContext);

  if (parentNode) {
    var element = parentNode.ownerDocument.nodesByProps.get(props);

    if (!element) {
      element = parentNode.ownerDocument.createElement(Type);
      element.setProps(props, ref, rendered);
      parentNode.appendChild(element);
      parentNode.ownerDocument.updateCollection();
      parentNode.ownerDocument.nodesByProps.set(props, element);
    }

    return children ? /* @__PURE__ */jsxRuntime.jsx(SSRContext.Provider, {
      value: element,
      children: children
    }) : null;
  }

  return /* @__PURE__ */jsxRuntime.jsx(Type, {
    ref: itemRef,
    children: children
  });
};

var ComboBoxContentContext = React.createContext(null);
var ComboBoxContentStateContext = React.createContext(null);

var ComboBoxContent = function ComboBoxContent(props, ref) {
  var _useContextProps3 = useContextProps(props, ref, ComboBoxContentContext);

  var _useContextProps4 = _slicedToArray(_useContextProps3, 2);

  props = _useContextProps4[0];
  ref = _useContextProps4[1];
  var isHidden = React.useContext(HiddenContext);
  var state = React.useContext(ComboBoxContentStateContext);
  var document = React.useContext(CollectionDocumentContext);

  if (document) {
    return /* @__PURE__ */jsxRuntime.jsx(CollectionPortal, _objectSpread({}, props));
  }

  if (state) {
    return isHidden ? null : /* @__PURE__ */jsxRuntime.jsx(ListBoxInner, {
      state: state,
      props: props,
      listBoxRef: ref
    });
  }

  return /* @__PURE__ */jsxRuntime.jsx(StandaloneListBox, {
    props: props,
    listBoxRef: ref
  });
};

var StandaloneListBox = function StandaloneListBox(_ref20) {
  var props = _ref20.props,
      listBoxRef = _ref20.listBoxRef;

  var _useCollection = useCollection(props),
      portal = _useCollection.portal,
      collection = _useCollection.collection;

  props = _objectSpread(_objectSpread({}, props), {}, {
    collection: collection,
    children: null,
    items: null
  });
  var state = reactStately.useListState(props);
  return /* @__PURE__ */jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [portal, /* @__PURE__ */jsxRuntime.jsx(ListBoxInner, {
      state: state,
      props: props,
      listBoxRef: listBoxRef
    })]
  });
};

var _ComboBoxContent = /* @__PURE__ */React.forwardRef(ComboBoxContent);

function ListBoxInner(_ref21) {
  var state = _ref21.state,
      props = _ref21.props,
      listBoxRef = _ref21.listBoxRef;
  var _props$layout = props.layout,
      layout = _props$layout === void 0 ? "stack" : _props$layout,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? "vertical" : _props$orientation;
  var collection = state.collection,
      selectionManager = state.selectionManager;

  var _reactAria$useLocale = reactAria.useLocale(),
      direction = _reactAria$useLocale.direction;

  var disabledBehavior = selectionManager.disabledBehavior,
      disabledKeys = selectionManager.disabledKeys;
  var collator = reactAria.useCollator({
    usage: "search",
    sensitivity: "base"
  });
  var keyboardDelegate = React.useMemo(function () {
    return props.keyboardDelegate || new reactAria.ListKeyboardDelegate({
      collection: collection,
      collator: collator,
      ref: listBoxRef,
      disabledKeys: disabledBehavior === "selection" ? /* @__PURE__ */new Set() : disabledKeys,
      layout: layout,
      orientation: orientation,
      direction: direction
    });
  }, [collection, collator, listBoxRef, disabledBehavior, disabledKeys, orientation, direction, props.keyboardDelegate, layout]);

  var _reactAria$useListBox = reactAria.useListBox(_objectSpread(_objectSpread({}, props), {}, {
    shouldSelectOnPressUp: props.shouldSelectOnPressUp,
    keyboardDelegate: keyboardDelegate
  }), state, listBoxRef),
      listBoxProps = _reactAria$useListBox.listBoxProps;

  var children = useCachedChildren({
    items: collection,
    children: function children(item) {
      switch (item.type) {
        case "section":
          {
            return /* @__PURE__ */jsxRuntime.jsx(ListBoxSection, {
              section: item
            });
          }

        case "item":
          {
            return /* @__PURE__ */jsxRuntime.jsx(Option, {
              item: item
            });
          }

        default:
          {
            throw new Error("Unsupported node type in Menu: " + item.type);
          }
      }
    }
  });

  var _reactAria$useFocusRi2 = reactAria.useFocusRing(),
      focusProps = _reactAria$useFocusRi2.focusProps,
      isFocused = _reactAria$useFocusRi2.isFocused,
      isFocusVisible = _reactAria$useFocusRi2.isFocusVisible;

  var renderValues = {
    isDropTarget: false,
    isEmpty: state.collection.size === 0,
    isFocused: isFocused,
    isFocusVisible: isFocusVisible,
    layout: props.layout || "stack",
    state: state
  };
  var renderProps = useRenderProps({
    className: props.className,
    style: props.style,
    defaultClassName: "react-aria-ListBox",
    values: renderValues
  });
  var emptyState = null;

  if (state.collection.size === 0 && props.renderEmptyState) {
    emptyState = /* @__PURE__ */jsxRuntime.jsx("div", {
      role: "option",
      style: {
        display: "contents"
      },
      children: props.renderEmptyState(renderValues)
    });
  }

  return /* @__PURE__ */jsxRuntime.jsx(reactAria.FocusScope, {
    children: /* @__PURE__ */jsxRuntime.jsxs("div", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, utils.filterDOMProps(props)), reactAria.mergeProps(listBoxProps, focusProps)), renderProps), {}, {
      className: cn("z-50 max-h-64 w-[var(--trigger-width)] overflow-y-auto rounded-md bg-white p-2 shadow-md", props.className),
      ref: listBoxRef,
      slot: props.slot || void 0,
      onScroll: props.onScroll,
      "data-empty": state.collection.size === 0 || void 0,
      "data-focused": isFocused || void 0,
      "data-focus-visible": isFocusVisible || void 0,
      "data-layout": props.layout || "stack",
      "data-orientation": props.orientation || "vertical",
      children: [/* @__PURE__ */jsxRuntime.jsx(Provider, {
        values: [[ComboBoxContentContext, props], [ComboBoxContentStateContext, state]],
        children: children
      }), emptyState]
    }))
  });
}

function ListBoxSection(_ref22) {
  var _section$props$ariaL, _section$props, _section$props2;

  var section = _ref22.section,
      className = _ref22.className,
      style = _ref22.style;
  var state = React.useContext(ComboBoxContentStateContext);

  var _useSlot = useSlot(),
      _useSlot2 = _slicedToArray(_useSlot, 2),
      heading = _useSlot2[1];

  var _reactAria$useListBox2 = reactAria.useListBoxSection({
    heading: heading,
    "aria-label": (_section$props$ariaL = section.props["aria-label"]) !== null && _section$props$ariaL !== void 0 ? _section$props$ariaL : void 0
  }),
      groupProps = _reactAria$useListBox2.groupProps;

  var children = useCachedChildren({
    items: state.collection.getChildren(section.key),
    children: function children(item) {
      switch (item.type) {
        case "item":
          {
            return /* @__PURE__ */jsxRuntime.jsx(Option, {
              item: item
            });
          }

        default:
          {
            throw new Error("Unsupported element type in Section: " + item.type);
          }
      }
    }
  });
  return /* @__PURE__ */jsxRuntime.jsx("section", _objectSpread(_objectSpread(_objectSpread({}, utils.filterDOMProps(section.props)), groupProps), {}, {
    className: className || ((_section$props = section.props) === null || _section$props === void 0 ? void 0 : _section$props.className) || "react-aria-Section",
    style: style || ((_section$props2 = section.props) === null || _section$props2 === void 0 ? void 0 : _section$props2.style),
    ref: section.props.ref,
    children: children
  }));
}

var ComboBoxItem = function ComboBoxItem(props, ref) {
  return useSSRCollectionNode("item", _objectSpread(_objectSpread({}, props), {}, {
    className: function className(_ref23) {
      var isFocused = _ref23.isFocused,
          isSelected = _ref23.isSelected;
      return cn("mb-1 flex cursor-pointer items-center gap-2 rounded-sm p-1 last:mb-0 [&>svg]:text-neutral-700", {
        "bg-neutral-100 [&>svg]:text-black": isFocused,
        "bg-primary [&>svg]:text-primary-contrast text-primary-contrast": isSelected
      }, props.className);
    }
  }), ref, props.children);
};

var _ComboBoxItem = /* @__PURE__ */React.forwardRef(ComboBoxItem);

function Option(_ref24) {
  var item = _ref24.item;
  var ref = utils.useObjectRef(item.props.ref);
  var state = React.useContext(ComboBoxContentStateContext);

  var _reactAria$useOption = reactAria.useOption({
    key: item.key
  }, state, ref),
      optionProps = _reactAria$useOption.optionProps,
      labelProps = _reactAria$useOption.labelProps,
      descriptionProps = _reactAria$useOption.descriptionProps,
      states = _objectWithoutProperties(_reactAria$useOption, _excluded16);

  var _reactAria$useHover2 = reactAria.useHover({
    isDisabled: !states.allowsSelection && !states.hasAction
  }),
      hoverProps = _reactAria$useHover2.hoverProps,
      isHovered = _reactAria$useHover2.isHovered;

  var props = item.props;
  var renderProps = useRenderProps(_objectSpread(_objectSpread({}, props), {}, {
    id: void 0,
    children: item.rendered,
    defaultClassName: "react-aria-ListBoxItem",
    values: _objectSpread(_objectSpread({}, states), {}, {
      isHovered: isHovered,
      selectionMode: state.selectionManager.selectionMode,
      selectionBehavior: state.selectionManager.selectionBehavior,
      allowsDragging: false,
      isDragging: false,
      isDropTarget: false
    })
  }));
  React.useEffect(function () {
    if (!item.textValue) {
      console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
    }
  }, [item.textValue]);
  var ElementType = props.href ? "a" : "div";
  return /* @__PURE__ */jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /* @__PURE__ */jsxRuntime.jsx(ElementType, _objectSpread(_objectSpread(_objectSpread({}, reactAria.mergeProps(optionProps, hoverProps)), renderProps), {}, {
      ref: ref,
      "data-selected": states.isSelected || void 0,
      "data-disabled": states.isDisabled || void 0,
      "data-hovered": isHovered || void 0,
      "data-focused": states.isFocused || void 0,
      "data-focus-visible": states.isFocusVisible || void 0,
      "data-pressed": states.isPressed || void 0,
      "data-selection-mode": state.selectionManager.selectionMode === "none" ? void 0 : state.selectionManager.selectionMode,
      children: renderProps.children
    }))
  });
}

var _path$v;

function _extends$w() {
  _extends$w = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$w.apply(this, arguments);
}

var SvgTimes$3 = function SvgTimes(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$v || (_path$v = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M16.365 16.434 5.638 5.707M5.638 16.305 16.365 5.578"
  })));
};

var InputGroupContext = React.createContext({
  handleInputValueChange: function handleInputValueChange() {},
  handleClearButtonClick: function handleClearButtonClick() {}
});

var InputGroupProvider = function InputGroupProvider(_ref25) {
  var children = _ref25.children;

  var _React$useState9 = React.useState(""),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      inputValue = _React$useState10[0],
      setInputValue = _React$useState10[1];

  var context = React.useMemo(function () {
    return {
      inputValue: inputValue,
      handleInputValueChange: setInputValue,
      handleClearButtonClick: function handleClearButtonClick() {
        setInputValue("");
      }
    };
  }, [inputValue, setInputValue]);
  return /* @__PURE__ */jsxRuntime.jsx(InputGroupContext.Provider, {
    value: context,
    children: children
  });
};

var InputGroup = React.forwardRef(function (_ref26, ref) {
  var className = _ref26.className,
      error = _ref26.error,
      props = _objectWithoutProperties(_ref26, _excluded17);

  return /* @__PURE__ */jsxRuntime.jsx(InputGroupProvider, {
    children: /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
      ref: ref,
      className: cn("group/input-group flex items-center gap-1 rounded border border-neutral-500 bg-white px-2 [&>svg]:h-5 [&>svg]:w-5", "[&>input]:w-full [&>input]:border-none [&>input]:bg-transparent [&>input]:px-0", {
        "focus-within:border-primary": !error,
        "border-error": error
      }, className)
    }, props))
  });
});
InputGroup.displayName = "InputGroup";
var Input = React.forwardRef(function (_ref27, ref) {
  var className = _ref27.className,
      asChild = _ref27.asChild,
      error = _ref27.error,
      value = _ref27.value,
      defaultValue = _ref27.defaultValue,
      _onValueChange = _ref27.onValueChange,
      _onChange = _ref27.onChange,
      props = _objectWithoutProperties(_ref27, _excluded18);

  var _React$useContext = React.useContext(InputGroupContext),
      inputValue = _React$useContext.inputValue,
      handleInputValueChange = _React$useContext.handleInputValueChange;

  var _hooks$useControllabl = hooks.useControllableState({
    value: value !== null && value !== void 0 ? value : inputValue,
    defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : "",
    onValueChange: function onValueChange(value2) {
      handleInputValueChange(value2);
      _onValueChange === null || _onValueChange === void 0 || _onValueChange(value2);
    }
  }),
      _hooks$useControllabl2 = _slicedToArray(_hooks$useControllabl, 2),
      _value = _hooks$useControllabl2[0],
      setValue = _hooks$useControllabl2[1];

  React.useEffect(function () {
    if (value !== void 0 && value !== inputValue) {
      handleInputValueChange(value);
    }
  }, [value, inputValue, handleInputValueChange]);
  var Component = asChild ? reactSlot.Slot : "input";
  return /* @__PURE__ */jsxRuntime.jsx(Component, _objectSpread({
    ref: ref,
    value: _value,
    onChange: function onChange(event) {
      if ("value" in event.target) {
        setValue(event.target.value);
        _onChange === null || _onChange === void 0 || _onChange(event);
      }
    },
    className: cn("w-full rounded border border-neutral-500 bg-white p-2 outline-none duration-200 placeholder:text-neutral-800 disabled:opacity-30", {
      "focus-visible:border-primary": !error,
      "border-error": error
    }, className)
  }, props));
});
Input.displayName = "Input";
var InputLeftContent = React.forwardRef(function (_ref28, ref) {
  var className = _ref28.className,
      props = _objectWithoutProperties(_ref28, _excluded19);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    ref: ref,
    className: cn("[&>svg]:group-focus-within/input-group:text-primary flex items-center gap-1 [&>svg]:text-xl [&>svg]:text-neutral-500", className)
  }, props));
});
InputLeftContent.displayName = "InputLeftContent";
var InputClearButton = React.forwardRef(function (_ref29, ref) {
  var className = _ref29.className,
      _ref29$type = _ref29.type,
      type = _ref29$type === void 0 ? "button" : _ref29$type,
      children = _ref29.children,
      _onClick = _ref29.onClick,
      value = _ref29.value,
      props = _objectWithoutProperties(_ref29, _excluded20);

  var _React$useContext2 = React.useContext(InputGroupContext),
      handleClearButtonClick = _React$useContext2.handleClearButtonClick,
      inputValue = _React$useContext2.inputValue;

  return /* @__PURE__ */jsxRuntime.jsx("button", _objectSpread(_objectSpread({
    ref: ref,
    type: type,
    className: cn("hover:bg-primary-100 pointer-events-none hidden rounded-sm text-xl duration-200", {
      "group-hover/input-group:pointer-events-auto group-hover/input-group:block": inputValue || value
    }, className),
    onClick: function onClick(event) {
      handleClearButtonClick();
      _onClick === null || _onClick === void 0 || _onClick(event);
    }
  }, props), {}, {
    children: children !== null && children !== void 0 ? children : /* @__PURE__ */jsxRuntime.jsx(SvgTimes$3, {
      className: "text-xl text-black"
    })
  }));
});
InputClearButton.displayName = "InputClearButton";
var ComboBoxInputContext = React.createContext({});

var ComboBoxInput = function ComboBoxInput(_ref30, ref) {
  var _ref30$size = _ref30.size,
      size = _ref30$size === void 0 ? "lg" : _ref30$size,
      props = _objectWithoutProperties(_ref30, _excluded21);

  var _useContextProps5 = useContextProps(props, ref, ComboBoxInputContext);

  var _useContextProps6 = _slicedToArray(_useContextProps5, 2);

  props = _useContextProps6[0];
  ref = _useContextProps6[1];

  var _reactAria$useHover3 = reactAria.useHover({}),
      hoverProps = _reactAria$useHover3.hoverProps,
      isHovered = _reactAria$useHover3.isHovered;

  var _reactAria$useFocusRi3 = reactAria.useFocusRing({
    isTextInput: true,
    autoFocus: props.autoFocus
  }),
      isFocused = _reactAria$useFocusRi3.isFocused,
      isFocusVisible = _reactAria$useFocusRi3.isFocusVisible,
      focusProps = _reactAria$useFocusRi3.focusProps;

  var isInvalid = !!props["aria-invalid"] && props["aria-invalid"] !== "false";
  var renderProps = useRenderProps(_objectSpread(_objectSpread({}, props), {}, {
    values: {
      isHovered: isHovered,
      isFocused: isFocused,
      isFocusVisible: isFocusVisible,
      isDisabled: props.disabled || false,
      isInvalid: isInvalid
    },
    defaultClassName: "react-aria-Input"
  }));
  return /* @__PURE__ */jsxRuntime.jsx(Input, _objectSpread(_objectSpread(_objectSpread({}, reactAria.mergeProps(props, focusProps, hoverProps)), renderProps), {}, {
    ref: ref,
    className: cn("pl-2 pr-6 pt-2 text-left", {
      "h-14": size === "lg",
      "h-[52px]": size === "md"
    }, props.className),
    "data-focused": isFocused || void 0,
    "data-disabled": props.disabled || void 0,
    "data-hovered": isHovered || void 0,
    "data-focus-visible": isFocusVisible || void 0,
    "data-invalid": isInvalid || void 0
  }));
};

var _ComboBoxInput = /* @__PURE__ */createHideableComponent(ComboBoxInput);

var ComboBoxLabelContext = React.createContext({});

var ComboBoxLabel = function ComboBoxLabel(_ref31, ref) {
  var asChild = _ref31.asChild,
      props = _objectWithoutProperties(_ref31, _excluded22);

  var _useContextProps7 = useContextProps(props, ref, ComboBoxLabelContext);

  var _useContextProps8 = _slicedToArray(_useContextProps7, 2);

  props = _useContextProps8[0];
  ref = _useContextProps8[1];
  var Component = asChild ? reactSlot.Slot : "label";
  return /* @__PURE__ */jsxRuntime.jsx(Component, _objectSpread(_objectSpread({
    className: "react-aria-Label"
  }, props), {}, {
    ref: ref
  }));
};

var _ComboBoxLabel = /* @__PURE__ */createHideableComponent(ComboBoxLabel);

var OverlayTriggerStateContext = React.createContext(null);
var ComboBoxPopoverContext = React.createContext(null);

var ComboBoxPopover = function ComboBoxPopover(props, ref) {
  var _useContextProps9 = useContextProps(props, ref, ComboBoxPopoverContext);

  var _useContextProps10 = _slicedToArray(_useContextProps9, 2);

  props = _useContextProps10[0];
  ref = _useContextProps10[1];
  var contextState = React.useContext(OverlayTriggerStateContext);
  var localState = reactStately.useOverlayTriggerState(props);
  var state = // eslint-disable-next-line eqeqeq
  props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
  var isExiting = useExitAnimation(ref, state.isOpen);
  var isHidden = React.useContext(HiddenContext);

  if (isHidden) {
    var children = props.children;

    if (typeof children === "function") {
      children = children({
        placement: "bottom",
        isEntering: false,
        isExiting: false
      });
    }

    return /* @__PURE__ */jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: children
    });
  }

  if (state && !state.isOpen && !isExiting) {
    return null;
  }

  return /* @__PURE__ */jsxRuntime.jsx(PopoverInner, _objectSpread(_objectSpread({}, props), {}, {
    triggerRef: props.triggerRef,
    state: state,
    popoverRef: ref,
    isExiting: isExiting
  }));
};

var _ComboBoxPopover = /* @__PURE__ */React.forwardRef(ComboBoxPopover);

var PopoverInner = function PopoverInner(_ref32) {
  var _props$offset;

  var state = _ref32.state,
      isExiting = _ref32.isExiting,
      props = _objectWithoutProperties(_ref32, _excluded23);

  var _reactAria$usePopover = reactAria.usePopover(_objectSpread(_objectSpread({}, props), {}, {
    offset: (_props$offset = props.offset) !== null && _props$offset !== void 0 ? _props$offset : 8
  }), state),
      popoverProps = _reactAria$usePopover.popoverProps,
      underlayProps = _reactAria$usePopover.underlayProps,
      arrowProps = _reactAria$usePopover.arrowProps,
      placement = _reactAria$usePopover.placement;

  var ref = props.popoverRef;
  var isEntering = useEnterAnimation(ref, !!placement);
  var renderProps = useRenderProps(_objectSpread(_objectSpread({}, props), {}, {
    defaultClassName: "react-aria-Popover",
    values: {
      placement: placement,
      isEntering: isEntering,
      isExiting: isExiting
    }
  }));

  var style = _objectSpread(_objectSpread({}, renderProps.style), popoverProps.style);

  return /* @__PURE__ */jsxRuntime.jsxs(reactAria.Overlay, {
    isExiting: isExiting,
    children: [!props.isNonModal && /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread({}, underlayProps), {}, {
      style: {
        position: "fixed",
        inset: 0
      }
    })), /* @__PURE__ */jsxRuntime.jsxs("div", _objectSpread(_objectSpread(_objectSpread({}, utils.mergeProps(utils.filterDOMProps(props), popoverProps)), renderProps), {}, {
      ref: ref,
      slot: props.slot || void 0,
      style: style,
      "data-placement": placement,
      "data-entering": isEntering || void 0,
      "data-exiting": isExiting || void 0,
      children: [!props.isNonModal && /* @__PURE__ */jsxRuntime.jsx(reactAria.DismissButton, {
        onDismiss: state.close
      }), /* @__PURE__ */jsxRuntime.jsx(OverlayArrowContext.Provider, {
        value: _objectSpread(_objectSpread({}, arrowProps), {}, {
          placement: placement
        }),
        children: renderProps.children
      }), /* @__PURE__ */jsxRuntime.jsx(reactAria.DismissButton, {
        onDismiss: state.close
      })]
    }))]
  });
};

var OverlayArrowContext = React.createContext({
  placement: "bottom"
});
var ComboBoxContext = React.createContext(null);
var ComboBoxStateContext = React.createContext(null);

var ComboBox = function ComboBox(props, ref) {
  var _useContextProps11 = useContextProps(_objectSpread(_objectSpread({}, props), {}, {
    selectedKey: props.value,
    onSelectionChange: props.onValueChange,
    onInputChange: props.onInputValueChange
  }), ref, ComboBoxContext);

  var _useContextProps12 = _slicedToArray(_useContextProps11, 2);

  props = _useContextProps12[0];
  ref = _useContextProps12[1];

  var _useCollectionDocumen2 = useCollectionDocument(),
      collection = _useCollectionDocumen2.collection,
      document2 = _useCollectionDocumen2.document;

  var _props = props,
      _props$isDisabled = _props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
      _props$isInvalid = _props.isInvalid,
      isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
      _props$isRequired = _props.isRequired,
      isRequired = _props$isRequired === void 0 ? false : _props$isRequired,
      items = _props.items,
      defaultItems = _props.defaultItems;
  var _props2 = props,
      children = _props2.children;
  children = React.useMemo(function () {
    return typeof children === "function" ? children({
      isOpen: false,
      isDisabled: isDisabled,
      isInvalid: isInvalid,
      isRequired: isRequired
    }) : children;
  }, [children, isDisabled, isInvalid, isRequired]);
  return /* @__PURE__ */jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/* @__PURE__ */jsxRuntime.jsx(Hidden, {
      children: /* @__PURE__ */jsxRuntime.jsx(Provider, {
        values: [[CollectionDocumentContext, document2], [ComboBoxContentContext, {
          items: items !== null && items !== void 0 ? items : defaultItems
        }]],
        children: children
      })
    }), /* @__PURE__ */jsxRuntime.jsx(ComboBoxInner, {
      props: props,
      collection: collection,
      comboBoxRef: ref
    })]
  });
};

var ComboBoxInner = function ComboBoxInner(_ref33) {
  var props = _ref33.props,
      collection = _ref33.collection,
      ref = _ref33.comboBoxRef;
  var name = props.name,
      allowsCustomValue = props.allowsCustomValue,
      defaultFilter = props.defaultFilter,
      items = props.items,
      isDisabled = props.isDisabled,
      isInvalid = props.isInvalid,
      isRequired = props.isRequired,
      slot = props.slot,
      buttonRef = props.buttonRef;
  var _props$formValue = props.formValue,
      formValue = _props$formValue === void 0 ? "key" : _props$formValue;

  if (allowsCustomValue) {
    formValue = "text";
  }

  var _reactAria$useFilter = reactAria.useFilter({
    sensitivity: "base"
  }),
      contains = _reactAria$useFilter.contains;

  var state = reactStately.useComboBoxState(_objectSpread(_objectSpread({
    defaultFilter: defaultFilter || contains
  }, props), {}, {
    items: items,
    children: void 0,
    collection: collection,
    // HACK: This is a temporary solution to allow async items: https://github.com/adobe/react-spectrum/issues/3392#issuecomment-1726752664
    allowsEmptyCollection: true
  }));
  var renderPropsState = React.useMemo(function () {
    return {
      isOpen: state.isOpen,
      isDisabled: isDisabled || false,
      isInvalid: isInvalid || false,
      isRequired: isRequired || false
    };
  }, [state.isOpen, isDisabled, isInvalid, isRequired]);
  var inputRef = React.useRef(null);
  var listBoxRef = React.useRef(null);
  var popoverRef = React.useRef(null);

  var _useSlot3 = useSlot(),
      _useSlot4 = _slicedToArray(_useSlot3, 2),
      labelRef = _useSlot4[0],
      label = _useSlot4[1];

  var _reactAria$useComboBo = reactAria.useComboBox(_objectSpread(_objectSpread({}, removeDataAttributes(props)), {}, {
    label: label,
    inputRef: inputRef,
    buttonRef: buttonRef,
    listBoxRef: listBoxRef,
    popoverRef: popoverRef,
    name: formValue === "text" ? name : void 0
  }), state),
      buttonProps = _reactAria$useComboBo.buttonProps,
      inputProps = _reactAria$useComboBo.inputProps,
      listBoxProps = _reactAria$useComboBo.listBoxProps,
      labelProps = _reactAria$useComboBo.labelProps;

  var onResize = React.useCallback(function () {
    if (inputRef.current) {
      var _buttonRef$current;

      var buttonRect = buttonRef === null || buttonRef === void 0 || (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.getBoundingClientRect();
      var inputRect = inputRef.current.getBoundingClientRect();
      var minX = buttonRect ? Math.min(buttonRect.left, inputRect.left) : inputRect.left;
      var maxX = buttonRect ? Math.max(buttonRect.right, inputRect.right) : inputRect.right;
      document.documentElement.style.setProperty("--trigger-width", "".concat(maxX - minX, "px"));
    }
  }, [buttonRef, inputRef]);
  utils.useResizeObserver({
    ref: inputRef,
    onResize: onResize
  });
  var renderProps = useRenderProps(_objectSpread(_objectSpread({}, props), {}, {
    values: renderPropsState,
    defaultClassName: "react-aria-ComboBox"
  }));
  var DOMProps = utils.filterDOMProps(props);
  delete DOMProps.id;
  return /* @__PURE__ */jsxRuntime.jsxs(Provider, {
    values: [[ComboBoxStateContext, state], [ComboBoxLabelContext, _objectSpread(_objectSpread({}, labelProps), {}, {
      ref: labelRef
    })], [ButtonContext, _objectSpread(_objectSpread({}, buttonProps), {}, {
      ref: buttonRef,
      isPressed: state.isOpen
    })], [ComboBoxInputContext, _objectSpread(_objectSpread({}, inputProps), {}, {
      size: "lg",
      value: inputProps.value,
      defaultValue: inputProps.defaultValue,
      ref: inputRef
    })], [OverlayTriggerStateContext, state], [ComboBoxPopoverContext, {
      ref: popoverRef,
      triggerRef: inputRef,
      placement: "bottom start",
      isNonModal: true
    }], [ComboBoxContentContext, _objectSpread(_objectSpread({}, listBoxProps), {}, {
      ref: listBoxRef
    })], [ComboBoxContentStateContext, state]],
    children: [/* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread(_objectSpread({}, DOMProps), renderProps), {}, {
      ref: ref,
      slot: slot || void 0,
      "data-focused": state.isFocused || void 0,
      "data-open": state.isOpen || void 0,
      "data-disabled": props.isDisabled || void 0,
      "data-invalid": props.isInvalid || void 0,
      "data-required": props.isRequired || void 0
    })), name && formValue === "key" && /* @__PURE__ */jsxRuntime.jsx("input", {
      type: "hidden",
      name: name,
      value: state.selectedKey
    })]
  });
};

var _ComboBox = /* @__PURE__ */React.forwardRef(ComboBox);

var Command = React.forwardRef(function (_ref34, ref) {
  var className = _ref34.className,
      props = _objectWithoutProperties(_ref34, _excluded24);

  return /* @__PURE__ */jsxRuntime.jsx(cmdk.Command, _objectSpread({
    ref: ref,
    shouldFilter: false,
    className: cn("flex flex-col", className)
  }, props));
});
Command.displayName = cmdk.Command.displayName;
var CommandInput = React.forwardRef(function (_ref35, ref) {
  var className = _ref35.className,
      props = _objectWithoutProperties(_ref35, _excluded25);

  return /* @__PURE__ */jsxRuntime.jsx(cmdk.Command.Input, _objectSpread({
    ref: ref,
    className: "w-full rounded border border-neutral-500 bg-white p-2 outline-none duration-200 placeholder:text-neutral-800"
  }, props));
});
CommandInput.displayName = cmdk.Command.Input.displayName;
var CommandContent = React.forwardRef(function (_ref36, ref) {
  var className = _ref36.className,
      props = _objectWithoutProperties(_ref36, _excluded26);

  return /* @__PURE__ */jsxRuntime.jsx(cmdk.Command.List, _objectSpread({
    ref: ref,
    className: cn("mt-2 max-h-72 overflow-y-auto overflow-x-hidden rounded bg-white p-2", className)
  }, props));
});
CommandContent.displayName = cmdk.Command.List.displayName;
var CommandEmpty = React.forwardRef(function (_ref37, ref) {
  var _ref37$children = _ref37.children,
      children = _ref37$children === void 0 ? "No results found." : _ref37$children,
      className = _ref37.className,
      props = _objectWithoutProperties(_ref37, _excluded27);

  return /* @__PURE__ */jsxRuntime.jsx(cmdk.Command.Empty, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("py-6 text-center", className)
  }, props), {}, {
    children: children
  }));
});
CommandEmpty.displayName = cmdk.Command.Empty.displayName;
var CommandItem = React.forwardRef(function (_ref38, ref) {
  var className = _ref38.className,
      children = _ref38.children,
      props = _objectWithoutProperties(_ref38, _excluded28);

  return /* @__PURE__ */jsxRuntime.jsx(cmdk.Command.Item, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("aria-selected:bg-primary-100 flex cursor-default select-none items-center rounded-sm px-1 py-3 outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className)
  }, props), {}, {
    children: children
  }));
});
CommandItem.displayName = cmdk.Command.Item.displayName;
var Overlay = React.forwardRef(function (_ref39, ref) {
  var className = _ref39.className,
      props = _objectWithoutProperties(_ref39, _excluded29);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread({
    "data-ui-overlay": true,
    className: cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-neutral-900/80", className)
  }, props), {}, {
    ref: ref
  }));
});
Overlay.displayName = "Overlay";
var Sheet = DialogPrimitive__namespace.Root;
var SheetTrigger = DialogPrimitive__namespace.Trigger;
var SheetClose = DialogPrimitive__namespace.Close;

var SheetPortal = function SheetPortal(props) {
  return /* @__PURE__ */jsxRuntime.jsx(DialogPrimitive__namespace.Portal, _objectSpread({}, props));
};

SheetPortal.displayName = DialogPrimitive__namespace.Portal.displayName;
var SheetOverlay = React.forwardRef(function (_ref40, ref) {
  var _ = _ref40.asChild,
      props = _objectWithoutProperties(_ref40, _excluded30);

  return /* @__PURE__ */jsxRuntime.jsx(DialogPrimitive__namespace.Overlay, _objectSpread(_objectSpread({
    asChild: true
  }, props), {}, {
    ref: ref,
    children: /* @__PURE__ */jsxRuntime.jsx(Overlay, {})
  }));
});
SheetOverlay.displayName = DialogPrimitive__namespace.Overlay.displayName;
var SHEET_CONTENT_SIDE = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
};
var sheetContentStyles = classVarianceAuthority.cva("", {
  variants: {
    side: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SHEET_CONTENT_SIDE.TOP, "inset-x-0 top-0 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top"), SHEET_CONTENT_SIDE.BOTTOM, "inset-x-0 bottom-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom"), SHEET_CONTENT_SIDE.LEFT, "inset-y-0 left-0 h-full w-3/4 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm"), SHEET_CONTENT_SIDE.RIGHT, "inset-y-0 right-0 h-full w-3/4 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm")
  }
});
var SheetContent = React.forwardRef(function (_ref41, ref) {
  var _ref41$side = _ref41.side,
      side = _ref41$side === void 0 ? SHEET_CONTENT_SIDE.RIGHT : _ref41$side,
      className = _ref41.className,
      children = _ref41.children,
      props = _objectWithoutProperties(_ref41, _excluded31);

  return /* @__PURE__ */jsxRuntime.jsxs(SheetPortal, {
    children: [/* @__PURE__ */jsxRuntime.jsx(SheetOverlay, {}), /* @__PURE__ */jsxRuntime.jsx(DialogPrimitive__namespace.Content, _objectSpread(_objectSpread({
      "data-ui-dialog-content": true,
      ref: ref,
      className: cn("data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 bg-white p-2 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500", sheetContentStyles({
        side: side
      }), className)
    }, props), {}, {
      children: children
    }))]
  });
});
SheetContent.displayName = DialogPrimitive__namespace.Content.displayName;

var _path$u;

function _extends$v() {
  _extends$v = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$v.apply(this, arguments);
}

var SvgX = function SvgX(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$u || (_path$u = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M16.365 16.434 5.638 5.707M5.638 16.305 16.365 5.578"
  })));
};

var CommandSheetContext = React.createContext({
  value: "",
  handleSelect: function handleSelect() {},
  handleTrigger: function handleTrigger() {}
});

var CommandSheet = function CommandSheet(_ref42) {
  var label = _ref42.label,
      value = _ref42.value,
      defaultValue = _ref42.defaultValue,
      open = _ref42.open,
      defaultOpen = _ref42.defaultOpen,
      onOpenChange = _ref42.onOpenChange,
      onValueChange = _ref42.onValueChange,
      props = _objectWithoutProperties(_ref42, _excluded32);

  var _hooks$useControllabl3 = hooks.useControllableState({
    value: value,
    defaultValue: defaultValue,
    onValueChange: onValueChange
  }),
      _hooks$useControllabl4 = _slicedToArray(_hooks$useControllabl3, 2),
      _value = _hooks$useControllabl4[0],
      setValue = _hooks$useControllabl4[1];

  var _hooks$useControllabl5 = hooks.useControllableState({
    value: open,
    defaultValue: defaultOpen,
    onValueChange: onOpenChange
  }),
      _hooks$useControllabl6 = _slicedToArray(_hooks$useControllabl5, 2),
      _open = _hooks$useControllabl6[0],
      setOpen = _hooks$useControllabl6[1];

  return /* @__PURE__ */jsxRuntime.jsx(CommandSheetContext.Provider, {
    value: {
      label: label,
      value: _value,
      handleSelect: function handleSelect(value2) {
        setValue(value2);
        setOpen(false);
      },
      handleTrigger: function handleTrigger() {
        return setOpen(!_open);
      }
    },
    children: /* @__PURE__ */jsxRuntime.jsx(Sheet, _objectSpread({
      open: _open,
      onOpenChange: setOpen
    }, props))
  });
};

CommandSheet.displayName = Sheet.displayName;
var CommandSheetTrigger = React.forwardRef(function (_ref43, ref) {
  var _ref43$onClick = _ref43.onClick,
      _onClick2 = _ref43$onClick === void 0 ? function () {} : _ref43$onClick,
      props = _objectWithoutProperties(_ref43, _excluded33);

  var _React$useContext3 = React.useContext(CommandSheetContext),
      handleTrigger = _React$useContext3.handleTrigger;

  return /* @__PURE__ */jsxRuntime.jsx(SheetTrigger, _objectSpread({
    ref: ref,
    onClick: function onClick(event) {
      handleTrigger();

      _onClick2(event);
    }
  }, props));
});
CommandSheetTrigger.displayName = SheetTrigger.displayName;
var CommandSheetList = React.forwardRef(function (_ref44, ref) {
  var className = _ref44.className,
      props = _objectWithoutProperties(_ref44, _excluded34);

  return /* @__PURE__ */jsxRuntime.jsx(CommandContent, _objectSpread({
    ref: ref,
    className: cn("max-h-fit flex-1 bg-white", className)
  }, props));
});
CommandSheetList.displayName = CommandContent.displayName;
var CommandSheetContent = React.forwardRef(function (_ref45, ref) {
  var children = _ref45.children,
      className = _ref45.className,
      _ref45$side = _ref45.side,
      side = _ref45$side === void 0 ? SHEET_CONTENT_SIDE.BOTTOM : _ref45$side,
      shouldFilter = _ref45.shouldFilter,
      props = _objectWithoutProperties(_ref45, _excluded35);

  var _React$useContext4 = React.useContext(CommandSheetContext),
      label = _React$useContext4.label;

  return /* @__PURE__ */jsxRuntime.jsxs(SheetContent, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("flex flex-col-reverse justify-end overflow-y-hidden bg-neutral-100", // NOTE: it is reversed because browser automatically focus on the first element, and we want it to focus on the input
    {
      "h-5/6 rounded-b-lg ": side === SHEET_CONTENT_SIDE.TOP,
      "rounded-r-lg": side === SHEET_CONTENT_SIDE.LEFT,
      "h-5/6 rounded-t-lg ": side === SHEET_CONTENT_SIDE.BOTTOM,
      "rounded-l-lg": side === SHEET_CONTENT_SIDE.RIGHT
    }, className),
    side: side
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntime.jsx(Command, {
      shouldFilter: shouldFilter,
      className: "flex-1 overflow-y-hidden",
      label: label,
      children: children
    }), /* @__PURE__ */jsxRuntime.jsxs("div", {
      className: "mb-2 flex justify-between",
      children: [/* @__PURE__ */jsxRuntime.jsx("div", {
        className: "p-2 text-lg font-bold",
        children: label
      }), /* @__PURE__ */jsxRuntime.jsx(SheetClose, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(Button, {
          variant: BUTTON_VARIANT.GHOST,
          children: /* @__PURE__ */jsxRuntime.jsx(SvgX, {
            height: 24,
            width: 24
          })
        })
      })]
    })]
  }));
});
CommandSheetContent.displayName = SheetContent.displayName;
var CommandSheetItem = React.forwardRef(function (_ref46, ref) {
  var children = _ref46.children,
      value = _ref46.value,
      _ = _ref46.onSelect,
      props = _objectWithoutProperties(_ref46, _excluded36);

  var _React$useContext5 = React.useContext(CommandSheetContext),
      selectedValue = _React$useContext5.value,
      handleSelect = _React$useContext5.handleSelect;

  return /* @__PURE__ */jsxRuntime.jsx(CommandItem, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("flex gap-1", {
      "text-primary": (value === null || value === void 0 ? void 0 : value.toLowerCase().trim()) === selectedValue
    }),
    onSelect: handleSelect
  }, props), {}, {
    children: children
  }));
});
CommandSheetItem.displayName = CommandItem.displayName;

var _path$t;

function _extends$u() {
  _extends$u = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$u.apply(this, arguments);
}

var SvgArrow$4 = function SvgArrow(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$u({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.05 9 11 13.95 15.95 9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var FloatingInputGroupContext = React.createContext({
  hasLeftContent: false,
  handleLeftContentRendered: function handleLeftContentRendered() {}
});
var FloatingInputGroup = React.forwardRef(function (_ref47, ref) {
  var className = _ref47.className,
      error = _ref47.error,
      focused = _ref47.focused,
      value = _ref47.value,
      success = _ref47.success,
      props = _objectWithoutProperties(_ref47, _excluded37);

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      leftContentRendered = _React$useState12[0],
      setLeftContentRendered = _React$useState12[1];

  var handleLeftContentRendered = React.useCallback(function () {
    setLeftContentRendered(true);
  }, []);
  var context = React.useMemo(function () {
    return {
      focused: focused,
      hasLeftContent: leftContentRendered,
      handleLeftContentRendered: handleLeftContentRendered,
      value: value
    };
  }, [focused, handleLeftContentRendered, leftContentRendered, value]);
  return /* @__PURE__ */jsxRuntime.jsx(FloatingInputGroupContext.Provider, {
    value: context,
    children: /* @__PURE__ */jsxRuntime.jsx(InputGroupProvider, {
      children: /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
        ref: ref,
        className: cn("group/input-group relative flex cursor-pointer items-center gap-1 rounded border border-neutral-500 bg-white px-2 transition-colors duration-200", {
          "focus-within:border-primary": !error,
          "border-error": error,
          "border-primary": focused && !error,
          "border-success": success
        }, className),
        "data-focused": focused
      }, props))
    })
  });
});
FloatingInputGroup.displayName = "FloatingInputGroup";
var FloatingLabel = React.forwardRef(function (_ref48, ref) {
  var className = _ref48.className,
      props = _objectWithoutProperties(_ref48, _excluded38);

  var _React$useContext6 = React.useContext(FloatingInputGroupContext),
      hasLeftContent = _React$useContext6.hasLeftContent,
      focused = _React$useContext6.focused,
      value = _React$useContext6.value;

  var _React$useContext7 = React.useContext(InputGroupContext),
      inputValue = _React$useContext7.inputValue;

  return (// eslint-disable-next-line jsx-a11y/label-has-associated-control

    /* @__PURE__ */
    jsxRuntime.jsx("label", _objectSpread({
      ref: ref,
      className: cn("absolute origin-top-left cursor-text text-neutral-800 transition-transform duration-200", "group-focus-within/input-group:-translate-y-3 group-focus-within/input-group:translate-x-0 group-focus-within/input-group:scale-75", {
        "translate-x-6": hasLeftContent && !(inputValue || focused || value),
        "-translate-y-3 translate-x-0 scale-75": inputValue || focused || value
      }, className)
    }, props))
  );
});
FloatingLabel.displayName = "FloatingLabel";
var FloatingInputLeftContent = React.forwardRef(function (_ref49, ref) {
  var className = _ref49.className,
      props = _objectWithoutProperties(_ref49, _excluded39);

  var _React$useContext8 = React.useContext(FloatingInputGroupContext),
      handleLeftContentRendered = _React$useContext8.handleLeftContentRendered,
      focused = _React$useContext8.focused,
      value = _React$useContext8.value;

  var _React$useContext9 = React.useContext(InputGroupContext),
      inputValue = _React$useContext9.inputValue;

  React.useLayoutEffect(function () {
    handleLeftContentRendered();
  }, [handleLeftContentRendered]);
  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    ref: ref,
    className: cn("group-focus-within/input-group:text-primary flex items-center gap-1 text-xl text-neutral-500 duration-200 group-focus-within/input-group:translate-y-1.5", {
      "text-primary translate-y-1.5": focused || inputValue || value
    }, className)
  }, props));
});
FloatingInputLeftContent.displayName = "FloatingInputLeftContent";
var FloatingInput = React.forwardRef(function (_ref50, ref) {
  var className = _ref50.className,
      _ref50$size = _ref50.size,
      size = _ref50$size === void 0 ? "lg" : _ref50$size,
      props = _objectWithoutProperties(_ref50, _excluded40);

  return /* @__PURE__ */jsxRuntime.jsx(Input, _objectSpread({
    className: cn("w-full border-none bg-transparent pl-0 placeholder:opacity-0 focus-within:placeholder:opacity-100", {
      "pt-6": size === "lg",
      "pt-5": size === "md"
    }, className),
    ref: ref
  }, props));
});
FloatingInput.displayName = Input.displayName;
var FloatingInputRightContent = React.forwardRef(function (_ref51, ref) {
  var className = _ref51.className,
      props = _objectWithoutProperties(_ref51, _excluded41);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    ref: ref,
    className: cn("flex items-center gap-1 text-xl text-black", className)
  }, props));
});
FloatingInputRightContent.displayName = "FloatingInputRightContent";

var FloatingInputArrow = function FloatingInputArrow(_ref52) {
  var className = _ref52.className,
      props = _objectWithoutProperties(_ref52, _excluded42);

  var _React$useContext10 = React.useContext(FloatingInputGroupContext),
      focused = _React$useContext10.focused;

  return /* @__PURE__ */jsxRuntime.jsx(SvgArrow$4, _objectSpread(_objectSpread({}, props), {}, {
    className: cn("", {
      "rotate-180": focused
    }, className)
  }));
};

var FloatingInputClearButton = function FloatingInputClearButton(props) {
  var _React$useContext11 = React.useContext(FloatingInputGroupContext),
      value = _React$useContext11.value;

  return /* @__PURE__ */jsxRuntime.jsx(InputClearButton, _objectSpread(_objectSpread({}, props), {}, {
    value: value,
    tabIndex: props.tabIndex || -1
  }));
};

var ResponsiveAutocomplete = function ResponsiveAutocomplete(_ref53) {
  var _items$find$label, _items$find2;

  var id = _ref53.id,
      inputValue = _ref53.inputValue,
      label = _ref53.label,
      items = _ref53.items,
      loading = _ref53.loading,
      icon = _ref53.icon,
      name = _ref53.name,
      error = _ref53.error,
      onValueChange = _ref53.onValueChange,
      onInputValueChange = _ref53.onInputValueChange,
      onBlur = _ref53.onBlur,
      _ref53$showMobileIcon = _ref53.showMobileIcon,
      showMobileIcon = _ref53$showMobileIcon === void 0 ? true : _ref53$showMobileIcon,
      _ref53$defaultValue = _ref53.defaultValue,
      defaultValue = _ref53$defaultValue === void 0 ? "" : _ref53$defaultValue,
      _ref53$shouldFilter = _ref53.shouldFilter,
      shouldFilter = _ref53$shouldFilter === void 0 ? true : _ref53$shouldFilter,
      inputRef = _ref53.inputRef,
      _ref53$size = _ref53.size,
      size = _ref53$size === void 0 ? "lg" : _ref53$size,
      _ref53$fullScreen = _ref53.fullScreen,
      fullScreen = _ref53$fullScreen === void 0 ? false : _ref53$fullScreen;

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      mobileOpen = _React$useState14[0],
      setMobileOpen = _React$useState14[1];

  var _React$useState15 = React.useState(defaultValue),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      value = _React$useState16[0],
      setValue = _React$useState16[1];

  var _React$useState17 = React.useState(defaultValue),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      _inputValue = _React$useState18[0],
      setInputValue = _React$useState18[1];

  var _React$useState19 = React.useState(inputValue),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      previousInputValue = _React$useState20[0],
      setPreviousInputValue = _React$useState20[1];

  if (inputValue !== previousInputValue) {
    setPreviousInputValue(inputValue);
    setInputValue(inputValue !== null && inputValue !== void 0 ? inputValue : "");
  }

  var _items = shouldFilter ? items.filter(function (item) {
    return item.label.toLowerCase().includes(_inputValue.toLowerCase().trim());
  }) : items;

  var handleValueChange = function handleValueChange(value2) {
    var _items$find;

    var inputValue2 = (_items$find = items.find(function (item) {
      return item.value === value2;
    })) === null || _items$find === void 0 ? void 0 : _items$find.label;
    inputValue2 && setInputValue(inputValue2);
    setValue(value2);
    onValueChange === null || onValueChange === void 0 || onValueChange(value2);
  };

  var handleInputValueChange = function handleInputValueChange(value2) {
    if (value2 === "") {
      setValue("");
      onValueChange === null || onValueChange === void 0 || onValueChange("");
    }

    setInputValue(value2);
    onInputValueChange === null || onInputValueChange === void 0 || onInputValueChange(value2);
  };

  var handleClearValue = function handleClearValue() {
    setInputValue("");
    onInputValueChange === null || onInputValueChange === void 0 || onInputValueChange("");
    onValueChange === null || onValueChange === void 0 || onValueChange("");
    setValue("");
  };

  return reactDeviceDetect.isMobile ? /* @__PURE__ */jsxRuntime.jsxs(CommandSheet, {
    label: label,
    open: mobileOpen,
    value: value,
    onOpenChange: setMobileOpen,
    onValueChange: handleValueChange,
    children: [/* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
      focused: mobileOpen,
      error: error,
      children: [icon && /* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
        children: icon
      }), /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
        htmlFor: id,
        className: "pointer-events-none",
        children: label
      }), /* @__PURE__ */jsxRuntime.jsx(CommandSheetTrigger, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(FloatingInput, {
          ref: inputRef,
          id: id,
          value: value,
          size: size,
          asChild: true,
          children: /* @__PURE__ */jsxRuntime.jsx("button", {
            type: "button",
            className: cn("truncate text-left", {
              "h-14": size === "lg",
              "h-[52px]": size === "md"
            }),
            children: (_items$find$label = (_items$find2 = items.find(function (item) {
              return item.value.toLowerCase() === value.toLowerCase();
            })) === null || _items$find2 === void 0 ? void 0 : _items$find2.label) !== null && _items$find$label !== void 0 ? _items$find$label : ""
          })
        })
      }), /* @__PURE__ */jsxRuntime.jsx("input", {
        type: "hidden",
        name: name,
        value: value
      })]
    }), /* @__PURE__ */jsxRuntime.jsxs(CommandSheetContent, {
      shouldFilter: shouldFilter,
      className: cn(fullScreen && "h-full"),
      children: [/* @__PURE__ */jsxRuntime.jsxs(InputGroup, {
        children: [showMobileIcon && /* @__PURE__ */jsxRuntime.jsx(InputLeftContent, {
          children: icon
        }), /* @__PURE__ */jsxRuntime.jsx(CommandInput, {
          value: _inputValue,
          onValueChange: handleInputValueChange
        }), loading && /* @__PURE__ */jsxRuntime.jsx(Loading, {})]
      }), /* @__PURE__ */jsxRuntime.jsxs(CommandSheetList, {
        children: [items.length === 0 && /* @__PURE__ */jsxRuntime.jsx(CommandEmpty, {
          className: loading ? "invisible" : "visible",
          children: "No results found."
        }), items.map(function (item) {
          return /* @__PURE__ */jsxRuntime.jsxs(CommandSheetItem, {
            className: "flex gap-2",
            value: item.value,
            children: [item.icon && /* @__PURE__ */jsxRuntime.jsx("span", {
              className: "text-xl",
              children: item.icon
            }), item.label]
          }, item.value);
        })]
      })]
    })]
  }) : /* @__PURE__ */jsxRuntime.jsx(FloatingComboBox$1, {
    label: label,
    items: _items,
    value: value,
    inputValue: _inputValue,
    name: name,
    loading: loading,
    icon: icon,
    error: error,
    onValueChange: handleValueChange,
    onInputValueChange: handleInputValueChange,
    onBlur: onBlur,
    onClear: handleClearValue,
    size: size,
    children: function children(item) {
      return /* @__PURE__ */jsxRuntime.jsxs(_ComboBoxItem, {
        id: item.value,
        textValue: item.label,
        children: [/* @__PURE__ */jsxRuntime.jsx("span", {
          className: "shrink-0 text-xl",
          children: item.icon
        }), item.label]
      });
    }
  });
};

var FloatingComboBox$1 = function FloatingComboBox$1(_ref54) {
  var label = _ref54.label,
      description = _ref54.description,
      errorMessage = _ref54.errorMessage,
      children = _ref54.children,
      name = _ref54.name,
      loading = _ref54.loading,
      icon = _ref54.icon,
      onClear = _ref54.onClear,
      error = _ref54.error,
      size = _ref54.size,
      props = _objectWithoutProperties(_ref54, _excluded43);

  var _useTranslation = useTranslation("ui:responsive-combo-box"),
      t = _useTranslation.t;

  return /* @__PURE__ */jsxRuntime.jsxs(_ComboBox, _objectSpread(_objectSpread({}, props), {}, {
    children: [/* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
      error: error,
      className: "relative w-full px-2",
      children: [icon && /* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
        className: "absolute left-2 shrink-0",
        children: icon
      }), /* @__PURE__ */jsxRuntime.jsx(_ComboBoxLabel, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
          children: label
        })
      }), /* @__PURE__ */jsxRuntime.jsx(_ComboBoxInput, {
        className: cn("pl-0 pt-5", {
          "pl-7": !!icon
        }),
        size: size,
        name: name,
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(FloatingInput, {})
      }), /* @__PURE__ */jsxRuntime.jsx(_ComboBoxButton, {}), /* @__PURE__ */jsxRuntime.jsxs(FloatingInputRightContent, {
        className: "absolute right-0 pr-2",
        children: [loading && /* @__PURE__ */jsxRuntime.jsx(Loading, {}), /* @__PURE__ */jsxRuntime.jsx(FloatingInputClearButton, {
          onClick: onClear
        })]
      })]
    }), /* @__PURE__ */jsxRuntime.jsx(_ComboBoxPopover, {
      className: loading || !props.inputValue ? "hidden" : "",
      children: /* @__PURE__ */jsxRuntime.jsx(_ComboBoxContent, {
        className: "pointer-events-auto",
        renderEmptyState: function renderEmptyState() {
          return /* @__PURE__ */jsxRuntime.jsx("p", {
            className: "px-4 py-2 text-gray-700",
            children: t("No results found.")
          });
        },
        children: children
      })
    })]
  }));
};

var useCountries = function useCountries() {
  var _reactI18next$useTran = reactI18next.useTranslation("ui:country-input"),
      t = _reactI18next$useTran.t;

  return [{
    name: t("Afghanistan"),
    callingCode: "+93",
    code: "af"
  }, {
    name: t("Albania"),
    callingCode: "+355",
    code: "al"
  }, {
    name: t("Algeria"),
    callingCode: "+213",
    code: "dz"
  }, {
    name: t("AmericanSamoa"),
    callingCode: "+1 684",
    code: "as"
  }, {
    name: t("Andorra"),
    callingCode: "+376",
    code: "ad"
  }, {
    name: t("Angola"),
    callingCode: "+244",
    code: "ao"
  }, {
    name: t("Anguilla"),
    callingCode: "+1 264",
    code: "ai"
  }, {
    name: t("Antigua and Barbuda"),
    callingCode: "+1268",
    code: "ag"
  }, {
    name: t("Argentina"),
    callingCode: "+54",
    code: "ar"
  }, {
    name: t("Armenia"),
    callingCode: "+374",
    code: "am"
  }, {
    name: t("Aruba"),
    callingCode: "+297",
    code: "aw"
  }, {
    name: t("Australia"),
    callingCode: "+61",
    code: "au"
  }, {
    name: t("Austria"),
    callingCode: "+43",
    code: "at"
  }, {
    name: t("Azerbaijan"),
    callingCode: "+994",
    code: "az"
  }, {
    name: t("Bahamas"),
    callingCode: "+1 242",
    code: "bs"
  }, {
    name: t("Bahrain"),
    callingCode: "+973",
    code: "bh"
  }, {
    name: t("Bangladesh"),
    callingCode: "+880",
    code: "bd"
  }, {
    name: t("Barbados"),
    callingCode: "+1 246",
    code: "bb"
  }, {
    name: t("Belarus"),
    callingCode: "+375",
    code: "by"
  }, {
    name: t("Belgium"),
    callingCode: "+32",
    code: "be"
  }, {
    name: t("Belize"),
    callingCode: "+501",
    code: "bz"
  }, {
    name: t("Benin"),
    callingCode: "+229",
    code: "bj"
  }, {
    name: t("Bermuda"),
    callingCode: "+1 441",
    code: "bm"
  }, {
    name: t("Bhutan"),
    callingCode: "+975",
    code: "bt"
  }, {
    name: t("Bosnia and Herzegovina"),
    callingCode: "+387",
    code: "ba"
  }, {
    name: t("Botswana"),
    callingCode: "+267",
    code: "bw"
  }, {
    name: t("Brazil"),
    callingCode: "+55",
    code: "br"
  }, {
    name: t("British Indian Ocean Territory"),
    callingCode: "+246",
    code: "io"
  }, {
    name: t("Bulgaria"),
    callingCode: "+359",
    code: "bg"
  }, {
    name: t("Burkina Faso"),
    callingCode: "+226",
    code: "bf"
  }, {
    name: t("Burundi"),
    callingCode: "+257",
    code: "bi"
  }, {
    name: t("Cambodia"),
    callingCode: "+855",
    code: "kh"
  }, {
    name: t("Cameroon"),
    callingCode: "+237",
    code: "cm"
  }, {
    name: t("Canada"),
    callingCode: "+1",
    code: "ca"
  }, {
    name: t("Cape Verde"),
    callingCode: "+238",
    code: "cv"
  }, {
    name: t("Cayman Islands"),
    callingCode: "+ 345",
    code: "ky"
  }, {
    name: t("Central African Republic"),
    callingCode: "+236",
    code: "cf"
  }, {
    name: t("Chad"),
    callingCode: "+235",
    code: "td"
  }, {
    name: t("Chile"),
    callingCode: "+56",
    code: "cl"
  }, {
    name: t("China"),
    callingCode: "+86",
    code: "cn"
  }, {
    name: t("Christmas Island"),
    callingCode: "+61 8 9164",
    code: "cx"
  }, {
    name: t("Colombia"),
    callingCode: "+57",
    code: "co"
  }, {
    name: t("Comoros"),
    callingCode: "+269",
    code: "km"
  }, {
    name: t("Congo"),
    callingCode: "+242",
    code: "cg"
  }, {
    name: t("Cook Islands"),
    callingCode: "+682",
    code: "ck"
  }, {
    name: t("Costa Rica"),
    callingCode: "+506",
    code: "cr"
  }, {
    name: t("Croatia"),
    callingCode: "+385",
    code: "hr"
  }, {
    name: t("Curacao"),
    callingCode: "+599",
    code: "cw"
  }, {
    name: t("Cyprus"),
    callingCode: "+357",
    code: "cy"
  }, {
    name: t("Czech Republic"),
    callingCode: "+420",
    code: "cz"
  }, {
    name: t("Denmark"),
    callingCode: "+45",
    code: "dk"
  }, {
    name: t("Djibouti"),
    callingCode: "+253",
    code: "dj"
  }, {
    name: t("Dominica"),
    callingCode: "+1 767",
    code: "dm"
  }, {
    name: t("Dominican Republic"),
    callingCode: "+1 849",
    code: "do"
  }, {
    name: t("Dominican Republic"),
    callingCode: "+1 809",
    code: "do"
  }, {
    name: t("Dominican Republic"),
    callingCode: "+1 829",
    code: "do"
  }, {
    name: t("Ecuador"),
    callingCode: "+593",
    code: "ec"
  }, {
    name: t("Egypt"),
    callingCode: "+20",
    code: "eg"
  }, {
    name: t("El Salvador"),
    callingCode: "+503",
    code: "sv"
  }, {
    name: t("Equatorial Guinea"),
    callingCode: "+240",
    code: "gq"
  }, {
    name: t("Eritrea"),
    callingCode: "+291",
    code: "er"
  }, {
    name: t("Estonia"),
    callingCode: "+372",
    code: "ee"
  }, {
    name: t("Ethiopia"),
    callingCode: "+251",
    code: "et"
  }, {
    name: t("Faroe Islands"),
    callingCode: "+298",
    code: "fo"
  }, {
    name: t("Fiji"),
    callingCode: "+679",
    code: "fj"
  }, {
    name: t("Finland"),
    callingCode: "+358",
    code: "fi"
  }, {
    name: t("France"),
    callingCode: "+33",
    code: "fr"
  }, {
    name: t("French Guiana"),
    callingCode: "+594",
    code: "gf"
  }, {
    name: t("French Polynesia"),
    callingCode: "+689",
    code: "pf"
  }, {
    name: t("Gabon"),
    callingCode: "+241",
    code: "ga"
  }, {
    name: t("Gambia"),
    callingCode: "+220",
    code: "gm"
  }, {
    name: t("Georgia"),
    callingCode: "+995",
    code: "ge"
  }, {
    name: t("Germany"),
    callingCode: "+49",
    code: "de"
  }, {
    name: t("Ghana"),
    callingCode: "+233",
    code: "gh"
  }, {
    name: t("Gibraltar"),
    callingCode: "+350",
    code: "gi"
  }, {
    name: t("Greece"),
    callingCode: "+30",
    code: "gr"
  }, {
    name: t("Greenland"),
    callingCode: "+299",
    code: "gl"
  }, {
    name: t("Grenada"),
    callingCode: "+1 473",
    code: "gd"
  }, {
    name: t("Guadeloupe"),
    callingCode: "+590",
    code: "gp"
  }, {
    name: t("Guam"),
    callingCode: "+1 671",
    code: "gu"
  }, {
    name: t("Guatemala"),
    callingCode: "+502",
    code: "gt"
  }, {
    name: t("Guinea"),
    callingCode: "+224",
    code: "gn"
  }, {
    name: t("Guinea-Bissau"),
    callingCode: "+245",
    code: "gw"
  }, {
    name: t("Guyana"),
    callingCode: "+595",
    code: "gy"
  }, {
    name: t("Haiti"),
    callingCode: "+509",
    code: "ht"
  }, {
    name: t("Honduras"),
    callingCode: "+504",
    code: "hn"
  }, {
    name: t("Hungary"),
    callingCode: "+36",
    code: "hu"
  }, {
    name: t("Iceland"),
    callingCode: "+354",
    code: "is"
  }, {
    name: t("India"),
    callingCode: "+91",
    code: "in"
  }, {
    name: t("Indonesia"),
    callingCode: "+62",
    code: "id"
  }, {
    name: t("Iraq"),
    callingCode: "+964",
    code: "iq"
  }, {
    name: t("Ireland"),
    callingCode: "+353",
    code: "ie"
  }, {
    name: t("Israel"),
    callingCode: "+972",
    code: "il"
  }, {
    name: t("Italy"),
    callingCode: "+39",
    code: "it"
  }, {
    name: t("Jamaica"),
    callingCode: "+1 876",
    code: "jm"
  }, {
    name: t("Jamaica"),
    callingCode: "+1 658",
    code: "jm"
  }, {
    name: t("Japan"),
    callingCode: "+81",
    code: "jp"
  }, {
    name: t("Jordan"),
    callingCode: "+962",
    code: "jo"
  }, {
    name: t("Kazakhstan"),
    callingCode: "+7 7",
    code: "kz"
  }, {
    name: t("Kenya"),
    callingCode: "+254",
    code: "ke"
  }, {
    name: t("Kiribati"),
    callingCode: "+686",
    code: "ki"
  }, {
    name: t("Kuwait"),
    callingCode: "+965",
    code: "kw"
  }, {
    name: t("Kyrgyzstan"),
    callingCode: "+996",
    code: "kg"
  }, {
    name: t("Latvia"),
    callingCode: "+371",
    code: "lv"
  }, {
    name: t("Lebanon"),
    callingCode: "+961",
    code: "lb"
  }, {
    name: t("Lesotho"),
    callingCode: "+266",
    code: "ls"
  }, {
    name: t("Liberia"),
    callingCode: "+231",
    code: "lr"
  }, {
    name: t("Liechtenstein"),
    callingCode: "+423",
    code: "li"
  }, {
    name: t("Lithuania"),
    callingCode: "+370",
    code: "lt"
  }, {
    name: t("Luxembourg"),
    callingCode: "+352",
    code: "lu"
  }, {
    name: t("Madagascar"),
    callingCode: "+261",
    code: "mg"
  }, {
    name: t("Malawi"),
    callingCode: "+265",
    code: "mw"
  }, {
    name: t("Malaysia"),
    callingCode: "+60",
    code: "my"
  }, {
    name: t("Maldives"),
    callingCode: "+960",
    code: "mv"
  }, {
    name: t("Mali"),
    callingCode: "+223",
    code: "ml"
  }, {
    name: t("Malta"),
    callingCode: "+356",
    code: "mt"
  }, {
    name: t("Marshall Islands"),
    callingCode: "+692",
    code: "mh"
  }, {
    name: t("Martinique"),
    callingCode: "+596",
    code: "mq"
  }, {
    name: t("Mauritania"),
    callingCode: "+222",
    code: "mr"
  }, {
    name: t("Mauritius"),
    callingCode: "+230",
    code: "mu"
  }, {
    name: t("Mayotte"),
    callingCode: "+262",
    code: "yt"
  }, {
    name: t("Mexico"),
    callingCode: "+52",
    code: "mx"
  }, {
    name: t("Monaco"),
    callingCode: "+377",
    code: "mc"
  }, {
    name: t("Mongolia"),
    callingCode: "+976",
    code: "mn"
  }, {
    name: t("Montenegro"),
    callingCode: "+382",
    code: "me"
  }, {
    name: t("Montserrat"),
    callingCode: "+1664",
    code: "ms"
  }, {
    name: t("Morocco"),
    callingCode: "+212",
    code: "ma"
  }, {
    name: t("Myanmar"),
    callingCode: "+95",
    code: "mm"
  }, {
    name: t("Namibia"),
    callingCode: "+264",
    code: "na"
  }, {
    name: t("Nauru"),
    callingCode: "+674",
    code: "nr"
  }, {
    name: t("Nepal"),
    callingCode: "+977",
    code: "np"
  }, {
    name: t("Netherlands"),
    callingCode: "+31",
    code: "nl"
  }, {
    name: t("New Caledonia"),
    callingCode: "+687",
    code: "nc"
  }, {
    name: t("New Zealand"),
    callingCode: "+64",
    code: "nz"
  }, {
    name: t("Nicaragua"),
    callingCode: "+505",
    code: "ni"
  }, {
    name: t("Niger"),
    callingCode: "+227",
    code: "ne"
  }, {
    name: t("Nigeria"),
    callingCode: "+234",
    code: "ng"
  }, {
    name: t("Niue"),
    callingCode: "+683",
    code: "nu"
  }, {
    name: t("Norfolk Island"),
    callingCode: "+672",
    code: "nf"
  }, {
    name: t("Northern Mariana Islands"),
    callingCode: "+1 670",
    code: "mp"
  }, {
    name: t("Norway"),
    callingCode: "+47",
    code: "no"
  }, {
    name: t("Oman"),
    callingCode: "+968",
    code: "om"
  }, {
    name: t("Pakistan"),
    callingCode: "+92",
    code: "pk"
  }, {
    name: t("Palau"),
    callingCode: "+680",
    code: "pw"
  }, {
    name: t("Panama"),
    callingCode: "+507",
    code: "pa"
  }, {
    name: t("Papua New Guinea"),
    callingCode: "+675",
    code: "pg"
  }, {
    name: t("Paraguay"),
    callingCode: "+595",
    code: "py"
  }, {
    name: t("Peru"),
    callingCode: "+51",
    code: "pe"
  }, {
    name: t("Philippines"),
    callingCode: "+63",
    code: "ph"
  }, {
    name: t("Poland"),
    callingCode: "+48",
    code: "pl"
  }, {
    name: t("Portugal"),
    callingCode: "+351",
    code: "pt"
  }, {
    name: t("Puerto Rico"),
    callingCode: "+1 939",
    code: "pr"
  }, {
    name: t("Puerto Rico"),
    callingCode: "+1 787",
    code: "pr"
  }, {
    name: t("Qatar"),
    callingCode: "+974",
    code: "qa"
  }, {
    name: t("Romania"),
    callingCode: "+40",
    code: "ro"
  }, {
    name: t("Rwanda"),
    callingCode: "+250",
    code: "rw"
  }, {
    name: t("Samoa"),
    callingCode: "+685",
    code: "ws"
  }, {
    name: t("San Marino"),
    callingCode: "+378",
    code: "sm"
  }, {
    name: t("Saudi Arabia"),
    callingCode: "+966",
    code: "sa"
  }, {
    name: t("Senegal"),
    callingCode: "+221",
    code: "sn"
  }, {
    name: t("Serbia"),
    callingCode: "+381",
    code: "rs"
  }, {
    name: t("Seychelles"),
    callingCode: "+248",
    code: "sc"
  }, {
    name: t("Sierra Leone"),
    callingCode: "+232",
    code: "sl"
  }, {
    name: t("Singapore"),
    callingCode: "+65",
    code: "sg"
  }, {
    name: t("Slovakia"),
    callingCode: "+421",
    code: "sk"
  }, {
    name: t("Slovenia"),
    callingCode: "+386",
    code: "si"
  }, {
    name: t("Solomon Islands"),
    callingCode: "+677",
    code: "sb"
  }, {
    name: t("South Africa"),
    callingCode: "+27",
    code: "za"
  }, {
    name: t("South Georgia and the South Sandwich Islands"),
    callingCode: "+500",
    code: "gs"
  }, {
    name: t("Spain"),
    callingCode: "+34",
    code: "es"
  }, {
    name: t("Sri Lanka"),
    callingCode: "+94",
    code: "lk"
  }, {
    name: t("Suriname"),
    callingCode: "+597",
    code: "sr"
  }, {
    name: t("Swaziland"),
    callingCode: "+268",
    code: "sz"
  }, {
    name: t("Sweden"),
    callingCode: "+46",
    code: "se"
  }, {
    name: t("Switzerland"),
    callingCode: "+41",
    code: "ch"
  }, {
    name: t("Tajikistan"),
    callingCode: "+992",
    code: "tj"
  }, {
    name: t("Thailand"),
    callingCode: "+66",
    code: "th"
  }, {
    name: t("Togo"),
    callingCode: "+228",
    code: "tg"
  }, {
    name: t("Tokelau"),
    callingCode: "+690",
    code: "tk"
  }, {
    name: t("Tonga"),
    callingCode: "+676",
    code: "to"
  }, {
    name: t("Trinidad and Tobago"),
    callingCode: "+1 868",
    code: "tt"
  }, {
    name: t("Tunisia"),
    callingCode: "+216",
    code: "tn"
  }, {
    name: t("Turkey"),
    callingCode: "+90",
    code: "tr"
  }, {
    name: t("Turkmenistan"),
    callingCode: "+993",
    code: "tm"
  }, {
    name: t("Turks and Caicos Islands"),
    callingCode: "+1 649",
    code: "tc"
  }, {
    name: t("Tuvalu"),
    callingCode: "+688",
    code: "tv"
  }, {
    name: t("Uganda"),
    callingCode: "+256",
    code: "ug"
  }, {
    name: t("Ukraine"),
    callingCode: "+380",
    code: "ua"
  }, {
    name: t("United Arab Emirates"),
    callingCode: "+971",
    code: "ae"
  }, {
    name: t("United Kingdom"),
    callingCode: "+44",
    code: "gb"
  }, {
    name: t("United States"),
    callingCode: "+1",
    code: "us"
  }, {
    name: t("Uruguay"),
    callingCode: "+598",
    code: "uy"
  }, {
    name: t("Uzbekistan"),
    callingCode: "+998",
    code: "uz"
  }, {
    name: t("Vanuatu"),
    callingCode: "+678",
    code: "vu"
  }, {
    name: t("Wallis and Futuna"),
    callingCode: "+681",
    code: "wf"
  }, {
    name: t("Yemen"),
    callingCode: "+967",
    code: "ye"
  }, {
    name: t("Zambia"),
    callingCode: "+260",
    code: "zm"
  }, {
    name: t("Zimbabwe"),
    callingCode: "+263",
    code: "zw"
  }, {
    name: t("\xC5land Islands"),
    callingCode: "+358",
    code: "ax"
  }, {
    name: t("Bolivia, Plurinational State of"),
    callingCode: "+591",
    code: "bo"
  }, {
    name: t("Brunei Darussalam"),
    callingCode: "+673",
    code: "bn"
  }, {
    name: t("Cocos (Keeling) Islands"),
    callingCode: "+61 8 9162",
    code: "cc"
  }, {
    name: t("Congo, The Democratic Republic of the"),
    callingCode: "+243",
    code: "cd"
  }, {
    name: t("Cote d'Ivoire"),
    callingCode: "+225",
    code: "ci"
  }, {
    name: t("Falkland Islands (Malvinas)"),
    callingCode: "+500",
    code: "fk"
  }, {
    name: t("Guernsey"),
    callingCode: "+44",
    code: "gg"
  }, {
    name: t("Holy See (Vatican City State)"),
    callingCode: "+379",
    code: "va"
  }, {
    name: t("Hong Kong"),
    callingCode: "+852",
    code: "hk"
  }, {
    name: t("Isle of Man"),
    callingCode: "+44",
    code: "im"
  }, {
    name: t("Jersey"),
    callingCode: "+44",
    code: "je"
  }, {
    name: t("Korea, Republic of"),
    callingCode: "+82",
    code: "kr"
  }, {
    name: t("Lao People's Democratic Republic"),
    callingCode: "+856",
    code: "la"
  }, {
    name: t("Libyan Arab Jamahiriya"),
    callingCode: "+218",
    code: "ly"
  }, {
    name: t("Macao"),
    callingCode: "+853",
    code: "mo"
  }, {
    name: t("Macedonia, The Former Yugoslav Republic of"),
    callingCode: "+389",
    code: "mk"
  }, {
    name: t("Micronesia, Federated States of"),
    callingCode: "+691",
    code: "fm"
  }, {
    name: t("Moldova, Republic of"),
    callingCode: "+373",
    code: "md"
  }, {
    name: t("Mozambique"),
    callingCode: "+258",
    code: "mz"
  }, {
    name: t("Palestinian Territory, Occupied"),
    callingCode: "+970",
    code: "ps"
  }, {
    name: t("Pitcairn"),
    callingCode: "+872",
    code: "pn"
  }, {
    name: t("R\xE9union"),
    callingCode: "+262",
    code: "re"
  }, {
    name: t("Russia"),
    callingCode: "+7",
    code: "ru"
  }, {
    name: t("Saint Barth\xE9lemy"),
    callingCode: "+590",
    code: "bl"
  }, {
    name: t("Saint Helena, Ascension and Tristan Da Cunha"),
    callingCode: "+290",
    code: "sh"
  }, {
    name: t("Saint Kitts and Nevis"),
    callingCode: "+1 869",
    code: "kn"
  }, {
    name: t("Saint Lucia"),
    callingCode: "+1 758",
    code: "lc"
  }, {
    name: t("Saint Martin"),
    callingCode: "+590",
    code: "mf"
  }, {
    name: t("Saint Pierre and Miquelon"),
    callingCode: "+508",
    code: "pm"
  }, {
    name: t("Saint Vincent and the Grenadines"),
    callingCode: "+1 784",
    code: "vc"
  }, {
    name: t("Sao Tome and Principe"),
    callingCode: "+239",
    code: "st"
  }, {
    name: t("Somalia"),
    callingCode: "+252",
    code: "so"
  }, {
    name: t("Svalbard and Jan Mayen"),
    callingCode: "+47",
    code: "sj"
  }, {
    name: t("Taiwan, Province of China"),
    callingCode: "+886",
    code: "tw"
  }, {
    name: t("Tanzania, United Republic of"),
    callingCode: "+255",
    code: "tz"
  }, {
    name: t("Timor-Leste"),
    callingCode: "+670",
    code: "tl"
  }, {
    name: t("Venezuela, Bolivarian Republic of"),
    callingCode: "+58",
    code: "ve"
  }, {
    name: t("Viet Nam"),
    callingCode: "+84",
    code: "vn"
  }, {
    name: t("Virgin Islands, British"),
    callingCode: "+1 284",
    code: "vg"
  }, {
    name: t("Virgin Islands, U.S."),
    callingCode: "+1 340",
    code: "vi"
  }];
};

var getDefaultValue = function getDefaultValue(country) {
  if (!country) {
    return "";
  }

  return "".concat(country.name, " (").concat(country.callingCode, ")");
};

var CountryInput = function CountryInput(_ref55) {
  var onValueChange = _ref55.onValueChange,
      value = _ref55.value,
      props = _objectWithoutProperties(_ref55, _excluded44);

  var countries = useCountries();

  var handleValueChange = function handleValueChange(displayText) {
    if (displayText.length === 0) {
      onValueChange === null || onValueChange === void 0 || onValueChange({
        callingCode: "",
        code: "",
        name: ""
      });
      return;
    }

    var countryData = countries.find(function (_ref56) {
      var name = _ref56.name,
          callingCode = _ref56.callingCode;
      return "".concat(name === null || name === void 0 ? void 0 : name.toLowerCase(), " (").concat(callingCode === null || callingCode === void 0 ? void 0 : callingCode.toLowerCase(), ")") === displayText.toLowerCase();
    });

    if (!countryData) {
      console.error("Country not found for displayText: ".concat(displayText, ". This should not happen."));
      return;
    }

    onValueChange === null || onValueChange === void 0 || onValueChange(countryData);
  };

  var items = countries.map(function (_ref57) {
    var callingCode = _ref57.callingCode,
        code = _ref57.code,
        name = _ref57.name;
    var label = "".concat(name, " (").concat(callingCode, ")");
    return {
      value: label,
      label: label,
      icon: /* @__PURE__ */jsxRuntime.jsx(Flag, {
        className: "w-5",
        country: code.toUpperCase()
      })
    };
  });
  var selectedCountry = countries.find(function (country) {
    var _value$code;

    return country.code === (value === null || value === void 0 || (_value$code = value.code) === null || _value$code === void 0 ? void 0 : _value$code.toLowerCase());
  });
  var icon = selectedCountry ? /* @__PURE__ */jsxRuntime.jsx(Flag, {
    className: "mr-2 w-5",
    country: selectedCountry.code.toUpperCase()
  }) : /* @__PURE__ */jsxRuntime.jsx("span", {
    className: "w-5 text-center",
    children: "+"
  });
  return /* @__PURE__ */jsxRuntime.jsx(ResponsiveAutocomplete, _objectSpread(_objectSpread({}, props), {}, {
    items: items,
    showMobileIcon: false,
    onValueChange: handleValueChange,
    defaultValue: getDefaultValue(selectedCountry),
    inputValue: "",
    icon: icon,
    fullScreen: true
  }));
};

var _path$s;

function _extends$t() {
  _extends$t = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$t.apply(this, arguments);
}

var SvgCheck$1 = function SvgCheck(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$t({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m1.672 5 3.603 3.603 7.052-7.052",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Checkbox = React.forwardRef(function (_ref58, ref) {
  var className = _ref58.className,
      _ref58$onValueChange = _ref58.onValueChange,
      onValueChange = _ref58$onValueChange === void 0 ? function () {} : _ref58$onValueChange,
      value = _ref58.value,
      props = _objectWithoutProperties(_ref58, _excluded45);

  return /* @__PURE__ */jsxRuntime.jsx(CheckboxPrimitive__namespace.Root, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: cn("peer/checkbox group/checkbox", className),
    checked: value,
    onCheckedChange: onValueChange
  }));
});
Checkbox.displayName = CheckboxPrimitive__namespace.Root.displayName;
var CheckboxIndicatorWrapper = React.forwardRef(function (_ref59, ref) {
  var className = _ref59.className,
      children = _ref59.children,
      props = _objectWithoutProperties(_ref59, _excluded46);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: cn("h-5 w-5 shrink-0 rounded-[0.250rem] border border-neutral-500 bg-white outline-none disabled:cursor-not-allowed disabled:opacity-50", "group-data-[state=checked]/checkbox:border-primary group-data-[state=checked]/checkbox:bg-primary group-data-[state=checked]/checkbox:text-primary-contrast", className),
    children: /* @__PURE__ */jsxRuntime.jsx(CheckboxPrimitive__namespace.Indicator, _objectSpread(_objectSpread({}, props), {}, {
      className: cn("flex h-full w-full items-center justify-center text-current", className),
      children: /* @__PURE__ */jsxRuntime.jsx(SvgCheck$1, {
        className: "text-sm"
      })
    }))
  }));
});
CheckboxIndicatorWrapper.displayName = "CheckboxIndicatorWrapper";
var CheckboxCard = React.forwardRef(function (_ref60, ref) {
  var className = _ref60.className,
      _ref60$onValueChange = _ref60.onValueChange,
      onValueChange = _ref60$onValueChange === void 0 ? function () {} : _ref60$onValueChange,
      value = _ref60.value,
      children = _ref60.children,
      props = _objectWithoutProperties(_ref60, _excluded47);

  return /* @__PURE__ */jsxRuntime.jsx(CheckboxPrimitive__namespace.Root, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    asChild: true,
    checked: value,
    onCheckedChange: onValueChange,
    children: /* @__PURE__ */jsxRuntime.jsx("div", {
      className: cn("group/checkbox data-[state=checked]:border-primary flex cursor-pointer gap-4 rounded-md border border-neutral-500 bg-white p-2 outline-none transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50 sm:gap-3", className),
      children: children
    })
  }));
});
CheckboxCard.displayName = CheckboxPrimitive__namespace.Root.displayName;
var CheckboxCardTitle = React.forwardRef(function (_ref61, ref) {
  var className = _ref61.className,
      children = _ref61.children,
      props = _objectWithoutProperties(_ref61, _excluded48);

  return /* @__PURE__ */jsxRuntime.jsx("h2", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: cn("text-base font-semibold", className),
    children: children
  }));
});
CheckboxCardTitle.displayName = "CheckboxCardTitle";
var CheckboxCardDescription = React.forwardRef(function (_ref62, ref) {
  var className = _ref62.className,
      children = _ref62.children,
      props = _objectWithoutProperties(_ref62, _excluded49);

  return /* @__PURE__ */jsxRuntime.jsx("p", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: cn("text-xs text-neutral-800", className),
    children: children
  }));
});
CheckboxCardDescription.displayName = "CheckboxCardDescription";
var CheckboxCardButton = React.forwardRef(function (_ref63, ref) {
  var className = _ref63.className,
      children = _ref63.children,
      props = _objectWithoutProperties(_ref63, _excluded50);

  return /* @__PURE__ */jsxRuntime.jsx(Button, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: cn("hover:bg-primary group-data-[state=checked]/checkbox:bg-success-300 px-3 text-base", className),
    children: children
  }));
});
CheckboxCardButton.displayName = "CheckboxCardDescription";

var _path$r;

function _extends$s() {
  _extends$s = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$s.apply(this, arguments);
}

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$r || (_path$r = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13 6.05 8.05 11 13 15.95",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$q;

function _extends$r() {
  _extends$r = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$r.apply(this, arguments);
}

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$q || (_path$q = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9 15.95 13.95 11 9 6.05",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Calendar = function Calendar(_ref64) {
  var className = _ref64.className,
      classNames = _ref64.classNames,
      _ref64$showOutsideDay = _ref64.showOutsideDays,
      showOutsideDays = _ref64$showOutsideDay === void 0 ? true : _ref64$showOutsideDay,
      value = _ref64.value,
      onValueChange = _ref64.onValueChange,
      props = _objectWithoutProperties(_ref64, _excluded51);

  return /* @__PURE__ */jsxRuntime.jsx(reactDayPicker.DayPicker, _objectSpread({
    selected: value,
    onSelect: onValueChange,
    showOutsideDays: showOutsideDays,
    className: cn("p-2", className),
    classNames: _objectSpread({
      months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
      month: "space-y-4",
      caption: "flex justify-center pt-1 relative items-center",
      caption_label: "text-sm font-medium",
      nav: "space-x-1 flex items-center",
      nav_button: "inline-flex hover:bg-neutral-200 items-center justify-center rounded-sm text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 h-7 w-7 bg-transparent !p-0 hover:bg-neutral-100",
      nav_button_previous: "absolute left-1 p-0",
      nav_button_next: "absolute right-1",
      table: "w-full border-collapse space-y-1",
      head_row: "flex",
      head_cell: "text-neutral-400 w-8 font-normal text-[0.8rem]",
      row: "flex w-full mt-2",
      cell: "relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-primary rounded-full",
      day: "inline-flex hover:bg-neutral-200 items-center justify-center rounded-full text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 h-8 w-8 p-0 font-normal rounded-full aria-selected:opacity-100",
      day_range_start: "day-range-start",
      day_range_end: "day-range-end",
      day_today: "bg-neutral-200 text-black aria-selected:bg-primary aria-selected:text-primary-contrast",
      day_selected: "bg-primary rounded-full text-primary-contrast hover:bg-primary hover:text-primary-contrast focus:bg-primary focus:text-primary-contrast",
      day_outside: "text-neutral-400 aria-selected:text-primary-contrast",
      day_disabled: "text-neutral-400 opacity-50",
      day_range_middle: "aria-selected:bg-primary aria-selected:text-primary-contrast",
      day_hidden: "invisible"
    }, classNames),
    components: {
      IconLeft: function IconLeft(props2) {
        return /* @__PURE__ */jsxRuntime.jsx(SvgChevronLeft, _objectSpread(_objectSpread({}, props2), {}, {
          className: "text-xl"
        }));
      },
      IconRight: function IconRight(props2) {
        return /* @__PURE__ */jsxRuntime.jsx(SvgChevronRight, _objectSpread(_objectSpread({}, props2), {}, {
          className: "text-xl"
        }));
      }
    }
  }, props));
};

Calendar.displayName = "Calendar";
var Popover = PopoverPrimitive__namespace.Root;
var PopoverTrigger = PopoverPrimitive__namespace.Trigger;
var PopoverClose = PopoverPrimitive__namespace.Close;
var PopoverContent = React.forwardRef(function (_ref65, ref) {
  var className = _ref65.className,
      _ref65$align = _ref65.align,
      align = _ref65$align === void 0 ? "center" : _ref65$align,
      _ref65$sideOffset = _ref65.sideOffset,
      sideOffset = _ref65$sideOffset === void 0 ? 4 : _ref65$sideOffset,
      props = _objectWithoutProperties(_ref65, _excluded52);

  return /* @__PURE__ */jsxRuntime.jsx(PopoverPrimitive__namespace.Portal, {
    children: /* @__PURE__ */jsxRuntime.jsx(PopoverPrimitive__namespace.Content, _objectSpread({
      ref: ref,
      align: align,
      sideOffset: sideOffset,
      className: cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-80 rounded bg-white p-2 shadow-md outline-none", className)
    }, props))
  });
});
PopoverContent.displayName = PopoverPrimitive__namespace.Content.displayName;

var _g;

function _extends$q() {
  _extends$q = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$q.apply(this, arguments);
}

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$q({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.98 3.61H3.02A2.48 2.48 0 0 0 .54 6.09v8.78a2.48 2.48 0 0 0 2.48 2.48h9.96a2.48 2.48 0 0 0 2.48-2.48V6.09a2.48 2.48 0 0 0-2.48-2.48Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.79 7.52H15.2M3.29 10.4h2M7.29 10.4h2M11.29 10.4h2M3.29 14.06h2M7.29 14.06h2M11.29 14.06h2M4.29 5.1V1M11.71 5.1V1",
    strokeLinecap: "round"
  }))));
};

var DatePicker = React.forwardRef(function (_ref66, ref) {
  var _value$toISOString;

  var id = _ref66.id,
      value = _ref66.value,
      label = _ref66.label,
      open = _ref66.open,
      name = _ref66.name,
      error = _ref66.error,
      placeholder = _ref66.placeholder,
      fromDate = _ref66.fromDate,
      toDate = _ref66.toDate,
      onValueChange = _ref66.onValueChange,
      onOpenChange = _ref66.onOpenChange,
      props = _objectWithoutProperties(_ref66, _excluded53);

  var _useTranslation2 = useTranslation("ui:date-picker"),
      t = _useTranslation2.t;

  var triggerText = value ? dateFns.format(value, "MMM d, Y") : "";
  var inputValue = (_value$toISOString = value === null || value === void 0 ? void 0 : value.toISOString()) !== null && _value$toISOString !== void 0 ? _value$toISOString : "";
  return reactDeviceDetect.isMobile ? /* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
    error: error,
    children: [/* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
      children: /* @__PURE__ */jsxRuntime.jsx(SvgCalendar, {})
    }), /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
      htmlFor: id,
      children: label
    }), /* @__PURE__ */jsxRuntime.jsx(FloatingInput, {
      name: name,
      id: id,
      placeholder: placeholder,
      value: inputValue,
      type: "date",
      className: "h-14 opacity-0",
      min: fromDate === null || fromDate === void 0 ? void 0 : fromDate.toISOString().split("T")[0],
      max: toDate === null || toDate === void 0 ? void 0 : toDate.toISOString().split("T")[0],
      onChange: function onChange(event) {
        var value2 = event.target.value;

        if (!value2) {
          return;
        }

        onValueChange === null || onValueChange === void 0 || onValueChange(value2 ? dateFns.parseISO(value2) : void 0);
      }
    }), triggerText && /* @__PURE__ */jsxRuntime.jsx("p", {
      className: "pointer-events-none absolute left-8 top-6",
      children: triggerText
    })]
  }) : /* @__PURE__ */jsxRuntime.jsxs(Popover, {
    open: open,
    onOpenChange: onOpenChange,
    children: [/* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
      focused: open,
      error: error,
      children: [/* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
        children: /* @__PURE__ */jsxRuntime.jsx(SvgCalendar, {
          className: cn({
            "text-primary": open
          })
        })
      }), /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
        className: "pointer-events-none",
        htmlFor: id,
        children: label
      }), /* @__PURE__ */jsxRuntime.jsx(PopoverTrigger, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(FloatingInput, {
          name: name,
          value: inputValue,
          asChild: true,
          children: /* @__PURE__ */jsxRuntime.jsx("button", {
            type: "button",
            className: "h-14 overflow-hidden whitespace-nowrap text-left",
            children: triggerText
          })
        })
      }), /* @__PURE__ */jsxRuntime.jsx("input", {
        ref: ref,
        type: "hidden",
        id: id,
        name: name,
        value: inputValue
      })]
    }), /* @__PURE__ */jsxRuntime.jsxs(PopoverContent, {
      className: "w-auto p-2",
      children: [/* @__PURE__ */jsxRuntime.jsx(Calendar, _objectSpread(_objectSpread({}, props), {}, {
        mode: "single",
        fromDate: fromDate,
        toDate: toDate,
        value: value,
        initialFocus: true,
        onValueChange: onValueChange
      })), /* @__PURE__ */jsxRuntime.jsx(PopoverClose, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(Button, {
          className: "w-full",
          children: t("Done")
        })
      })]
    })]
  });
});
DatePicker.displayName = "DatePicker";

var _path$p;

function _extends$p() {
  _extends$p = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$p.apply(this, arguments);
}

var SvgTimes$2 = function SvgTimes(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$p || (_path$p = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M16.365 16.434 5.638 5.707M5.638 16.305 16.365 5.578"
  })));
};

var Dialog = DialogPrimitive__namespace.Root;
var DialogTrigger = DialogPrimitive__namespace.Trigger;
var DialogOverlay = React.forwardRef(function (_ref67, ref) {
  var _ = _ref67.asChild,
      props = _objectWithoutProperties(_ref67, _excluded54);

  return /* @__PURE__ */jsxRuntime.jsx(DialogPrimitive__namespace.Overlay, _objectSpread(_objectSpread({
    ref: ref,
    asChild: true
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntime.jsx(Overlay, {})
  }));
});
DialogOverlay.displayName = DialogPrimitive__namespace.Overlay.displayName;

var DialogPortal = function DialogPortal(_ref68) {
  var children = _ref68.children,
      className = _ref68.className,
      props = _objectWithoutProperties(_ref68, _excluded55);

  return /* @__PURE__ */jsxRuntime.jsxs(DialogPrimitive__namespace.Portal, _objectSpread(_objectSpread({}, props), {}, {
    children: [/* @__PURE__ */jsxRuntime.jsx(DialogOverlay, {}), /* @__PURE__ */jsxRuntime.jsx("div", {
      "data-ui-dialog-portal": true,
      className: cn("fixed inset-0 z-50 flex items-center justify-center p-2", className),
      children: children
    })]
  }));
};

DialogPortal.displayName = DialogPrimitive__namespace.Portal.displayName;
var DialogContent = React.forwardRef(function (_ref69, ref) {
  var className = _ref69.className,
      children = _ref69.children,
      props = _objectWithoutProperties(_ref69, _excluded56);

  return /* @__PURE__ */jsxRuntime.jsx(DialogPrimitive__namespace.Content, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 relative flex max-h-[90%] w-full max-w-lg flex-col rounded-lg bg-white shadow-lg duration-200", className)
  }, props), {}, {
    children: children
  }));
});
DialogContent.displayName = DialogPrimitive__namespace.Content.displayName;
var DialogClose = React.forwardRef(function (_ref70, ref) {
  var className = _ref70.className,
      props = _objectWithoutProperties(_ref70, _excluded57);

  return /* @__PURE__ */jsxRuntime.jsx(DialogPrimitive__namespace.Close, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: cn("absolute -left-6 top-0 hidden md:block", className),
    asChild: true,
    children: /* @__PURE__ */jsxRuntime.jsx(IconButton, {
      size: BUTTON_SIZE.SM,
      className: "rounded-lg",
      children: /* @__PURE__ */jsxRuntime.jsx(SvgTimes$2, {})
    })
  }));
});
DialogClose.displayName = DialogPrimitive__namespace.Close.displayName;

var DialogHeader = function DialogHeader(_ref71) {
  var className = _ref71.className,
      props = _objectWithoutProperties(_ref71, _excluded58);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    className: cn("flex flex-col space-y-1.5 p-3 text-center sm:text-left", className)
  }, props));
};

DialogHeader.displayName = "DialogHeader";

var DialogFooter = function DialogFooter(_ref72) {
  var className = _ref72.className,
      props = _objectWithoutProperties(_ref72, _excluded59);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    className: cn("flex flex-col-reverse p-3 sm:flex-row sm:justify-end sm:space-x-2", className)
  }, props));
};

DialogFooter.displayName = "DialogFooter";
var DialogTitle = React.forwardRef(function (_ref73, ref) {
  var className = _ref73.className,
      props = _objectWithoutProperties(_ref73, _excluded60);

  return /* @__PURE__ */jsxRuntime.jsx(DialogPrimitive__namespace.Title, _objectSpread({
    ref: ref,
    className: cn("text-lg font-semibold leading-none tracking-tight", className)
  }, props));
});
DialogTitle.displayName = DialogPrimitive__namespace.Title.displayName;
var DialogDescription = React.forwardRef(function (_ref74, ref) {
  var className = _ref74.className,
      props = _objectWithoutProperties(_ref74, _excluded61);

  return /* @__PURE__ */jsxRuntime.jsx(DialogPrimitive__namespace.Description, _objectSpread({
    ref: ref,
    className: cn("p-3 text-sm", className)
  }, props));
});
DialogDescription.displayName = DialogPrimitive__namespace.Description.displayName;

var DialogScrollableContent = function DialogScrollableContent(_ref75) {
  var className = _ref75.className,
      props = _objectWithoutProperties(_ref75, _excluded62);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    className: cn("overflow-auto p-3", className)
  }, props));
};

var _path$o;

function _extends$o() {
  _extends$o = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$o.apply(this, arguments);
}

var SvgArrow$3 = function SvgArrow(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$o({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.05 9 11 13.95 15.95 9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Collapsible = CollapsiblePrimitive__namespace.Root;
var CollapsibleTrigger = React.forwardRef(function (_ref76, ref) {
  var className = _ref76.className,
      children = _ref76.children,
      _ref76$arrowPosition = _ref76.arrowPosition,
      arrowPosition = _ref76$arrowPosition === void 0 ? "left" : _ref76$arrowPosition,
      _ref76$arrowDirection = _ref76.arrowDirection,
      arrowDirection = _ref76$arrowDirection === void 0 ? "down" : _ref76$arrowDirection,
      props = _objectWithoutProperties(_ref76, _excluded63);

  return /* @__PURE__ */jsxRuntime.jsxs(CollapsiblePrimitive__namespace.Trigger, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("group/trigger flex items-center gap-1", className)
  }, props), {}, {
    children: [arrowPosition === "left" && /* @__PURE__ */jsxRuntime.jsx(SvgArrow$3, {
      className: "text-2xl transition-transform duration-200 ".concat(arrowDirection === "down" ? "group-data-[state=closed]/trigger:rotate-0 group-data-[state=open]/trigger:rotate-180" : "group-data-[state=closed]/trigger:rotate-180 group-data-[state=open]/trigger:rotate-0")
    }), children, arrowPosition === "right" && /* @__PURE__ */jsxRuntime.jsx(SvgArrow$3, {
      className: "text-2xl transition-transform duration-200 ".concat(arrowDirection === "down" ? "group-data-[state=closed]/trigger:rotate-0 group-data-[state=open]/trigger:rotate-180" : "group-data-[state=closed]/trigger:rotate-180 group-data-[state=open]/trigger:rotate-0")
    })]
  }));
});
CollapsibleTrigger.displayName = CollapsiblePrimitive__namespace.Trigger.displayName;
var CollapsibleContent = CollapsiblePrimitive__namespace.Content;

var _rect, _path$n;

function _extends$n() {
  _extends$n = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$n.apply(this, arguments);
}

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$n({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 17,
    height: 17,
    rx: 1.5,
    stroke: "currentColor"
  })), _path$n || (_path$n = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 6a.5.5 0 0 0-.5.5V7H5.5a.5.5 0 0 0 0 1H8v.5a.5.5 0 0 0 1 0V8h7.5a.5.5 0 0 0 0-1H9v-.5a.5.5 0 0 0-.5-.5Zm-3 4.5a.5.5 0 0 0 0 1H14v.5a.5.5 0 0 0 1 0v-.5h1.5a.5.5 0 0 0 0-1H15V10a.5.5 0 0 0-1 0v.5H5.5Zm-.5 4a.5.5 0 0 1 .5-.5H10v-.5a.5.5 0 0 1 1 0v.5h5.5a.5.5 0 0 1 0 1H11v.5a.5.5 0 0 1-1 0V15H5.5a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  })));
};

var Filter = function Filter(_ref77) {
  var _ref77$options = _ref77.options,
      options = _ref77$options === void 0 ? [] : _ref77$options,
      _ref77$groups = _ref77.groups,
      groups = _ref77$groups === void 0 ? [] : _ref77$groups,
      value = _ref77.value,
      title = _ref77.title,
      _ref77$onValueChange = _ref77.onValueChange,
      _onValueChange2 = _ref77$onValueChange === void 0 ? function () {} : _ref77$onValueChange,
      _ref77$onClear = _ref77.onClear,
      onClear = _ref77$onClear === void 0 ? function () {} : _ref77$onClear;

  var _useTranslation3 = useTranslation("ui:filter"),
      t = _useTranslation3.t;

  var _React$useState21 = React.useState(false),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      isCheckboxSelected = _React$useState22[0],
      setIsCheckboxSelected = _React$useState22[1];

  var groupedOptions = options.reduce(function (acc, option) {
    var group = acc.find(function (group2) {
      return group2.group.value === option.group;
    });

    if (group) {
      group.options.push(option);
    } else {
      var group2 = groups.find(function (group3) {
        return group3.value === option.group;
      });

      if (!group2) {
        console.error("Group ".concat(option.group.toString(), " not found."));
        return acc;
      }

      acc.push({
        group: group2,
        options: [option]
      });
    }

    return acc;
  }, []);

  var renderFilters = function renderFilters() {
    return /* @__PURE__ */jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [/* @__PURE__ */jsxRuntime.jsxs("div", {
        className: "mb-2 flex items-end justify-between py-2",
        children: [/* @__PURE__ */jsxRuntime.jsx("h3", {
          className: "px-2 text-xl font-semibold",
          children: title || t("Filters")
        }), isCheckboxSelected && /* @__PURE__ */jsxRuntime.jsx(Button, {
          onClick: function onClick() {
            setIsCheckboxSelected(false);
            onClear();
          },
          variant: BUTTON_VARIANT.GHOST,
          color: BUTTON_COLOR.PRIMARY,
          size: BUTTON_SIZE.SM,
          children: t("Clear All")
        })]
      }), groupedOptions.map(function (group) {
        return /* @__PURE__ */jsxRuntime.jsxs(Collapsible, {
          defaultOpen: true,
          className: "mb-3",
          children: [/* @__PURE__ */jsxRuntime.jsx(CollapsibleTrigger, {
            className: "mb-2 w-full border-b border-b-neutral-500 pb-1.5 text-sm text-neutral-800 sm:text-xs",
            children: group.group.label
          }), /* @__PURE__ */jsxRuntime.jsx(CollapsibleContent, {
            children: group.options.map(function (option) {
              var _value$option$group2;

              return /* @__PURE__ */jsxRuntime.jsx("div", {
                className: "mb-2 pr-2 sm:mb-0",
                children: /* @__PURE__ */jsxRuntime.jsxs("label", {
                  htmlFor: option.value,
                  className: "flex flex-1 cursor-pointer items-center gap-2 p-1 text-base font-medium leading-none",
                  children: [/* @__PURE__ */jsxRuntime.jsx(Checkbox, {
                    onValueChange: function onValueChange(_value) {
                      var _value$option$group;

                      setIsCheckboxSelected(typeof _value === "boolean" ? _value : false);

                      _onValueChange2(_value ? _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, option.group, [].concat(_toConsumableArray(value[option.group]), [option.value]))) : _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, option.group, (_value$option$group = value[option.group]) === null || _value$option$group === void 0 ? void 0 : _value$option$group.filter(function (v) {
                        return v !== option.value;
                      }))));
                    },
                    value: (_value$option$group2 = value[option.group]) === null || _value$option$group2 === void 0 ? void 0 : _value$option$group2.includes(option.value),
                    id: option.value,
                    children: /* @__PURE__ */jsxRuntime.jsx(CheckboxIndicatorWrapper, {})
                  }), /* @__PURE__ */jsxRuntime.jsx("span", {
                    className: "text-sm",
                    children: option.label
                  }), typeof option.quantity === "number" && /* @__PURE__ */jsxRuntime.jsx(Badge, {
                    className: "peer-data-[state=checked]/checkbox:bg-primary ml-auto min-w-[1.375rem] justify-center bg-neutral-700 px-0.5 py-0.5",
                    children: option.quantity
                  })]
                })
              }, option.value);
            })
          })]
        }, group.group.value);
      })]
    });
  };

  return /* @__PURE__ */jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/* @__PURE__ */jsxRuntime.jsx("div", {
      className: "hidden md:block",
      children: renderFilters()
    }), /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "grid md:hidden",
      children: /* @__PURE__ */jsxRuntime.jsxs(Sheet, {
        children: [/* @__PURE__ */jsxRuntime.jsx(SheetTrigger, {
          asChild: true,
          children: /* @__PURE__ */jsxRuntime.jsxs(Button, {
            color: BUTTON_COLOR.WHITE,
            children: [/* @__PURE__ */jsxRuntime.jsx(SvgFilter, {
              className: "text-primary text-xl"
            }), title || t("Filters")]
          })
        }), /* @__PURE__ */jsxRuntime.jsxs(SheetContent, {
          side: SHEET_CONTENT_SIDE.BOTTOM,
          className: "max-h-full overflow-auto rounded-md bg-neutral-100 pb-16",
          children: [renderFilters(), /* @__PURE__ */jsxRuntime.jsx("div", {
            className: "fixed bottom-0 left-0 right-0 bg-neutral-100 px-2 py-4",
            children: /* @__PURE__ */jsxRuntime.jsx(SheetClose, {
              asChild: true,
              children: /* @__PURE__ */jsxRuntime.jsx(Button, {
                className: "w-full py-3 text-base leading-6",
                children: t("Show results")
              })
            })
          })]
        })]
      })
    })]
  });
};

var _path$m;

function _extends$m() {
  _extends$m = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$m.apply(this, arguments);
}

var SvgArrow$2 = function SvgArrow(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$m({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.05 9 11 13.95 15.95 9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var SelectGroup = SelectPrimitive__namespace.Group;
var Select = SelectPrimitive__namespace.Root;
Select.displayName = SelectPrimitive__namespace.Root.displayName;
var SelectTrigger = React.forwardRef(function (_ref78, ref) {
  var className = _ref78.className,
      children = _ref78.children,
      asChild = _ref78.asChild,
      props = _objectWithoutProperties(_ref78, _excluded64);

  return /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.Trigger, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: cn("", {
      "border-input group/trigger flex w-full items-center justify-between rounded-md border bg-white px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-1 disabled:cursor-not-allowed disabled:opacity-50": !asChild
    }, className),
    asChild: asChild,
    children: children
  }));
});
SelectTrigger.displayName = SelectPrimitive__namespace.Trigger.displayName;
var SelectValue = React.forwardRef(function (_ref79, ref) {
  var className = _ref79.className,
      customRender = _ref79.customRender,
      placeholder = _ref79.placeholder,
      props = _objectWithoutProperties(_ref79, _excluded65);

  return /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.Value, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    placeholder: placeholder
  }));
});
SelectValue.displayName = SelectPrimitive__namespace.Value.displayName;
var SelectContent = React.forwardRef(function (_ref80, ref) {
  var className = _ref80.className,
      children = _ref80.children,
      _ref80$position = _ref80.position,
      position = _ref80$position === void 0 ? "popper" : _ref80$position,
      props = _objectWithoutProperties(_ref80, _excluded66);

  return /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.Portal, {
    children: /* @__PURE__ */jsxRuntime.jsxs(SelectPrimitive__namespace.Content, _objectSpread(_objectSpread({
      ref: ref,
      className: cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 min-w-[8rem] overflow-hidden rounded-md bg-white text-black shadow-md", position === "popper" && "data-[side=bottom]:translate-y-2 data-[side=left]:-translate-x-2 data-[side=right]:translate-x-2 data-[side=top]:-translate-y-2", className),
      position: position
    }, props), {}, {
      children: [/* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.ScrollUpButton, {
        className: "flex justify-center py-1",
        children: /* @__PURE__ */jsxRuntime.jsx(SvgArrow$2, {
          className: "h-6 w-6 rotate-180"
        })
      }), /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.Viewport, {
        className: cn("p-2", position === "popper" && "w-full min-w-[var(--radix-select-trigger-width)]"),
        children: children
      }), /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.ScrollDownButton, {
        className: "flex justify-center py-1",
        children: /* @__PURE__ */jsxRuntime.jsx(SvgArrow$2, {
          className: "h-6 w-6"
        })
      })]
    }))
  });
});
SelectContent.displayName = SelectPrimitive__namespace.Content.displayName;
var SelectLabel = React.forwardRef(function (_ref81, ref) {
  var className = _ref81.className,
      props = _objectWithoutProperties(_ref81, _excluded67);

  return /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.Label, _objectSpread({
    ref: ref,
    className: cn("px-2 py-1.5 text-sm font-semibold", className)
  }, props));
});
SelectLabel.displayName = SelectPrimitive__namespace.Label.displayName;
var SelectIcon = React.forwardRef(function (_ref82, ref) {
  var className = _ref82.className,
      props = _objectWithoutProperties(_ref82, _excluded68);

  return /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.Icon, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: cn("group-data-[state=open]/trigger:rotate-180", className)
  }));
});
SelectIcon.displayName = SelectPrimitive__namespace.Icon.displayName;
var SelectItem = React.forwardRef(function (_ref83, ref) {
  var className = _ref83.className,
      children = _ref83.children,
      icon = _ref83.icon,
      props = _objectWithoutProperties(_ref83, _excluded69);

  return /* @__PURE__ */jsxRuntime.jsxs(SelectPrimitive__namespace.Item, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("data-[state=checked]:text-primary relative mb-1 flex w-full cursor-pointer select-none items-center gap-1 rounded-sm p-1 text-base outline-none focus:bg-neutral-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className)
  }, props), {}, {
    children: [icon && /* @__PURE__ */jsxRuntime.jsx("span", {
      className: "mr-1 flex h-3.5 w-3.5 items-center justify-center",
      children: /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.ItemIndicator, {
        children: icon
      })
    }), /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.ItemText, {
      children: children
    })]
  }));
});
SelectItem.displayName = SelectPrimitive__namespace.Item.displayName;
var SelectSeparator = React.forwardRef(function (_ref84, ref) {
  var className = _ref84.className,
      props = _objectWithoutProperties(_ref84, _excluded70);

  return /* @__PURE__ */jsxRuntime.jsx(SelectPrimitive__namespace.Separator, _objectSpread({
    ref: ref,
    className: cn("-mx-1 my-1 h-px bg-neutral-300", className)
  }, props));
});
SelectSeparator.displayName = SelectPrimitive__namespace.Separator.displayName;
var defaultTheme = {
  palette: {
    white: "hsl(0 0% 100%)",
    black: "hsl(0 0% 10%)",
    primary: {
      100: "hsl(209 85% 90%)",
      200: "hsl(208 85% 64%)",
      300: "hsl(208 90% 49%)",
      400: "hsl(208 90% 34%)",
      500: "hsl(208 90% 19%)",
      contrast: "hsl(0 80% 100%)"
    },
    secondary: {
      100: "hsl(49 98% 81%)",
      200: "hsl(49 98% 67%)",
      300: "hsl(49 98% 53%)",
      400: "hsl(49 86% 37%)",
      500: "hsl(49 87% 21%)",
      contrast: "hsl(180 4% 5%)"
    },
    neutral: {
      100: "hsl(0 0% 96%)",
      200: "hsl(208 15% 91%)",
      300: "hsl(208 40% 94%)",
      400: "hsl(208 32% 89%)",
      500: "hsl(208 26% 78%)",
      600: "hsl(208 22% 74%)",
      700: "hsl(208 18% 65%)",
      800: "hsl(208 13% 45%)",
      900: "hsl(208 15% 26%)"
    },
    success: {
      100: "hsl(129 40% 90%)",
      200: "hsl(131 39% 65%)",
      300: "hsl(131 39% 50%)",
      400: "hsl(131 39% 35%)",
      500: "hsl(132 39% 20%)"
    },
    error: {
      100: "hsl(0 53% 87%)",
      200: "hsl(0 54% 57%)",
      300: "hsl(0 87% 38%)",
      400: "hsl(0 88% 26%)",
      500: "hsl(0 87% 15%)"
    },
    warning: {
      100: "hsl(41 100% 90%)",
      200: "hsl(41 100% 65%)",
      300: "hsl(41 100% 50%)",
      400: "hsl(41 100% 35%)",
      500: "hsl(41 100% 20%)"
    }
  },
  fontFamily: {
    sans: "Manrope, Roboto, sans-serif"
  },
  header: {
    logoHeight: "1.25rem",
    height: "auto",
    bg: "hsl(0 0% 100%)",
    border: "hsl(208 15% 91%)",
    createAccountBtn: {
      bg: "hsl(208 91% 48%)",
      text: "hsl(0 80% 100%)",
      hover: {
        bg: "hsl(208 91% 34%)",
        text: "hsl(0 80% 100%)"
      }
    },
    signInBtn: {
      bg: "hsl(0 0% 0% / 0%)",
      text: "hsl(208 91% 48%)",
      hover: {
        bg: "hsl(208 85% 79%)",
        text: "hsl(208 91% 48%)"
      }
    },
    generalBtn: {
      bg: "hsl(0 0% 0% / 0%)",
      text: "hsl(0 0% 0%)",
      hover: {
        bg: "hsl(0 0% 96%)",
        text: "hsl(0 0% 0%)"
      }
    }
  }
};
var screens = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
};
var mediaQueries = {
  sm: "(min-width: ".concat(screens.sm, ")"),
  md: "(min-width: ".concat(screens.md, ")"),
  lg: "(min-width: ".concat(screens.lg, ")"),
  xl: "(min-width: ".concat(screens.xl, ")")
};

var getCssVariable = function getCssVariable(cssVariableName) {
  return getComputedStyle(document.documentElement).getPropertyValue(cssVariableName);
};

var getHslColor = function getHslColor(cssVariableName) {
  return "hsl(".concat(getCssVariable(cssVariableName), ")");
};

var getTheme = function getTheme() {
  return {
    palette: {
      white: getHslColor("--mz-palette-white"),
      black: getHslColor("--mz-palette-black"),
      primary: {
        100: getHslColor("--mz-palette-primary-100"),
        200: getHslColor("--mz-palette-primary-200"),
        300: getHslColor("--mz-palette-primary-300"),
        400: getHslColor("--mz-palette-primary-400"),
        500: getHslColor("--mz-palette-primary-500"),
        contrast: getHslColor("--mz-palette-primary-contrast")
      },
      secondary: {
        100: getHslColor("--mz-palette-secondary-100"),
        200: getHslColor("--mz-palette-secondary-200"),
        300: getHslColor("--mz-palette-secondary-300"),
        400: getHslColor("--mz-palette-secondary-400"),
        500: getHslColor("--mz-palette-secondary-500"),
        contrast: getHslColor("--mz-palette-secondary-contrast")
      },
      neutral: {
        100: getHslColor("--mz-palette-neutral-100"),
        200: getHslColor("--mz-palette-neutral-200"),
        300: getHslColor("--mz-palette-neutral-300"),
        400: getHslColor("--mz-palette-neutral-400"),
        500: getHslColor("--mz-palette-neutral-500"),
        600: getHslColor("--mz-palette-neutral-600"),
        700: getHslColor("--mz-palette-neutral-700"),
        800: getHslColor("--mz-palette-neutral-800"),
        900: getHslColor("--mz-palette-neutral-900")
      },
      success: {
        100: getHslColor("--mz-palette-success-100"),
        200: getHslColor("--mz-palette-success-200"),
        300: getHslColor("--mz-palette-success-300"),
        400: getHslColor("--mz-palette-success-400"),
        500: getHslColor("--mz-palette-success-500")
      },
      error: {
        100: getHslColor("--mz-palette-error-100"),
        200: getHslColor("--mz-palette-error-200"),
        300: getHslColor("--mz-palette-error-300"),
        400: getHslColor("--mz-palette-error-400"),
        500: getHslColor("--mz-palette-error-500")
      },
      warning: {
        100: getHslColor("--mz-palette-warning-100"),
        200: getHslColor("--mz-palette-warning-200"),
        300: getHslColor("--mz-palette-warning-300"),
        400: getHslColor("--mz-palette-warning-400"),
        500: getHslColor("--mz-palette-warning-500")
      }
    },
    fontFamily: {
      sans: getCssVariable("--mz-font-family-sans")
    },
    header: {
      logoHeight: getCssVariable("--mz-header-logo-height"),
      height: getCssVariable("--mz-header-height"),
      bg: getCssVariable("--mz-header-bg"),
      border: getCssVariable("--mz-header-border"),
      createAccountBtn: {
        bg: getHslColor("--mz-header-create-account-btn-bg"),
        text: getHslColor("--mz-header-create-account-btn-text"),
        hover: {
          bg: getHslColor("--mz-header-create-account-btn-hover-bg"),
          text: getHslColor("--mz-header-create-account-btn-hover-text")
        }
      },
      signInBtn: {
        bg: getHslColor("--mz-header-sign-in-btn-bg"),
        text: getHslColor("--mz-header-sign-in-btn-text"),
        hover: {
          bg: getHslColor("--mz-header-sign-in-btn-hover-bg"),
          text: getHslColor("--mz-header-sign-in-btn-hover-text")
        }
      },
      generalBtn: {
        bg: getHslColor("--mz-header-general-btn-bg"),
        text: getHslColor("--mz-header-general-btn-text"),
        hover: {
          bg: getHslColor("--mz-header-general-btn-hover-bg"),
          text: getHslColor("--mz-header-general-btn-hover-text")
        }
      }
    }
  };
};

var camelToKebabCase = function camelToKebabCase(key) {
  return key.replace(/([\da-z])([A-Z])/g, "$1-$2").toLowerCase();
};

var setTheme = function setTheme(theme) {
  var root = document.documentElement;
  var cssVariables = toThemeVars(theme);
  Object.entries(cssVariables).forEach(function (_ref85) {
    var _ref86 = _slicedToArray(_ref85, 2),
        property = _ref86[0],
        value = _ref86[1];

    root.style.setProperty(property, value);
  });
};

var toThemeVars = function toThemeVars(theme) {
  var themeVariables = {};

  var _generateCssVariables = function generateCssVariables(partialTheme) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    for (var key in partialTheme) {
      var value = partialTheme[key];
      var transformedKey = camelToKebabCase(key);
      var newPath = [].concat(_toConsumableArray(path), [transformedKey]);

      if (typeof value === "string") {
        themeVariables["--mz-".concat(newPath.join("-"))] = value.replace("hsl(", "").replace(")", "");
      } else {
        _generateCssVariables(value, newPath);
      }
    }
  };

  _generateCssVariables(theme);

  return themeVariables;
};

var extendTheme = function extendTheme(partialTheme) {
  var theme = deepMerge(defaultTheme, partialTheme);
  return theme;
};

var extendPalette = function extendPalette(partialPalette) {
  var palette = deepMerge(defaultTheme.palette, partialPalette);
  return palette;
};

var deepMerge = function deepMerge(target, source) {
  var _recursiveMerge = function recursiveMerge(target2, source1, source2) {
    for (var key in source1) {
      var _target2$key;

      var targetValue = (_target2$key = target2[key]) !== null && _target2$key !== void 0 ? _target2$key : {};
      var source1Value = source1[key];
      var source2Value = source2 === null || source2 === void 0 ? void 0 : source2[key];

      if (Object.prototype.toString.call(source1Value) === "[object Object]" || Array.isArray(source1Value)) {
        target2[key] = _recursiveMerge(targetValue, source1Value, source2Value);
      } else {
        target2[key] = source2Value !== null && source2Value !== void 0 ? source2Value : source1Value;
      }
    }

    return target2;
  };

  return _recursiveMerge({}, target, source);
};

var reForwardRef = function reForwardRef(fromRef, toRef) {
  if (!toRef) {
    return;
  }

  if (typeof toRef === "function") {
    toRef(fromRef);
  } else {
    toRef.current = fromRef;
  }
};

var Container = React.forwardRef(function (_ref87, ref) {
  var className = _ref87.className,
      props = _objectWithoutProperties(_ref87, _excluded71);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: cn("mx-auto max-w-5xl px-2 md:px-4", className)
  }));
});
Container.displayName = "Container";

var _path$l;

function _extends$l() {
  _extends$l = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$l.apply(this, arguments);
}

var SvgAlignRight = function SvgAlignRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$l || (_path$l = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm4 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm-3 5a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H5Z",
    fill: "currentColor"
  })));
};

var HeaderButton = React.forwardRef(function (_ref88, ref) {
  var asChild = _ref88.asChild,
      className = _ref88.className,
      props = _objectWithoutProperties(_ref88, _excluded72);

  var Component = asChild ? reactSlot.Slot : "button";
  return /* @__PURE__ */jsxRuntime.jsx(Component, _objectSpread(_objectSpread({
    ref: ref,
    type: "button"
  }, props), {}, {
    className: cn("bg-header-general-btn-bg text-header-general-btn-text hover:bg-header-general-btn-hover-bg hover:text-header-general-btn-hover-text flex h-9 items-center gap-1 rounded px-4 py-2 text-center leading-5 duration-200", className)
  }));
});
HeaderButton.displayName = "HeaderButton";
var Header = React.forwardRef(function (_ref89, ref) {
  var className = _ref89.className,
      children = _ref89.children,
      props = _objectWithoutProperties(_ref89, _excluded73);

  var handleRef = function handleRef(_ref) {
    if (!_ref) return;
    var headerHeight = _ref.offsetHeight;
    document.documentElement.style.setProperty("--mz-header-height", "".concat(headerHeight, "px"));
    reForwardRef(_ref, ref);
  };

  return /* @__PURE__ */jsxRuntime.jsx("header", _objectSpread(_objectSpread({
    ref: handleRef
  }, props), {}, {
    className: cn("border-b-header-border bg-header-bg fixed left-0 right-0 top-0 z-30 h-[var(--mz-header-height)] w-[calc(100%-var(--removed-body-scroll-bar-size,0px))] border-b", className),
    children: /* @__PURE__ */jsxRuntime.jsx(Container, {
      className: "flex h-full max-w-none justify-between py-2",
      children: children
    })
  }));
});
Header.displayName = "Header";
var HeaderLogo = React.forwardRef(function (_ref90, ref) {
  var className = _ref90.className,
      children = _ref90.children,
      _ref90$href = _ref90.href,
      href = _ref90$href === void 0 ? "/" : _ref90$href,
      props = _objectWithoutProperties(_ref90, _excluded74);

  return /* @__PURE__ */jsxRuntime.jsx("a", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: cn("flex items-center rounded-sm duration-200 [&>*]:h-[var(--mz-header-logo-height)]", className),
    href: href,
    children: children
  }));
});
HeaderLogo.displayName = "HeaderLogo";
var HeaderContent = React.forwardRef(function (_ref91, ref) {
  var className = _ref91.className,
      children = _ref91.children,
      open = _ref91.open,
      onOpenChange = _ref91.onOpenChange,
      _ref91$breakpoint = _ref91.breakpoint,
      breakpoint = _ref91$breakpoint === void 0 ? "lg" : _ref91$breakpoint,
      props = _objectWithoutProperties(_ref91, _excluded75);

  var greaterThanSmall = usehooksTs.useMediaQuery(mediaQueries.lg);
  return /* @__PURE__ */jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread({
      ref: greaterThanSmall ? ref : void 0
    }, props), {}, {
      className: cn("hidden gap-1 ".concat(breakpoint, ":flex"), className),
      children: children
    })), /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread({
      ref: greaterThanSmall ? void 0 : ref
    }, props), {}, {
      className: "block ".concat(breakpoint, ":hidden"),
      children: /* @__PURE__ */jsxRuntime.jsxs(Sheet, {
        open: open,
        onOpenChange: onOpenChange,
        children: [/* @__PURE__ */jsxRuntime.jsx(SheetTrigger, {
          asChild: true,
          children: /* @__PURE__ */jsxRuntime.jsx(HeaderButton, {
            className: "group",
            children: /* @__PURE__ */jsxRuntime.jsx(SvgAlignRight, {
              className: "hover:text-header-general-btn-hover-text text-xl"
            })
          })
        }), /* @__PURE__ */jsxRuntime.jsx(SheetContent, {
          side: "bottom",
          className: "z-50 rounded-t-lg",
          children: children
        })]
      })
    }))]
  });
});
HeaderContent.displayName = "HeaderContent";
var HeaderCreateAccountButton = React.forwardRef(function (_ref92, ref) {
  var asChild = _ref92.asChild,
      className = _ref92.className,
      props = _objectWithoutProperties(_ref92, _excluded76);

  var Component = asChild ? reactSlot.Slot : "button";
  return /* @__PURE__ */jsxRuntime.jsx(Component, _objectSpread(_objectSpread({
    ref: ref,
    type: "button"
  }, props), {}, {
    className: cn("bg-header-create-account-btn-bg text-header-create-account-btn-text hover:bg-header-create-account-btn-hover-bg hover:text-header-create-account-btn-hover-text flex h-9 items-center gap-1 rounded px-4 py-2 text-center leading-5 duration-200", className)
  }));
});
HeaderCreateAccountButton.displayName = "HeaderCreateAccountButton";
var HeaderSignInButton = React.forwardRef(function (_ref93, ref) {
  var asChild = _ref93.asChild,
      className = _ref93.className,
      props = _objectWithoutProperties(_ref93, _excluded77);

  var Component = asChild ? reactSlot.Slot : "button";
  return /* @__PURE__ */jsxRuntime.jsx(Component, _objectSpread(_objectSpread({
    ref: ref,
    type: "button"
  }, props), {}, {
    className: cn("bg-header-sign-in-btn-bg text-header-sign-in-btn-text hover:bg-header-sign-in-btn-hover-bg/20 hover:text-header-sign-in-btn-hover-text flex h-9 items-center gap-1 rounded px-4 py-2 text-center leading-5 duration-200", className)
  }));
});
HeaderSignInButton.displayName = "HeaderSignInButton";

var _path$k;

function _extends$k() {
  _extends$k = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$k.apply(this, arguments);
}

var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$k || (_path$k = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.05 9 11 13.95 15.95 9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$j;

function _extends$j() {
  _extends$j = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$j.apply(this, arguments);
}

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$j || (_path$j = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m4.218 11.246 4.255 4.255L16.8 7.174",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _circle$3, _path$i;

function _extends$i() {
  _extends$i = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$i.apply(this, arguments);
}

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _circle$3 || (_circle$3 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 9.995,
    cy: 9.926,
    r: 6.501,
    stroke: "currentColor"
  })), _path$i || (_path$i = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "m19.293 19.308-4.45-4.45"
  })));
};

var HeaderCombobox = function HeaderCombobox(_ref94) {
  var _items$find3;

  var label = _ref94.label,
      value = _ref94.value,
      items = _ref94.items,
      _ref94$triggerText = _ref94.triggerText,
      triggerText = _ref94$triggerText === void 0 ? "" : _ref94$triggerText,
      open = _ref94.open,
      _ref94$loading = _ref94.loading,
      loading = _ref94$loading === void 0 ? false : _ref94$loading,
      _ref94$shouldFilter = _ref94.shouldFilter,
      shouldFilter = _ref94$shouldFilter === void 0 ? false : _ref94$shouldFilter,
      onValueChange = _ref94.onValueChange,
      onOpenChange = _ref94.onOpenChange;
  var greaterThanLarge = usehooksTs.useMediaQuery(mediaQueries.lg);

  var _hooks$useControllabl7 = hooks.useControllableState({
    value: open,
    defaultValue: false,
    onValueChange: onOpenChange
  }),
      _hooks$useControllabl8 = _slicedToArray(_hooks$useControllabl7, 2),
      _commandSheetOpen = _hooks$useControllabl8[0],
      setCommandSheetOpen = _hooks$useControllabl8[1];

  var _hooks$useControllabl9 = hooks.useControllableState({
    value: open,
    defaultValue: false,
    onValueChange: onOpenChange
  }),
      _hooks$useControllabl10 = _slicedToArray(_hooks$useControllabl9, 2),
      _popoverOpen = _hooks$useControllabl10[0],
      setPopoverOpen = _hooks$useControllabl10[1];

  var commandSheetOpen = !greaterThanLarge ? _commandSheetOpen : false;
  var popoverOpen = greaterThanLarge ? _popoverOpen : false;

  var _triggerText = triggerText.length > 0 ? triggerText : (_items$find3 = items.find(function (item) {
    return item.value === value;
  })) === null || _items$find3 === void 0 ? void 0 : _items$find3.label;

  return /* @__PURE__ */jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/* @__PURE__ */jsxRuntime.jsx("div", {
      className: "w-full lg:hidden",
      children: /* @__PURE__ */jsxRuntime.jsxs(CommandSheet, {
        label: label,
        open: commandSheetOpen,
        value: value,
        onOpenChange: setCommandSheetOpen,
        onValueChange: onValueChange,
        children: [/* @__PURE__ */jsxRuntime.jsx(CommandSheetTrigger, {
          asChild: true,
          children: /* @__PURE__ */jsxRuntime.jsxs(HeaderButton, {
            className: "w-full [&>svg]:data-[state=open]:rotate-180",
            children: [_triggerText, /* @__PURE__ */jsxRuntime.jsx(SvgAngleDown, {
              className: "text-header-general-btn-text ml-auto -rotate-90 text-xl duration-200"
            })]
          })
        }), /* @__PURE__ */jsxRuntime.jsxs(CommandSheetContent, {
          children: [/* @__PURE__ */jsxRuntime.jsxs(InputGroup, {
            children: [/* @__PURE__ */jsxRuntime.jsx(InputLeftContent, {
              children: /* @__PURE__ */jsxRuntime.jsx(SvgSearch, {})
            }), /* @__PURE__ */jsxRuntime.jsx(CommandInput, {}), loading && /* @__PURE__ */jsxRuntime.jsx(Loading, {})]
          }), /* @__PURE__ */jsxRuntime.jsxs(CommandSheetList, {
            children: [/* @__PURE__ */jsxRuntime.jsx(CommandEmpty, {
              children: "No results found."
            }), items.map(function (item) {
              return /* @__PURE__ */jsxRuntime.jsxs(CommandSheetItem, {
                value: item.value,
                children: [/* @__PURE__ */jsxRuntime.jsx(SvgCheck, {
                  className: cn("stroke-primary text-xl opacity-0", {
                    "opacity-100": item.value.toLowerCase().trim() === (value === null || value === void 0 ? void 0 : value.toLowerCase().trim())
                  })
                }), item.label]
              }, item.value);
            })]
          })]
        })]
      })
    }), /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "hidden lg:block",
      children: /* @__PURE__ */jsxRuntime.jsxs(Popover, {
        open: popoverOpen,
        onOpenChange: setPopoverOpen,
        children: [/* @__PURE__ */jsxRuntime.jsx(PopoverTrigger, {
          asChild: true,
          children: /* @__PURE__ */jsxRuntime.jsxs(HeaderButton, {
            className: "[&>svg]:data-[state=open]:rotate-180",
            children: [_triggerText, /* @__PURE__ */jsxRuntime.jsx(SvgAngleDown, {
              className: "text-xl duration-200"
            })]
          })
        }), /* @__PURE__ */jsxRuntime.jsx(PopoverContent, {
          sideOffset: 12,
          children: /* @__PURE__ */jsxRuntime.jsxs(Command, {
            shouldFilter: shouldFilter,
            children: [/* @__PURE__ */jsxRuntime.jsxs(InputGroup, {
              children: [/* @__PURE__ */jsxRuntime.jsx(InputLeftContent, {
                children: /* @__PURE__ */jsxRuntime.jsx(SvgSearch, {})
              }), /* @__PURE__ */jsxRuntime.jsx(CommandInput, {
                className: "h-10"
              }), loading && /* @__PURE__ */jsxRuntime.jsx(Loading, {})]
            }), /* @__PURE__ */jsxRuntime.jsxs(CommandContent, {
              className: "-mr-2 p-0",
              children: [/* @__PURE__ */jsxRuntime.jsx(CommandEmpty, {
                children: "No results found."
              }), items.map(function (item) {
                return /* @__PURE__ */jsxRuntime.jsxs(CommandItem, {
                  className: cn("flex gap-1 aria-selected:bg-neutral-100", {
                    "text-primary": item.value.toLowerCase().trim() === value
                  }),
                  onSelect: function onSelect() {
                    setPopoverOpen(false);
                    onValueChange === null || onValueChange === void 0 || onValueChange(item.value);
                  },
                  children: [/* @__PURE__ */jsxRuntime.jsx(SvgCheck, {
                    className: cn("text-primary text-xl opacity-0", {
                      "opacity-100": item.value.toLowerCase().trim() === value
                    })
                  }), item.label]
                }, item.value);
              })]
            })]
          })
        })]
      })
    })]
  });
};

var _circle$2, _path$h, _circle2$2;

function _extends$h() {
  _extends$h = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$h.apply(this, arguments);
}

var SvgAvatarSignedOut = function SvgAvatarSignedOut(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$h({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 15,
    fill: "currentColor"
  })), _path$h || (_path$h = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9 25.847v-.001a8.102 8.102 0 0 1 8.1-8.104c4.474 0 8.1 3.628 8.1 8.104v.008A11.95 11.95 0 0 1 17.004 29c-3.124 0-5.97-1.195-8.104-3.153Z",
    fill: "#fff"
  })), _circle2$2 || (_circle2$2 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 17,
    cy: 13.699,
    r: 4.5,
    fill: "#fff"
  })));
};

var _path$g;

function _extends$g() {
  _extends$g = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$g.apply(this, arguments);
}

var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$g({
    width: "1em",
    height: "1em",
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.828 1.334 3 3.506 5.17 1.334",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var HeaderAvatar = React.forwardRef(function (_ref95, ref) {
  var label = _ref95.label,
      showCaret = _ref95.showCaret,
      isOpen = _ref95.isOpen;
  return /* @__PURE__ */jsxRuntime.jsxs("div", {
    ref: ref,
    className: "bg-primary relative flex h-8 w-8 items-center justify-center rounded-full text-lg font-extrabold text-white",
    children: [label !== null && label !== void 0 ? label : /* @__PURE__ */jsxRuntime.jsx(SvgAvatarSignedOut, {
      className: "text-primary text-3xl"
    }), showCaret && /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "absolute left-2/3 top-2/3 flex h-3 w-3 items-center justify-center rounded-full border-[1px] border-white bg-neutral-400",
      children: /* @__PURE__ */jsxRuntime.jsx(SvgChevron, {
        className: cn("text-[6px] text-neutral-800 transition-transform duration-300 ease-in-out", {
          "rotate-180": isOpen
        })
      })
    })]
  });
});
HeaderAvatar.displayName = "HeaderAvatar";
var HeaderUserAvatar = React.forwardRef(function (_ref96, ref) {
  var email = _ref96.email,
      name = _ref96.name,
      role = _ref96.role,
      isOpen = _ref96.isOpen,
      _ref96$displayField = _ref96.displayField,
      displayField = _ref96$displayField === void 0 ? "email" : _ref96$displayField;
  return /* @__PURE__ */jsxRuntime.jsxs("div", {
    ref: ref,
    className: "hidden gap-2 sm:flex",
    children: [/* @__PURE__ */jsxRuntime.jsxs("div", {
      className: "self-center text-right",
      children: [displayField === "email" ? email : name, role && /* @__PURE__ */jsxRuntime.jsx("div", {
        className: "text-xs text-gray-500",
        children: role
      })]
    }), /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "relative",
      children: /* @__PURE__ */jsxRuntime.jsx(HeaderAvatar, {
        label: name[0],
        showCaret: true,
        isOpen: isOpen
      })
    })]
  });
});
HeaderUserAvatar.displayName = "HeaderUserAvatar";
var PhoneInput = React.forwardRef(function (_ref97, ref) {
  var callingCode = _ref97.callingCode,
      id = _ref97.id,
      label = _ref97.label,
      onValueChange = _ref97.onValueChange,
      error = _ref97.error,
      props = _objectWithoutProperties(_ref97, _excluded78);

  return /* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
    error: error,
    children: [callingCode && /* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
      className: cn("!translate-y-2 whitespace-nowrap pt-0 text-base text-neutral-800 "),
      children: /* @__PURE__ */jsxRuntime.jsxs("span", {
        children: ["(", callingCode, ")"]
      })
    }), /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
      className: cn({
        "-translate-y-3 translate-x-0 scale-75": !!callingCode,
        "translate-x-0": !callingCode
      }),
      htmlFor: id,
      children: label
    }), /* @__PURE__ */jsxRuntime.jsx(FloatingInput, _objectSpread(_objectSpread({
      onValueChange: onValueChange,
      type: "tel",
      className: "pl-0",
      ref: ref
    }, props), {}, {
      id: id
    })), /* @__PURE__ */jsxRuntime.jsx(FloatingInputClearButton, {
      onClick: function onClick() {
        return onValueChange && onValueChange("");
      }
    })]
  });
});
PhoneInput.displayName = "PhoneInput";

var _path$f;

function _extends$f() {
  _extends$f = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$f.apply(this, arguments);
}

var SvgArrow$1 = function SvgArrow(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$f({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.05 9 11 13.95 15.95 9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ResponsiveCombobox = function ResponsiveCombobox(_ref98) {
  var _items$find$label2, _items$find5;

  var id = _ref98.id,
      inputValue = _ref98.inputValue,
      label = _ref98.label,
      items = _ref98.items,
      loading = _ref98.loading,
      icon = _ref98.icon,
      name = _ref98.name,
      error = _ref98.error,
      onValueChange = _ref98.onValueChange,
      onInputValueChange = _ref98.onInputValueChange,
      onBlur = _ref98.onBlur,
      _ref98$showMobileIcon = _ref98.showMobileIcon,
      showMobileIcon = _ref98$showMobileIcon === void 0 ? true : _ref98$showMobileIcon,
      _ref98$defaultValue = _ref98.defaultValue,
      defaultValue = _ref98$defaultValue === void 0 ? "" : _ref98$defaultValue,
      _ref98$shouldFilter = _ref98.shouldFilter,
      shouldFilter = _ref98$shouldFilter === void 0 ? true : _ref98$shouldFilter,
      inputRef = _ref98.inputRef,
      onOpenChange = _ref98.onOpenChange,
      open = _ref98.open;
  var greaterThenSmall = usehooksTs.useMediaQuery(mediaQueries.sm);

  var _React$useState23 = React.useState(defaultValue),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      value = _React$useState24[0],
      setValue = _React$useState24[1];

  var _React$useState25 = React.useState(defaultValue),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      _inputValue = _React$useState26[0],
      setInputValue = _React$useState26[1];

  var _hooks$useControllabl11 = hooks.useControllableState({
    value: open,
    defaultValue: false,
    onValueChange: onOpenChange
  }),
      _hooks$useControllabl12 = _slicedToArray(_hooks$useControllabl11, 2),
      _mobileOpen = _hooks$useControllabl12[0],
      setMobileOpen = _hooks$useControllabl12[1];

  var _hooks$useControllabl13 = hooks.useControllableState({
    value: open,
    defaultValue: false,
    onValueChange: onOpenChange
  }),
      _hooks$useControllabl14 = _slicedToArray(_hooks$useControllabl13, 2),
      _desktopOpen = _hooks$useControllabl14[0],
      setDesktopOpen = _hooks$useControllabl14[1];

  var _React$useState27 = React.useState(inputValue),
      _React$useState28 = _slicedToArray(_React$useState27, 2),
      previousInputValue = _React$useState28[0],
      setPreviousInputValue = _React$useState28[1];

  if (inputValue !== previousInputValue) {
    setPreviousInputValue(inputValue);
    setInputValue(inputValue !== null && inputValue !== void 0 ? inputValue : "");
  }

  var _items = shouldFilter ? items.filter(function (item) {
    return item.label.toLowerCase().includes(_inputValue.toLowerCase().trim());
  }) : items;

  var handleValueChange = function handleValueChange(value2) {
    var _items$find4;

    var inputValue2 = (_items$find4 = items.find(function (item) {
      return item.value.toLowerCase() === value2.toLowerCase();
    })) === null || _items$find4 === void 0 ? void 0 : _items$find4.label;
    inputValue2 && setInputValue(inputValue2);
    setValue(value2);
    onValueChange === null || onValueChange === void 0 || onValueChange(value2);
  };

  var handleInputValueChange = function handleInputValueChange(value2) {
    if (value2 === "") {
      setValue("");
      onValueChange === null || onValueChange === void 0 || onValueChange("");
    }

    setInputValue(value2);
    onInputValueChange === null || onInputValueChange === void 0 || onInputValueChange(value2);
  };

  var handleClearValue = function handleClearValue() {
    setInputValue("");
    onInputValueChange === null || onInputValueChange === void 0 || onInputValueChange("");
    onValueChange === null || onValueChange === void 0 || onValueChange("");
    setValue("");
  };

  var mobileOpen = !greaterThenSmall ? _mobileOpen : false;
  var desktopOpen = greaterThenSmall ? _desktopOpen : false;
  return reactDeviceDetect.isMobile ? /* @__PURE__ */jsxRuntime.jsxs(CommandSheet, {
    label: label,
    open: mobileOpen,
    value: value,
    onOpenChange: setMobileOpen,
    onValueChange: handleValueChange,
    children: [/* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
      focused: mobileOpen,
      error: error,
      children: [icon && /* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
        children: icon
      }), /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
        htmlFor: id,
        className: "pointer-events-none",
        children: label
      }), /* @__PURE__ */jsxRuntime.jsx(CommandSheetTrigger, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(FloatingInput, {
          ref: inputRef,
          id: id,
          value: value,
          asChild: true,
          children: /* @__PURE__ */jsxRuntime.jsx("button", {
            type: "button",
            className: "h-14 truncate text-left",
            children: (_items$find$label2 = (_items$find5 = items.find(function (item) {
              return item.label.toLowerCase() === value.toLowerCase();
            })) === null || _items$find5 === void 0 ? void 0 : _items$find5.label) !== null && _items$find$label2 !== void 0 ? _items$find$label2 : value || ""
          })
        })
      }), /* @__PURE__ */jsxRuntime.jsx("input", {
        type: "hidden",
        name: name,
        value: value
      })]
    }), /* @__PURE__ */jsxRuntime.jsxs(CommandSheetContent, {
      shouldFilter: shouldFilter,
      children: [/* @__PURE__ */jsxRuntime.jsxs(InputGroup, {
        children: [showMobileIcon && /* @__PURE__ */jsxRuntime.jsx(InputLeftContent, {
          children: icon
        }), /* @__PURE__ */jsxRuntime.jsx(CommandInput, {
          value: _inputValue,
          onValueChange: handleInputValueChange
        }), loading && /* @__PURE__ */jsxRuntime.jsx(Loading, {})]
      }), /* @__PURE__ */jsxRuntime.jsxs(CommandSheetList, {
        children: [items.length === 0 && /* @__PURE__ */jsxRuntime.jsx(CommandEmpty, {
          className: loading ? "invisible" : "visible",
          children: "No results found."
        }), items.map(function (item) {
          return /* @__PURE__ */jsxRuntime.jsxs(CommandSheetItem, {
            className: "flex gap-2",
            value: item.value,
            children: [item.icon && /* @__PURE__ */jsxRuntime.jsx("span", {
              className: "text-xl",
              children: item.icon
            }), item.label]
          }, item.value);
        })]
      })]
    })]
  }) : /* @__PURE__ */jsxRuntime.jsx(FloatingComboBox, {
    label: label,
    items: _items,
    value: value,
    inputValue: _inputValue,
    name: name,
    loading: loading,
    icon: icon,
    error: error,
    onValueChange: handleValueChange,
    onInputValueChange: handleInputValueChange,
    onBlur: onBlur,
    onClear: handleClearValue,
    open: desktopOpen,
    onOpenChange: setDesktopOpen,
    children: function children(item) {
      return /* @__PURE__ */jsxRuntime.jsxs(_ComboBoxItem, {
        id: item.value,
        textValue: item.label,
        children: [/* @__PURE__ */jsxRuntime.jsx("span", {
          className: "shrink-0 text-xl",
          children: item.icon
        }), item.label]
      });
    }
  });
};

var FloatingComboBox = function FloatingComboBox(_ref99) {
  var label = _ref99.label,
      description = _ref99.description,
      errorMessage = _ref99.errorMessage,
      children = _ref99.children,
      name = _ref99.name,
      loading = _ref99.loading,
      icon = _ref99.icon,
      onClear = _ref99.onClear,
      error = _ref99.error,
      props = _objectWithoutProperties(_ref99, _excluded79);

  var _useTranslation4 = useTranslation("ui:responsive-combo-box"),
      t = _useTranslation4.t;

  return /* @__PURE__ */jsxRuntime.jsxs(_ComboBox, _objectSpread(_objectSpread({}, props), {}, {
    menuTrigger: "focus",
    children: [/* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
      error: error,
      className: "relative w-full px-2",
      children: [icon && /* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
        className: "absolute left-2 shrink-0",
        children: icon
      }), /* @__PURE__ */jsxRuntime.jsx(_ComboBoxLabel, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
          children: label
        })
      }), /* @__PURE__ */jsxRuntime.jsx(_ComboBoxInput, {
        className: cn("pl-0 pt-6", {
          "pl-7": !!icon
        }),
        name: name,
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(FloatingInput, {})
      }), /* @__PURE__ */jsxRuntime.jsxs(FloatingInputRightContent, {
        className: "absolute right-0 flex gap-1 pr-2",
        children: [loading && /* @__PURE__ */jsxRuntime.jsx(Loading, {}), /* @__PURE__ */jsxRuntime.jsx(FloatingInputClearButton, {
          onClick: onClear
        }), /* @__PURE__ */jsxRuntime.jsx(_ComboBoxButton, {
          className: "group",
          children: /* @__PURE__ */jsxRuntime.jsx(SvgArrow$1, {
            className: "text-xl group-data-[pressed=true]:rotate-180"
          })
        })]
      })]
    }), /* @__PURE__ */jsxRuntime.jsx(_ComboBoxPopover, {
      className: loading ? "hidden" : "",
      children: /* @__PURE__ */jsxRuntime.jsx(_ComboBoxContent, {
        className: "pointer-events-auto",
        renderEmptyState: function renderEmptyState() {
          return /* @__PURE__ */jsxRuntime.jsx("p", {
            className: "px-4 py-2 text-gray-700",
            children: t("No results found.")
          });
        },
        children: children
      })
    })]
  }));
};

var linkVariants = classVarianceAuthority.cva("", {
  variants: {
    color: {
      primary: "text-primary hover:text-primary-400",
      secondary: "text-secondary hover:text-secondary-400",
      neutral: "text-neutral-800 hover:text-neutral-900",
      error: "text-error hover:text-error-400",
      warning: "text-warning hover:text-warning-400",
      success: "text-success hover:text-success-400"
    }
  },
  defaultVariants: {
    color: "primary"
  }
});
var Link = React.forwardRef(function (_ref100, ref) {
  var children = _ref100.children,
      className = _ref100.className,
      color = _ref100.color,
      target = _ref100.target,
      rel = _ref100.rel,
      others = _objectWithoutProperties(_ref100, _excluded80);

  var getRelation = function getRelation() {
    if (rel) {
      return rel;
    }

    if (target === "_blank") {
      return "noreferrer";
    }

    return void 0;
  };

  return /* @__PURE__ */jsxRuntime.jsx("a", _objectSpread(_objectSpread({
    ref: ref,
    className: cn("cursor-pointer duration-200 hover:underline", linkVariants({
      color: color
    }), className),
    target: target,
    rel: getRelation()
  }, others), {}, {
    children: children
  }));
});
Link.displayName = "Link";

var _path$e;

function _extends$e() {
  _extends$e = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$e.apply(this, arguments);
}

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 5 10",
    fill: "none"
  }, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m4.672 5.26.26-1.693H3.31V2.47c0-.463.227-.915.953-.915H5V.115S4.331 0 3.692 0C2.357 0 1.484.81 1.484 2.277v1.29H0V5.26h1.484v4.09a5.9 5.9 0 0 0 1.827 0V5.26h1.361Z",
    fill: "currentColor"
  })));
};

var _path$d, _path2$1, _path3;

function _extends$d() {
  _extends$d = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$d.apply(this, arguments);
}

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.003.848c1.337 0 1.495.006 2.02.028.49.02.753.098.929.162.232.085.4.188.574.351.176.166.284.323.374.542.068.165.15.415.172.874.023.497.029.646.029 1.903 0 1.258-.006 1.408-.03 1.903-.02.46-.103.708-.171.874-.09.219-.2.377-.374.54a1.551 1.551 0 0 1-.574.352c-.176.065-.442.142-.928.162-.528.022-.686.028-2.021.028-1.337 0-1.495-.006-2.02-.028-.49-.02-.753-.097-.93-.162a1.56 1.56 0 0 1-.574-.351 1.444 1.444 0 0 1-.373-.541c-.068-.166-.15-.416-.172-.874-.023-.497-.03-.646-.03-1.903 0-1.26.007-1.408.03-1.903.022-.46.104-.709.172-.874.09-.22.2-.378.373-.542.176-.165.342-.266.575-.351.176-.064.442-.142.928-.162.526-.022.684-.028 2.02-.028Zm0-.848C3.645 0 3.475.006 2.94.028 2.41.05 2.044.13 1.728.247c-.33.121-.61.281-.888.544a2.3 2.3 0 0 0-.578.834c-.123.3-.21.642-.233 1.143C.006 3.272 0 3.432 0 4.71c0 1.28.006 1.44.03 1.942.023.5.109.845.232 1.143.129.31.299.574.578.835.278.262.557.424.886.543.318.116.682.197 1.213.22.534.021.704.027 2.062.027 1.358 0 1.528-.006 2.062-.028.531-.022.897-.103 1.213-.219.329-.12.608-.281.886-.543.277-.261.45-.524.576-.833.123-.3.21-.643.233-1.143.023-.503.029-.663.029-1.942s-.006-1.439-.03-1.941c-.023-.501-.109-.845-.232-1.143A2.196 2.196 0 0 0 9.166.79 2.466 2.466 0 0 0 8.28.248C7.962.133 7.598.052 7.067.03 6.53.006 6.36 0 5.003 0Z",
    fill: "currentColor"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5 1.883c-1.656 0-3 1.266-3 2.826s1.344 2.826 3 2.826S8 6.27 8 4.71 6.656 1.883 5 1.883Zm0 4.66c-1.075 0-1.946-.822-1.946-1.834S3.925 2.876 5 2.876s1.946.82 1.946 1.833c0 1.012-.871 1.833-1.946 1.833Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8 2.354c0 .26-.225.47-.5.47-.277 0-.5-.21-.5-.47 0-.261.225-.471.5-.471s.5.212.5.47Z",
    fill: "currentColor"
  })));
};

var _path$c;

function _extends$c() {
  _extends$c = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$c.apply(this, arguments);
}

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "none"
  }, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.262 0H.738a.762.762 0 0 0-.522.204A.676.676 0 0 0 0 .695v8.03c0 .185.078.362.216.492.139.13.326.204.522.204h8.524a.762.762 0 0 0 .522-.204.676.676 0 0 0 .216-.492V.695a.676.676 0 0 0-.216-.491A.762.762 0 0 0 9.262 0ZM2.98 8.025H1.477V3.526h1.504v4.5Zm-.753-5.122a.901.901 0 0 1-.479-.14.825.825 0 0 1-.315-.366.77.77 0 0 1-.047-.47.8.8 0 0 1 .237-.414.881.881 0 0 1 .442-.221.913.913 0 0 1 .499.047.854.854 0 0 1 .386.3.78.78 0 0 1 .082.765.8.8 0 0 1-.188.266.857.857 0 0 1-.284.176.897.897 0 0 1-.333.057Zm6.294 5.126H7.02V5.571c0-.725-.327-.948-.749-.948-.446 0-.883.316-.883.967v2.44H3.883v-4.5H5.33v.623h.02c.145-.277.653-.75 1.429-.75.839 0 1.745.47 1.745 1.843V8.03Z",
    fill: "currentColor"
  })));
};

var Footer = function Footer(props) {
  var _useTranslation5 = useTranslation("ui:footer"),
      t = _useTranslation5.t;

  var defaultProps = {
    logo: {
      src: "https://static.mozio.com/assets/logo.svg",
      alt: "Mozio logo",
      href: "/"
    },
    socials: [{
      href: "https://www.linkedin.com/company/mozio/",
      icon: /* @__PURE__ */jsxRuntime.jsx(SvgLinkedin, {})
    }, {
      href: "https://www.facebook.com/letsmozio/",
      icon: /* @__PURE__ */jsxRuntime.jsx(SvgFacebook, {})
    }, {
      href: "https://www.instagram.com/letsmozio/",
      icon: /* @__PURE__ */jsxRuntime.jsx(SvgInstagram, {})
    }],
    copyRight: t("2025 Mozio Inc. Trademarks and brands are property of their respective owners.")
  };
  var className = props.className,
      navLinks = props.navLinks,
      legalLinks = props.legalLinks,
      _props$socials = props.socials,
      socials = _props$socials === void 0 ? defaultProps.socials : _props$socials,
      _props$logo = props.logo,
      logo = _props$logo === void 0 ? defaultProps.logo : _props$logo,
      _props$copyRight = props.copyRight,
      copyRight = _props$copyRight === void 0 ? defaultProps.copyRight : _props$copyRight;

  var renderLogoAndSocials = function renderLogoAndSocials() {
    return /* @__PURE__ */jsxRuntime.jsxs("div", {
      className: "flex items-center justify-center gap-2 md:justify-start",
      children: [/* @__PURE__ */jsxRuntime.jsx("a", {
        className: "hover:bg-primary-100 duration-200",
        href: logo.href,
        children: /* @__PURE__ */jsxRuntime.jsx("img", {
          className: "h-6",
          src: logo.src,
          alt: logo.alt
        })
      }), socials.map(function (social) {
        return /* @__PURE__ */jsxRuntime.jsx("a", {
          className: "grid h-5 w-5 place-items-center rounded-full bg-neutral-800 text-xs text-white duration-200 hover:bg-neutral-900",
          href: social.href,
          target: "_blank",
          rel: "noreferrer",
          children: social.icon
        }, social.href);
      })]
    });
  };

  var renderNavLinks = function renderNavLinks() {
    return /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "flex flex-wrap justify-center gap-x-7 gap-y-4 md:justify-end",
      children: navLinks.map(function (link) {
        return /* @__PURE__ */jsxRuntime.jsx(Link, {
          color: "primary",
          href: link.href,
          children: link.content
        }, link.href);
      })
    });
  };

  var renderLegalLinks = function renderLegalLinks() {
    return /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "flex justify-center gap-x-4 text-xs",
      children: legalLinks.map(function (_ref101) {
        var content = _ref101.content,
            href = _ref101.href;
        return /* @__PURE__ */jsxRuntime.jsx(Link, {
          color: "neutral",
          href: href,
          target: "_blank",
          children: content
        }, href);
      })
    });
  };

  var renderCopyRight = function renderCopyRight() {
    return /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "text-xs text-neutral-800",
      children: copyRight
    });
  };

  return /* @__PURE__ */jsxRuntime.jsxs("footer", {
    className: cn("mx-auto mt-auto w-full py-14 text-sm text-gray-500", className),
    children: [/* @__PURE__ */jsxRuntime.jsxs(Container, {
      className: "grid max-w-full gap-4 text-center md:hidden",
      children: [renderLogoAndSocials(), renderNavLinks(), renderLegalLinks(), renderCopyRight()]
    }), /* @__PURE__ */jsxRuntime.jsxs(Container, {
      className: "hidden max-w-full gap-4 md:grid",
      children: [/* @__PURE__ */jsxRuntime.jsxs("div", {
        className: "grid grid-cols-[auto_1fr] gap-8",
        children: [/* @__PURE__ */jsxRuntime.jsx("div", {
          className: "grid gap-4",
          children: renderLogoAndSocials()
        }), /* @__PURE__ */jsxRuntime.jsx("div", {
          children: renderNavLinks()
        })]
      }), /* @__PURE__ */jsxRuntime.jsxs("div", {
        className: "flex items-end justify-between",
        children: [renderCopyRight(), renderLegalLinks()]
      })]
    })]
  });
};

var ensureKeyEqualValue = function ensureKeyEqualValue(langs) {
  Object.keys(langs).forEach(function (k) {
    return langs[k].value = k;
  });
  return langs;
};

var LANGUAGES = ensureKeyEqualValue({
  "en-us": {
    name: "English",
    englishName: "English",
    value: "en-us",
    intl: "en",
    code: "us",
    zendeskLocale: "en-us"
  },
  "de-de": {
    name: "Deutsch",
    englishName: "German",
    value: "de-de",
    intl: "de",
    moment: "de",
    code: "de",
    zendeskLocale: "de"
  },
  "ja-jp": {
    name: "\u65E5\u672C\u8A9E",
    englishName: "Japanese",
    value: "ja-jp",
    intl: "ja",
    code: "jp",
    zendeskLocale: "ja"
  },
  nl: {
    name: "Dutch",
    englishName: "Dutch",
    value: "nl",
    intl: "nl",
    moment: "nl",
    code: "nl",
    zendeskLocale: "nl"
  },
  "pt-br": {
    name: "Portugu\xEAs",
    englishName: "Portuguese",
    value: "pt-br",
    intl: "pt",
    moment: "pt",
    code: "br",
    zendeskLocale: "pt-br"
  },
  es: {
    name: "Espa\xF1ol",
    englishName: "Spanish",
    value: "es",
    intl: "es",
    moment: "es",
    code: "es",
    zendeskLocale: "es"
  },
  fr: {
    name: "Fran\xE7ais",
    englishName: "French",
    value: "fr",
    intl: "fr",
    moment: "fr",
    code: "fr",
    zendeskLocale: "fr"
  },
  "id-id": {
    name: "Bahasa Indonesia",
    englishName: "Indonesian",
    value: "id-id",
    intl: "en",
    code: "id",
    zendeskLocale: "en-us"
  },
  "it-it": {
    name: "Italiano",
    englishName: "Italian",
    value: "it-it",
    intl: "it",
    moment: "it",
    code: "it",
    zendeskLocale: "it"
  },
  pl: {
    name: "Polski",
    englishName: "Polish",
    value: "pl",
    intl: "pl",
    moment: "pl",
    code: "pl",
    zendeskLocale: "pl"
  },
  sv: {
    name: "Svenska",
    englishName: "Swedish",
    value: "sv",
    intl: "sv",
    moment: "sv",
    code: "sv",
    zendeskLocale: "sv"
  },
  "ru-ru": {
    name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    englishName: "Russian",
    value: "ru-ru",
    intl: "ru",
    moment: "ru",
    code: "ru",
    zendeskLocale: "ru"
  },
  "vi-vn": {
    name: "ti\u1EBFng Vi\u1EC7t",
    englishName: "Vietnamese",
    value: "vi-vn",
    intl: "vi",
    code: "vn",
    zendeskLocale: "vi"
  },
  "zh-cn": {
    name: "\u7B80\u4F53\u4E2D\u6587",
    englishName: "Simplified Chinese",
    value: "zh-cn",
    intl: "zh",
    code: "cn",
    zendeskLocale: "zh-cn"
  },
  "zh-tw": {
    name: "\u6B63\u9AD4\u4E2D\u6587",
    englishName: "Traditional Chinese",
    value: "zh-tw",
    intl: "zh",
    code: "tw",
    zendeskLocale: "zh-tw"
  },
  "ko-kr": {
    name: "\uD55C\uAD6D\uC778",
    englishName: "Korean",
    value: "ko-kr",
    intl: "ko",
    code: "kr",
    zendeskLocale: "ko"
  },
  "th-th": {
    name: "\u0E44\u0E17\u0E22",
    englishName: "Thai",
    value: "th-th",
    intl: "en",
    code: "th",
    zendeskLocale: "en-us"
  }
});

var LocaleInput = function LocaleInput(_ref102) {
  var onValueChange = _ref102.onValueChange,
      value = _ref102.value,
      props = _objectWithoutProperties(_ref102, _excluded81);

  var _reactI18next$useTran2 = reactI18next.useTranslation(),
      i18n = _reactI18next$useTran2.i18n;

  var getLabel = function getLabel(language) {
    return i18n.language === "en-us" ? "".concat(language.name).concat(language.englishName === "English" ? "" : " (".concat(language.englishName, ")")) : language.name;
  };

  var languages = Object.values(LANGUAGES).map(function (l) {
    return _objectSpread(_objectSpread({}, l), {}, {
      label: getLabel(l),
      icon: /* @__PURE__ */jsxRuntime.jsx(Flag, {
        className: "w-5",
        country: l.code.toUpperCase()
      })
    });
  });

  var findLanguage = function findLanguage(value2) {
    return languages.find(function (locale) {
      return locale.value === value2 || locale.name.toLowerCase() === value2;
    });
  };

  var selectedLocale = findLanguage(value);

  var handleValueChange = function handleValueChange(displayText) {
    if (displayText.length === 0) {
      onValueChange === null || onValueChange === void 0 || onValueChange(null);
      return;
    }

    var localeData = findLanguage(displayText);

    if (!localeData) {
      console.error("Locale not found for displayText: ".concat(displayText, ". This should not happen."));
      return;
    }

    onValueChange === null || onValueChange === void 0 || onValueChange(localeData.value);
  };

  return /* @__PURE__ */jsxRuntime.jsx(ResponsiveCombobox, _objectSpread(_objectSpread({}, props), {}, {
    items: languages,
    showMobileIcon: false,
    defaultValue: selectedLocale === null || selectedLocale === void 0 ? void 0 : selectedLocale.name,
    onValueChange: handleValueChange,
    icon: selectedLocale ? /* @__PURE__ */jsxRuntime.jsx(Flag, {
      className: "w-5",
      country: selectedLocale.code.toUpperCase()
    }) : // TODO: Check with designer an icon when no value is selected

    /* @__PURE__ */
    jsxRuntime.jsx("span", {
      className: "w-5 text-center",
      children: "+"
    })
  }));
};

var _path$b;

function _extends$b() {
  _extends$b = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$b.apply(this, arguments);
}

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.95 13 11 8.05 6.05 13",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$a, _path2;

function _extends$a() {
  _extends$a = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$a.apply(this, arguments);
}

var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11 4v1M11 17v1M4 11h1M17 11h1M6 6l1 1M6 16l1-1M15 7l1-1M11 7v4.253L16 16",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var TimePicker = function TimePicker(_ref103) {
  var open = _ref103.open,
      value = _ref103.value,
      id = _ref103.id,
      label = _ref103.label,
      placeholder = _ref103.placeholder,
      name = _ref103.name,
      error = _ref103.error,
      onValueChange = _ref103.onValueChange,
      onDone = _ref103.onDone,
      onOpenChange = _ref103.onOpenChange;

  var _useTranslation6 = useTranslation("ui:time-picker"),
      t = _useTranslation6.t;

  return reactDeviceDetect.isMobile ? /* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
    error: error,
    children: [/* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
      children: /* @__PURE__ */jsxRuntime.jsx(SvgTime, {})
    }), /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
      htmlFor: id,
      children: label
    }), /* @__PURE__ */jsxRuntime.jsx(FloatingInput, {
      id: id,
      name: name,
      placeholder: placeholder,
      value: convertValueObjectToString(value),
      type: "time",
      className: "h-14 opacity-0",
      onChange: function onChange(event) {
        var value2 = event.target.value;

        if (!value2) {
          return;
        }

        var _value2$split = value2.split(":"),
            _value2$split2 = _slicedToArray(_value2$split, 2),
            hour = _value2$split2[0],
            minute = _value2$split2[1];

        onValueChange === null || onValueChange === void 0 || onValueChange(new date.Time(hour ? Number.parseInt(hour) : 0, minute ? Number.parseInt(minute) : 0));
      }
    }), value && /* @__PURE__ */jsxRuntime.jsx("p", {
      className: "pointer-events-none absolute left-8 top-6",
      children: getTriggerText(value)
    })]
  }) : /* @__PURE__ */jsxRuntime.jsxs(Popover, {
    open: open,
    onOpenChange: onOpenChange,
    children: [/* @__PURE__ */jsxRuntime.jsxs(FloatingInputGroup, {
      focused: open,
      error: error,
      children: [/* @__PURE__ */jsxRuntime.jsx(FloatingInputLeftContent, {
        children: /* @__PURE__ */jsxRuntime.jsx(SvgTime, {
          className: cn({
            "text-primary": open
          })
        })
      }), /* @__PURE__ */jsxRuntime.jsx(FloatingLabel, {
        className: "pointer-events-none",
        htmlFor: id,
        children: label
      }), /* @__PURE__ */jsxRuntime.jsx(PopoverTrigger, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(FloatingInput, {
          name: name,
          value: getTriggerText(value),
          asChild: true,
          children: /* @__PURE__ */jsxRuntime.jsx("button", {
            type: "button",
            className: "h-14 text-left",
            children: getTriggerText(value)
          })
        })
      }), /* @__PURE__ */jsxRuntime.jsx("input", {
        type: "hidden",
        id: id,
        name: name,
        value: getTriggerText(value)
      })]
    }), /* @__PURE__ */jsxRuntime.jsxs(PopoverContent, {
      className: "w-72 px-2 pb-2 pt-4",
      children: [/* @__PURE__ */jsxRuntime.jsx(TimeField, {
        steps: {
          minute: 10
        },
        value: value,
        onValueChange: onValueChange,
        "aria-label": "Time-picker"
      }), /* @__PURE__ */jsxRuntime.jsx(PopoverClose, {
        asChild: true,
        children: /* @__PURE__ */jsxRuntime.jsx(Button, {
          className: "w-full",
          onClick: onDone,
          children: t("Done")
        })
      })]
    })]
  });
};

TimePicker.displayName = "TimePicker";

var convertValueObjectToString = function convertValueObjectToString(value) {
  if (!value) {
    return "";
  }

  var hour = value.hour,
      minute = value.minute;
  var formattedHour = hour < 10 ? "0".concat(hour) : hour !== null && hour !== void 0 ? hour : "--";
  var formattedMinute = minute < 10 ? "0".concat(minute) : minute !== null && minute !== void 0 ? minute : "--";
  return "".concat(formattedHour, ":").concat(formattedMinute);
};

var getTriggerText = function getTriggerText(value) {
  if (!value) {
    return "";
  }

  var hour = value.hour,
      minute = value.minute;
  var formattedHour = hour === 0 || hour === 12 ? 12 : hour % 12;
  var formattedMinute = minute < 10 ? "0".concat(minute) : minute;
  var period = hour >= 12 ? "PM" : "AM";
  return "".concat(formattedHour, ":").concat(formattedMinute, " ").concat(period);
};

var TimeField = function TimeField(props) {
  var _props$value;

  var state = reactStately.useTimeFieldState(_objectSpread(_objectSpread({}, props), {}, {
    onChange: props.onValueChange,
    value: (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : null,
    locale: "en-us"
  }));
  var ref = React.useRef(null);
  var steps = props.steps;
  var hasSteps = steps && Object.keys(steps).length > 0;
  var stateIncrementOriginal = state.increment;
  var stateDecrementOriginal = state.decrement;

  var stepValue = function stepValue(operation) {
    return function (type) {
      var _steps$type;

      if (type === "dayPeriod") {
        if (operation === "increment") {
          stateIncrementOriginal(type);
        }

        if (operation === "decrement") {
          stateDecrementOriginal(type);
        }

        return;
      }

      var step = (_steps$type = steps === null || steps === void 0 ? void 0 : steps[type]) !== null && _steps$type !== void 0 ? _steps$type : 1;
      var multiplier = operation === "increment" ? 1 : -1;

      if (state.value) {
        var dateValue = state.value.cycle(type, multiplier * step, {
          round: true
        });
        state.setValue(dateValue);
      }

      if (!state.value) {
        var segment = state.segments.find(function (s) {
          return s.type === type;
        });
        var segmentValue = 0;

        if (!(segment !== null && segment !== void 0 && segment.isPlaceholder) || (segment === null || segment === void 0 ? void 0 : segment.value) !== 0) {
          var time = new date.Time().set(_defineProperty({}, type, segment === null || segment === void 0 ? void 0 : segment.value)).cycle(type, multiplier * step, {
            round: true
          });
          segmentValue = time[type];
        }

        state.setSegment(type, segmentValue);
      }
    };
  };

  if (hasSteps) {
    state.increment = stepValue("increment");
    state.decrement = stepValue("decrement");
  }

  var _reactAria$useTimeFie = reactAria.useTimeField(_objectSpread(_objectSpread({}, props), {}, {
    onBlur: function onBlur(event) {
      var onBlur = props.onBlur;
      onBlur && onBlur(event);

      if (hasSteps && state.value) {
        var steppedValue = state.value.copy();
        Object.entries(steps).forEach(function (_ref104) {
          var _ref105 = _slicedToArray(_ref104, 2),
              type = _ref105[0],
              step = _ref105[1];

          if (state.value[type] % step !== 0) {
            steppedValue = steppedValue.cycle(type, step, {
              round: true
            });
          }
        });

        if (steppedValue.compare(state.value) !== 0) {
          state.setValue(steppedValue);
        }
      }
    }
  }), state, ref),
      fieldProps = _reactAria$useTimeFie.fieldProps;

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread(_objectSpread({}, fieldProps), {}, {
    ref: ref,
    className: "mb-4 flex items-center justify-center gap-1",
    children: state.segments.map(function (segment) {
      return segment.type !== "literal" && /* @__PURE__ */jsxRuntime.jsx(DateSegment, {
        segment: segment,
        state: state
      }, segment.type);
    })
  }));
};

var DateSegment = function DateSegment(_ref106) {
  var segment = _ref106.segment,
      state = _ref106.state;
  var ref = React.useRef(null);

  var _reactAria$useDateSeg = reactAria.useDateSegment(segment, state, ref),
      segmentProps = _reactAria$useDateSeg.segmentProps;

  var handleUp = function handleUp() {
    state.increment(segment.type);
  };

  var handleDown = function handleDown() {
    state.decrement(segment.type);
  };

  return /* @__PURE__ */jsxRuntime.jsxs("div", _objectSpread(_objectSpread({}, segmentProps), {}, {
    className: "group/segment flex flex-col items-center outline-none",
    ref: ref,
    children: [/* @__PURE__ */jsxRuntime.jsx(IconButton, {
      tabIndex: -1,
      variant: BUTTON_VARIANT.GHOST,
      size: BUTTON_SIZE.LG,
      onClick: handleUp,
      "aria-hidden": true,
      onFocus: function onFocus() {
        return ref.current && ref.current.focus();
      },
      children: /* @__PURE__ */jsxRuntime.jsx(SvgArrow, {})
    }), /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "group-focus-within/segment:border-primary my-3 flex h-14 w-14 items-center justify-center rounded-md border border-neutral-200 p-1 px-2 outline-none",
      children: /* @__PURE__ */jsxRuntime.jsx("span", {
        className: "w-full rounded-md p-1 text-center",
        children: segment.text
      })
    }), /* @__PURE__ */jsxRuntime.jsx(IconButton, {
      onClick: handleDown,
      variant: BUTTON_VARIANT.GHOST,
      size: BUTTON_SIZE.LG,
      tabIndex: -1,
      "aria-hidden": true,
      onFocus: function onFocus() {
        return ref.current && ref.current.focus();
      },
      children: /* @__PURE__ */jsxRuntime.jsx(SvgArrow, {
        className: "rotate-180"
      })
    })]
  }));
};

var RadioButtonGroup = React.forwardRef(function (_ref107, ref) {
  var className = _ref107.className,
      props = _objectWithoutProperties(_ref107, _excluded82);

  return /* @__PURE__ */jsxRuntime.jsx(RadioGroupPrimitive__namespace.Root, _objectSpread(_objectSpread({
    className: cn("flex flex-nowrap gap-2", "sm:gap-0", className)
  }, props), {}, {
    ref: ref
  }));
});
RadioButtonGroup.displayName = RadioGroupPrimitive__namespace.Root.displayName;
var RadioButtonGroupItem = React.forwardRef(function (_ref108, ref) {
  var className = _ref108.className,
      props = _objectWithoutProperties(_ref108, _excluded83);

  return /* @__PURE__ */jsxRuntime.jsx(RadioGroupPrimitive__namespace.Item, _objectSpread({
    ref: ref,
    className: cn("group/item flex w-full flex-nowrap gap-x-2 whitespace-nowrap rounded-md border border-neutral-200 bg-white px-1.5 py-1 text-neutral-800 duration-200", "data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-contrast", "sm:rounded-none sm:px-5 sm:first-of-type:rounded-bl-md sm:first-of-type:rounded-tl-md sm:last-of-type:rounded-br-md sm:last-of-type:rounded-tr-md ", "disabled:cursor-not-allowed disabled:opacity-50", className)
  }, props));
});
RadioButtonGroupItem.displayName = RadioGroupPrimitive__namespace.Item.displayName;
var RadioGroup = React__namespace.forwardRef(function (_ref109, ref) {
  var className = _ref109.className,
      props = _objectWithoutProperties(_ref109, _excluded84);

  return /* @__PURE__ */jsxRuntime.jsx(RadioGroupPrimitive__namespace.Root, _objectSpread(_objectSpread({
    className: cn("grid gap-2", className)
  }, props), {}, {
    ref: ref
  }));
});
RadioGroup.displayName = RadioGroupPrimitive__namespace.Root.displayName;
var RadioGroupItem = React__namespace.forwardRef(function (_ref110, ref) {
  var className = _ref110.className,
      props = _objectWithoutProperties(_ref110, _excluded85);

  return /* @__PURE__ */jsxRuntime.jsx(RadioGroupPrimitive__namespace.Item, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("text-primary ring-offset-background focus-visible:ring-ring data-[state=checked]:border-primary data-[state=checked]:bg-primary flex aspect-square h-4 w-4 min-w-[1rem] items-center justify-center rounded-full border border-neutral-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className)
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntime.jsx(RadioGroupPrimitive__namespace.Indicator, {
      className: "data-[state=checked]:bg-primary-contrast flex h-1.5 w-1.5 items-center justify-center rounded-full"
    })
  }));
});
RadioGroupItem.displayName = RadioGroupPrimitive__namespace.Item.displayName;
var ScrollArea = React.forwardRef(function (_ref111, ref) {
  var className = _ref111.className,
      children = _ref111.children,
      props = _objectWithoutProperties(_ref111, _excluded86);

  return /* @__PURE__ */jsxRuntime.jsxs(ScrollAreaPrimitive__namespace.Root, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("relative overflow-hidden", className)
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntime.jsx(ScrollAreaPrimitive__namespace.Viewport, {
      className: "h-full w-full rounded-[inherit]",
      children: children
    }), /* @__PURE__ */jsxRuntime.jsx(ScrollBar, {}), /* @__PURE__ */jsxRuntime.jsx(ScrollAreaPrimitive__namespace.Corner, {})]
  }));
});
ScrollArea.displayName = ScrollAreaPrimitive__namespace.Root.displayName;
var ScrollBar = React.forwardRef(function (_ref112, ref) {
  var className = _ref112.className,
      _ref112$orientation = _ref112.orientation,
      orientation = _ref112$orientation === void 0 ? "horizontal" : _ref112$orientation,
      props = _objectWithoutProperties(_ref112, _excluded87);

  return /* @__PURE__ */jsxRuntime.jsx(ScrollAreaPrimitive__namespace.ScrollAreaScrollbar, _objectSpread(_objectSpread({
    ref: ref,
    orientation: orientation,
    className: cn("flex touch-none select-none transition-colors", orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]", orientation === "horizontal" && "h-2.5 border-t border-t-transparent p-[1px]", className)
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntime.jsx(ScrollAreaPrimitive__namespace.ScrollAreaThumb, {
      className: "bg-border relative flex-1 rounded-full"
    })
  }));
});
ScrollBar.displayName = ScrollAreaPrimitive__namespace.ScrollAreaScrollbar.displayName;
var TooltipTrigger = TooltipPrimitive__namespace.Trigger;

var Tooltip = function Tooltip(_ref113) {
  var children = _ref113.children,
      props = _objectWithoutProperties(_ref113, _excluded88);

  return /* @__PURE__ */jsxRuntime.jsx(TooltipPrimitive__namespace.Provider, {
    children: /* @__PURE__ */jsxRuntime.jsx(TooltipPrimitive__namespace.Root, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

var TooltipContent = React.forwardRef(function (_ref114, ref) {
  var className = _ref114.className,
      _ref114$side = _ref114.side,
      side = _ref114$side === void 0 ? "top" : _ref114$side,
      _ref114$sideOffset = _ref114.sideOffset,
      sideOffset = _ref114$sideOffset === void 0 ? 4 : _ref114$sideOffset,
      children = _ref114.children,
      props = _objectWithoutProperties(_ref114, _excluded89);

  return /* @__PURE__ */jsxRuntime.jsx(TooltipPrimitive__namespace.Portal, {
    children: /* @__PURE__ */jsxRuntime.jsxs(TooltipPrimitive__namespace.Content, _objectSpread(_objectSpread({
      ref: ref,
      side: side,
      sideOffset: sideOffset,
      className: cn("data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95", "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", "bg-primary-500 max-w-[180px] rounded px-2 py-1 text-center text-sm text-white shadow-md", className)
    }, props), {}, {
      children: [/* @__PURE__ */jsxRuntime.jsx(TooltipPrimitive__namespace.Arrow, {
        className: "fill-primary-500"
      }), children]
    }))
  });
});
TooltipContent.displayName = TooltipPrimitive__namespace.Content.displayName;

var _path$9;

function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$9.apply(this, arguments);
}

var SvgAlert$1 = function SvgAlert(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3a6 6 0 0 0-6 6v6a6 6 0 0 0 6 6h6a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6H9Zm2 5a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V8Zm0 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
    fill: "currentColor"
  })));
};

var _circle$1, _path$8, _circle2$1;

function _extends$8() {
  _extends$8 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$8.apply(this, arguments);
}

var SvgInfo$1 = function SvgInfo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11 11h1v6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2$1 || (_circle2$1 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1,
    fill: "currentColor"
  })));
};

var _path$7;

function _extends$7() {
  _extends$7 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$7.apply(this, arguments);
}

var SvgSuccess$1 = function SvgSuccess(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18ZM5.327 8.92a1 1 0 1 0-1.414 1.415l2.962 2.962a1 1 0 0 0 1.415 0L14.087 7.5a1 1 0 0 0-1.414-1.415l-5.09 5.09-2.256-2.254Z",
    fill: "currentColor"
  })));
};

var _path$6;

function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$6.apply(this, arguments);
}

var SvgTimes$1 = function SvgTimes(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M16.365 16.434 5.638 5.707M5.638 16.305 16.365 5.578"
  })));
};

var ICONS$1 = {
  primary: /* @__PURE__ */jsxRuntime.jsx(SvgInfo$1, {
    className: "text-primary"
  }),
  secondary: /* @__PURE__ */jsxRuntime.jsx(SvgInfo$1, {
    className: "text-secondary-400"
  }),
  neutral: /* @__PURE__ */jsxRuntime.jsx(SvgInfo$1, {
    className: "text-neutral-700"
  }),
  warning: /* @__PURE__ */jsxRuntime.jsx(SvgInfo$1, {
    className: "text-warning-700"
  }),
  error: /* @__PURE__ */jsxRuntime.jsx(SvgAlert$1, {
    className: "text-error-300"
  }),
  success: /* @__PURE__ */jsxRuntime.jsx(SvgSuccess$1, {
    className: "text-success-300"
  })
};
var alertVariants = classVarianceAuthority.cva("inline-flex w-max rounded-md border px-2 py-2 text-xs font-normal items-start gap-1", {
  variants: {
    variant: {
      primary: "border-transparent bg-primary-100 text-primary-400",
      secondary: "border-transparent bg-secondary-100 text-secondary-400",
      error: "border-transparent bg-error-100 text-error-400 ",
      success: "border-transparent bg-success-100 text-success-400",
      warning: "border-transparent bg-warning-100 text-warning-400",
      neutral: "border-transparent bg-neutral-100 text-neutral-800"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
});
var Alert = React.forwardRef(function (_ref115, ref) {
  var className = _ref115.className,
      variant = _ref115.variant,
      onClose = _ref115.onClose,
      props = _objectWithoutProperties(_ref115, _excluded90);

  return /* @__PURE__ */jsxRuntime.jsxs("div", _objectSpread(_objectSpread({
    ref: ref,
    className: cn(alertVariants({
      variant: variant
    }), className)
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntime.jsx("div", {
      className: "text-lg",
      children: ICONS$1[variant || "primary"]
    }), props.children, onClose && /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "ml-auto cursor-pointer text-lg",
      children: /* @__PURE__ */jsxRuntime.jsx(SvgTimes$1, {
        onClick: onClose
      })
    })]
  }));
});
Alert.displayName = "Alert";
var NavigationMenu = React__namespace.forwardRef(function (_ref116, ref) {
  var className = _ref116.className,
      children = _ref116.children,
      props = _objectWithoutProperties(_ref116, _excluded91);

  return /* @__PURE__ */jsxRuntime.jsxs(NavigationMenuPrimitive__namespace.Root, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("relative z-10 flex flex-1 items-center justify-center [&>div]:w-full", className)
  }, props), {}, {
    children: [children, /* @__PURE__ */jsxRuntime.jsx(NavigationMenuViewport, {})]
  }));
});
NavigationMenu.displayName = NavigationMenuPrimitive__namespace.Root.displayName;
var NavigationMenuList = React__namespace.forwardRef(function (_ref117, ref) {
  var className = _ref117.className,
      props = _objectWithoutProperties(_ref117, _excluded92);

  return /* @__PURE__ */jsxRuntime.jsx(NavigationMenuPrimitive__namespace.List, _objectSpread({
    ref: ref,
    className: cn("group flex flex-1 list-none flex-col items-start justify-center space-x-0", className)
  }, props));
});
NavigationMenuList.displayName = NavigationMenuPrimitive__namespace.List.displayName;
var NavigationMenuItem = React__namespace.forwardRef(function (_ref118, ref) {
  var className = _ref118.className,
      props = _objectWithoutProperties(_ref118, _excluded93);

  return /* @__PURE__ */jsxRuntime.jsx(NavigationMenuPrimitive__namespace.Item, _objectSpread({
    ref: ref,
    className: cn("group flex w-full flex-1 items-center justify-start gap-2", className)
  }, props));
});
NavigationMenuItem.displayName = NavigationMenuPrimitive__namespace.Item.displayName;
var NavigationMenuLink = React__namespace.forwardRef(function (_ref119, ref) {
  var className = _ref119.className,
      props = _objectWithoutProperties(_ref119, _excluded94);

  return /* @__PURE__ */jsxRuntime.jsx(NavigationMenuPrimitive__namespace.Link, _objectSpread({
    ref: ref,
    className: cn("data-[active]:bg-primary-100 data-[active]:text-primary data-[active]:font-bold", "hover:text-primary hover:no-underline", "group flex w-full flex-1 items-center justify-start gap-1 rounded p-2 text-neutral-800", className)
  }, props));
});
NavigationMenuLink.displayName = NavigationMenuPrimitive__namespace.Link.displayName;
var NavigationMenuViewport = React__namespace.forwardRef(function (_ref120, ref) {
  var className = _ref120.className,
      props = _objectWithoutProperties(_ref120, _excluded95);

  return /* @__PURE__ */jsxRuntime.jsx("div", {
    className: cn("absolute left-0 top-full flex justify-center"),
    children: /* @__PURE__ */jsxRuntime.jsx(NavigationMenuPrimitive__namespace.Viewport, _objectSpread({
      className: cn("origin-top-center bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border text-left shadow-lg md:w-[var(--radix-navigation-menu-viewport-width)]", className),
      ref: ref
    }, props))
  });
});
NavigationMenuViewport.displayName = NavigationMenuPrimitive__namespace.Viewport.displayName;
var NavigationMenuIndicator = React__namespace.forwardRef(function (_ref121, ref) {
  var className = _ref121.className,
      props = _objectWithoutProperties(_ref121, _excluded96);

  return /* @__PURE__ */jsxRuntime.jsx(NavigationMenuPrimitive__namespace.Indicator, _objectSpread(_objectSpread({
    ref: ref,
    className: cn("data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden", className)
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md"
    })
  }));
});
NavigationMenuIndicator.displayName = NavigationMenuPrimitive__namespace.Indicator.displayName;
var Switch = React__namespace.forwardRef(function (_ref122, ref) {
  var className = _ref122.className,
      props = _objectWithoutProperties(_ref122, _excluded97);

  return /* @__PURE__ */jsxRuntime.jsx(SwitchPrimitives__namespace.Root, _objectSpread(_objectSpread({
    className: cn("focus-visible:ring-ring focus-visible:ring-offset-background data-[state=checked]:bg-primary peer inline-flex h-5 w-8 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=unchecked]:bg-neutral-500", className)
  }, props), {}, {
    ref: ref,
    children: /* @__PURE__ */jsxRuntime.jsx(SwitchPrimitives__namespace.Thumb, {
      className: cn("bg-background bg-primary-contrast pointer-events-none block h-4 w-4 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0")
    })
  }));
});
Switch.displayName = SwitchPrimitives__namespace.Root.displayName;

var _path$5;

function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$5.apply(this, arguments);
}

var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3a6 6 0 0 0-6 6v6a6 6 0 0 0 6 6h6a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6H9Zm2 5a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V8Zm0 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
    fill: "currentColor"
  })));
};

var _circle, _path$4, _circle2;

function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$4.apply(this, arguments);
}

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11 11h1v6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1,
    fill: "currentColor"
  })));
};

var _path$3;

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3.apply(this, arguments);
}

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18ZM5.327 8.92a1 1 0 1 0-1.414 1.415l2.962 2.962a1 1 0 0 0 1.415 0L14.087 7.5a1 1 0 0 0-1.414-1.415l-5.09 5.09-2.256-2.254Z",
    fill: "currentColor"
  })));
};

var _path$2;

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$2.apply(this, arguments);
}

var SvgTimes = function SvgTimes(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M16.365 16.434 5.638 5.707M5.638 16.305 16.365 5.578"
  })));
};

var ToastProvider = ToastPrimitives__namespace.Provider;
var ToastViewport = React__namespace.forwardRef(function (_ref123, ref) {
  var className = _ref123.className,
      _ref123$position = _ref123.position,
      position = _ref123$position === void 0 ? "bottom-right" : _ref123$position,
      props = _objectWithoutProperties(_ref123, _excluded98);

  var positionClasses = {
    "top-left": "top-0 left-0 justify-start",
    "top-center": "top-0 left-1/2 transform -translate-x-1/2 justify-center",
    "top-right": "top-0 right-0 justify-end",
    "bottom-left": "bottom-[50px] left-0 -translate-y-1/2 justify-start",
    "bottom-center": "bottom-[50px] left-1/2 transform -translate-x-1/2 -translate-y-1/2 justify-center",
    "bottom-right": "bottom-[50px] right-0 -translate-y-1/2  justify-end"
  };
  return /* @__PURE__ */jsxRuntime.jsx(ToastPrimitives__namespace.Viewport, _objectSpread({
    ref: ref,
    className: cn("fixed z-[100] flex max-h-screen w-full max-w-sm p-4 lg:max-w-none", positionClasses[position], // Apply the selected position classes
    className)
  }, props));
});
ToastViewport.displayName = ToastPrimitives__namespace.Viewport.displayName;
var toastVariants = classVarianceAuthority.cva("data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=open]:fade-in-80 group pointer-events-auto relative flex w-full items-center justify-between overflow-hidden rounded-md p-2 transition-all data-[state=closed]:slide-out-to-top-8 data-[state=open]:slide-in-from-top-8 top-[calc(var(--mz-header-height)+1rem)] z-50 m-auto w-auto duration-300 md:max-w-lg lg:max-w-none", {
  variants: {
    variant: {
      primary: "bg-primary-100 text-primary-400",
      secondary: "bg-secondary-100 text-secondary-400",
      error: "bg-error-100 text-error-400 ",
      success: "bg-success-100 text-success-500",
      warning: "bg-warning-100 text-warning-400",
      neutral: "bg-neutral-100 text-neutral-800"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
});
var Toast = React__namespace.forwardRef(function (_ref124, ref) {
  var className = _ref124.className,
      variant = _ref124.variant,
      props = _objectWithoutProperties(_ref124, _excluded99);

  return /* @__PURE__ */jsxRuntime.jsx(ToastPrimitives__namespace.Root, _objectSpread({
    ref: ref,
    className: cn(toastVariants({
      variant: variant
    }), className)
  }, props));
});
Toast.displayName = ToastPrimitives__namespace.Root.displayName;
var ToastTitle = React__namespace.forwardRef(function (_ref125, ref) {
  var className = _ref125.className,
      props = _objectWithoutProperties(_ref125, _excluded100);

  return /* @__PURE__ */jsxRuntime.jsx(ToastPrimitives__namespace.Title, _objectSpread({
    ref: ref,
    className: cn("text-sm", className)
  }, props));
});
ToastTitle.displayName = ToastPrimitives__namespace.Title.displayName;
var ToastDescription = React__namespace.forwardRef(function (_ref126, ref) {
  var className = _ref126.className,
      props = _objectWithoutProperties(_ref126, _excluded101);

  return /* @__PURE__ */jsxRuntime.jsx(ToastPrimitives__namespace.Description, _objectSpread({
    ref: ref,
    className: cn("text-xs opacity-90", className)
  }, props));
});
ToastDescription.displayName = ToastPrimitives__namespace.Description.displayName;
var TOAST_LIMIT = 1;
var TOAST_REMOVE_DELAY = 1e6;
var count = 0;

var genId = function genId() {
  count = (count + 1) % Number.MAX_SAFE_INTEGER;
  return count.toString();
};

var toastTimeouts = /* @__PURE__ */new Map();

var addToRemoveQueue = function addToRemoveQueue(toastId) {
  if (toastTimeouts.has(toastId)) {
    return;
  }

  var timeout = setTimeout(function () {
    toastTimeouts.delete(toastId);
    dispatch({
      type: "REMOVE_TOAST",
      toastId: toastId
    });
  }, TOAST_REMOVE_DELAY);
  toastTimeouts.set(toastId, timeout);
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "ADD_TOAST":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          toasts: [action.toast].concat(_toConsumableArray(state.toasts)).slice(0, TOAST_LIMIT)
        });
      }

    case "UPDATE_TOAST":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          toasts: state.toasts.map(function (t) {
            return t.id === action.toast.id ? _objectSpread(_objectSpread({}, t), action.toast) : t;
          })
        });
      }

    case "DISMISS_TOAST":
      {
        var toastId = action.toastId;

        if (toastId) {
          addToRemoveQueue(toastId);
        } else {
          state.toasts.forEach(function (toast2) {
            addToRemoveQueue(toast2.id);
          });
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          toasts: state.toasts.map(function (t) {
            return t.id === toastId || toastId === void 0 ? _objectSpread(_objectSpread({}, t), {}, {
              open: false
            }) : t;
          })
        });
      }

    case "REMOVE_TOAST":
      {
        if (action.toastId === void 0) {
          return _objectSpread(_objectSpread({}, state), {}, {
            toasts: []
          });
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          toasts: state.toasts.filter(function (t) {
            return t.id !== action.toastId;
          })
        });
      }
  }
};

var listeners = [];
var memoryState = {
  toasts: []
};

var dispatch = function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach(function (listener) {
    listener(memoryState);
  });
};

var toast = function toast(_ref127) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref127), _ref127));
  var id = genId();

  var update = function update(props2) {
    return dispatch({
      type: "UPDATE_TOAST",
      toast: _objectSpread(_objectSpread({}, props2), {}, {
        id: id
      })
    });
  };

  var dismiss = function dismiss() {
    return dispatch({
      type: "DISMISS_TOAST",
      toastId: id
    });
  };

  dispatch({
    type: "ADD_TOAST",
    toast: _objectSpread(_objectSpread({}, props), {}, {
      id: id,
      open: true,
      onOpenChange: function onOpenChange(open) {
        if (!open) dismiss();
      }
    })
  });
  return {
    id: id,
    dismiss: dismiss,
    update: update
  };
};

var useToast = function useToast() {
  var _React__namespace$use = React__namespace.useState(memoryState),
      _React__namespace$use2 = _slicedToArray(_React__namespace$use, 2),
      state = _React__namespace$use2[0],
      setState = _React__namespace$use2[1];

  React__namespace.useEffect(function () {
    listeners.push(setState);
    return function () {
      var index = listeners.indexOf(setState);

      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  return _objectSpread(_objectSpread({}, state), {}, {
    toast: toast,
    dismiss: function dismiss(toastId) {
      return dispatch({
        type: "DISMISS_TOAST",
        toastId: toastId
      });
    }
  });
};

var ICONS = {
  primary: /* @__PURE__ */jsxRuntime.jsx(SvgInfo, {
    className: "text-primary"
  }),
  secondary: /* @__PURE__ */jsxRuntime.jsx(SvgInfo, {
    className: "text-secondary"
  }),
  neutral: /* @__PURE__ */jsxRuntime.jsx(SvgInfo, {
    className: "text-neutral-700"
  }),
  warning: /* @__PURE__ */jsxRuntime.jsx(SvgInfo, {
    className: "text-warning-700"
  }),
  error: /* @__PURE__ */jsxRuntime.jsx(SvgAlert, {
    className: "text-error-300"
  }),
  success: /* @__PURE__ */jsxRuntime.jsx(SvgSuccess, {
    className: "text-success-400"
  })
};

var Toaster = function Toaster(_ref128) {
  var _toasts$, _toasts$2;

  var _ref128$duration = _ref128.duration,
      duration = _ref128$duration === void 0 ? 5e3 : _ref128$duration;

  var _useToast = useToast(),
      toasts = _useToast.toasts;

  var position = (_toasts$ = toasts[0]) === null || _toasts$ === void 0 ? void 0 : _toasts$.position;
  var showDismiss = ((_toasts$2 = toasts[0]) === null || _toasts$2 === void 0 ? void 0 : _toasts$2.showDismiss) || true;
  return /* @__PURE__ */jsxRuntime.jsxs(ToastProvider, {
    duration: duration,
    swipeDirection: "right",
    children: [toasts.map(function (_ref129) {
      var id = _ref129.id,
          title = _ref129.title,
          description = _ref129.description,
          props = _objectWithoutProperties(_ref129, _excluded102);

      return /* @__PURE__ */jsxRuntime.jsxs(Toast, _objectSpread(_objectSpread({}, props), {}, {
        className: "flex items-start justify-between gap-4",
        children: [/* @__PURE__ */jsxRuntime.jsxs("div", {
          className: "grid gap-1",
          children: [title && /* @__PURE__ */jsxRuntime.jsxs(ToastTitle, {
            className: "flex items-center gap-1",
            children: [/* @__PURE__ */jsxRuntime.jsx("div", {
              className: "text-lg",
              children: ICONS[props.variant || "primary"]
            }), title]
          }), description && /* @__PURE__ */jsxRuntime.jsx(ToastDescription, {
            children: description
          })]
        }), showDismiss && /* @__PURE__ */jsxRuntime.jsx(ToastPrimitives.ToastAction, {
          altText: "Dismiss",
          className: "ml-auto",
          children: /* @__PURE__ */jsxRuntime.jsx(SvgTimes, {})
        })]
      }), id);
    }), /* @__PURE__ */jsxRuntime.jsx(ToastViewport, {
      position: position
    })]
  });
};

var Timeline = function Timeline(_ref130) {
  var steps = _ref130.steps;
  return /* @__PURE__ */jsxRuntime.jsxs("div", {
    className: "relative",
    children: [/* @__PURE__ */jsxRuntime.jsx("div", {
      className: "z-1 absolute top-6 h-[2px] w-full bg-neutral-500"
    }), /* @__PURE__ */jsxRuntime.jsx("div", {
      className: "relative z-10 flex",
      children: steps.map(function (step) {
        return /* @__PURE__ */jsxRuntime.jsxs("div", {
          className: "flex w-full flex-col items-center text-center",
          children: [/* @__PURE__ */jsxRuntime.jsx("div", {
            className: cn$1("flex h-12 w-12 items-center justify-center rounded-full text-3xl text-white", step.bgClass),
            children: step.icon
          }), /* @__PURE__ */jsxRuntime.jsx("h2", {
            className: "mt-2 text-lg font-bold text-gray-900",
            children: step.time
          }), /* @__PURE__ */jsxRuntime.jsx("p", {
            className: "text-sm text-gray-600",
            children: step.label
          })]
        }, step.time);
      })
    })]
  });
};

Timeline.displayName = "Timeline";

var _path$1;

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10",
    width: "1em",
    height: "1em"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m1.711 5 3.395 3.394c.115.116.174.26.177.435a.589.589 0 0 1-.177.443.598.598 0 0 1-.44.181.598.598 0 0 1-.439-.18L.482 5.526A.69.69 0 0 1 .27 5a.69.69 0 0 1 .213-.527L4.227.728A.604.604 0 0 1 4.662.55a.589.589 0 0 1 .444.178c.12.12.18.267.18.439s-.06.318-.18.439L1.71 5Z",
    fill: "#637280",
    xmlns: "http://www.w3.org/2000/svg"
  })));
};

var _path;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.289 5 .894 1.606a.604.604 0 0 1-.177-.435.589.589 0 0 1 .177-.443.598.598 0 0 1 .44-.181c.172 0 .318.06.439.18l3.745 3.746A.69.69 0 0 1 5.73 5a.69.69 0 0 1-.213.527L1.773 9.272a.604.604 0 0 1-.435.178.589.589 0 0 1-.444-.178.598.598 0 0 1-.18-.439c0-.172.06-.318.18-.439L4.29 5Z",
    fill: "#637280"
  })));
};

var DOTS = "...";

var range = function range(start, end) {
  return Array.from({
    length: end - start + 1
  }, function (_, idx) {
    return idx + start;
  });
};

var usePagination = function usePagination(_ref131) {
  var totalCount = _ref131.totalCount,
      pageSize = _ref131.pageSize,
      _ref131$siblingCount = _ref131.siblingCount,
      siblingCount = _ref131$siblingCount === void 0 ? 1 : _ref131$siblingCount,
      currentPage = _ref131.currentPage;
  return React.useMemo(function () {
    var totalPageCount = Math.ceil(totalCount / pageSize);
    var totalPageNumbers = siblingCount + 5;
    if (totalPageNumbers >= totalPageCount) return range(1, totalPageCount);
    var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
    var shouldShowLeftDots = leftSiblingIndex > 2;
    var shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

    if (!shouldShowLeftDots && shouldShowRightDots) {
      return [].concat(_toConsumableArray(range(1, 3 + 2 * siblingCount)), [DOTS, totalPageCount]);
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      return [1, DOTS].concat(_toConsumableArray(range(totalPageCount - (3 + 2 * siblingCount) + 1, totalPageCount)));
    }

    return [1, DOTS].concat(_toConsumableArray(range(leftSiblingIndex, rightSiblingIndex)), [DOTS, totalPageCount]);
  }, [totalCount, pageSize, siblingCount, currentPage]);
};

var Pagination = function Pagination(_ref132) {
  var totalCount = _ref132.totalCount,
      pageSize = _ref132.pageSize,
      _ref132$siblingCount = _ref132.siblingCount,
      siblingCount = _ref132$siblingCount === void 0 ? 1 : _ref132$siblingCount,
      currentPage = _ref132.currentPage,
      onPageChange = _ref132.onPageChange,
      _ref132$activeColor = _ref132.activeColor,
      activeColor = _ref132$activeColor === void 0 ? "bg-neutral-100 text-black font-semibold" : _ref132$activeColor,
      _ref132$inactiveColor = _ref132.inactiveColor,
      inactiveColor = _ref132$inactiveColor === void 0 ? "text-gray-600" : _ref132$inactiveColor,
      _ref132$buttonColor = _ref132.buttonColor,
      buttonColor = _ref132$buttonColor === void 0 ? "text-gray-500" : _ref132$buttonColor,
      _ref132$disabledColor = _ref132.disabledColor,
      disabledColor = _ref132$disabledColor === void 0 ? "opacity-50" : _ref132$disabledColor;
  var paginationRange = usePagination({
    totalCount: totalCount,
    pageSize: pageSize,
    siblingCount: siblingCount,
    currentPage: currentPage
  });
  if (!paginationRange || paginationRange.length < 2) return null;

  var onNext = function onNext() {
    return onPageChange(currentPage + 1);
  };

  var onPrevious = function onPrevious() {
    return onPageChange(currentPage - 1);
  };

  return /* @__PURE__ */jsxRuntime.jsxs("ul", {
    className: "flex items-center space-x-2",
    children: [/* @__PURE__ */jsxRuntime.jsx("li", {
      children: /* @__PURE__ */jsxRuntime.jsx("button", {
        type: "button",
        onClick: onPrevious,
        disabled: currentPage === 1,
        className: cn("px-3 py-2", buttonColor, currentPage === 1 && disabledColor),
        children: /* @__PURE__ */jsxRuntime.jsx(SvgArrowLeft, {})
      })
    }), paginationRange.map(function (page, index) {
      return (// eslint-disable-next-line react/no-array-index-key

        /* @__PURE__ */
        jsxRuntime.jsx("li", {
          children: page === "..." ? /* @__PURE__ */jsxRuntime.jsx("span", {
            className: cn("px-3 py-2", inactiveColor),
            children: "..."
          }) : /* @__PURE__ */jsxRuntime.jsx("button", {
            type: "button",
            onClick: function onClick() {
              return onPageChange(Number(page));
            },
            className: cn("rounded-lg px-4 py-2 text-sm", currentPage === page ? activeColor : inactiveColor),
            children: page
          })
        }, index)
      );
    }), /* @__PURE__ */jsxRuntime.jsx("li", {
      children: /* @__PURE__ */jsxRuntime.jsx("button", {
        type: "button",
        onClick: onNext,
        disabled: currentPage === paginationRange[paginationRange.length - 1],
        className: cn("px-3 py-2", buttonColor, currentPage === paginationRange[paginationRange.length - 1] && disabledColor),
        children: /* @__PURE__ */jsxRuntime.jsx(SvgArrowRight, {})
      })
    })]
  });
};

Pagination.displayName = "Pagination";

var Skeleton = function Skeleton(_ref133) {
  var className = _ref133.className,
      props = _objectWithoutProperties(_ref133, _excluded103);

  return /* @__PURE__ */jsxRuntime.jsx("div", _objectSpread({
    className: cn("animate-pulse rounded-md bg-neutral-200", className)
  }, props));
};

exports.Alert = Alert;
exports.AspectRatio = AspectRatio;
exports.BUTTON_COLOR = BUTTON_COLOR;
exports.BUTTON_SIZE = BUTTON_SIZE;
exports.BUTTON_VARIANT = BUTTON_VARIANT;
exports.Badge = Badge;
exports.Button = Button;
exports.Card = Card;
exports.CardContent = CardContent;
exports.CardDescription = CardDescription;
exports.CardFooter = CardFooter;
exports.CardHeader = CardHeader;
exports.CardTitle = CardTitle;
exports.Checkbox = Checkbox;
exports.CheckboxCard = CheckboxCard;
exports.CheckboxCardButton = CheckboxCardButton;
exports.CheckboxCardDescription = CheckboxCardDescription;
exports.CheckboxCardTitle = CheckboxCardTitle;
exports.CheckboxIndicatorWrapper = CheckboxIndicatorWrapper;
exports.Collapsible = Collapsible;
exports.CollapsibleContent = CollapsibleContent;
exports.CollapsibleTrigger = CollapsibleTrigger;
exports.ComboBox = _ComboBox;
exports.ComboBoxButton = _ComboBoxButton;
exports.ComboBoxContent = _ComboBoxContent;
exports.ComboBoxContentContext = ComboBoxContentContext;
exports.ComboBoxContentStateContext = ComboBoxContentStateContext;
exports.ComboBoxContext = ComboBoxContext;
exports.ComboBoxInput = _ComboBoxInput;
exports.ComboBoxInputContext = ComboBoxInputContext;
exports.ComboBoxItem = _ComboBoxItem;
exports.ComboBoxLabel = _ComboBoxLabel;
exports.ComboBoxLabelContext = ComboBoxLabelContext;
exports.ComboBoxPopover = _ComboBoxPopover;
exports.ComboBoxPopoverContext = ComboBoxPopoverContext;
exports.ComboBoxStateContext = ComboBoxStateContext;
exports.CommandSheet = CommandSheet;
exports.CommandSheetContent = CommandSheetContent;
exports.CommandSheetItem = CommandSheetItem;
exports.CommandSheetList = CommandSheetList;
exports.CommandSheetTrigger = CommandSheetTrigger;
exports.Container = Container;
exports.CountryInput = CountryInput;
exports.DatePicker = DatePicker;
exports.Dialog = Dialog;
exports.DialogClose = DialogClose;
exports.DialogContent = DialogContent;
exports.DialogDescription = DialogDescription;
exports.DialogFooter = DialogFooter;
exports.DialogHeader = DialogHeader;
exports.DialogPortal = DialogPortal;
exports.DialogScrollableContent = DialogScrollableContent;
exports.DialogTitle = DialogTitle;
exports.DialogTrigger = DialogTrigger;
exports.Filter = Filter;
exports.Flag = Flag;
exports.FloatingInput = FloatingInput;
exports.FloatingInputArrow = FloatingInputArrow;
exports.FloatingInputClearButton = FloatingInputClearButton;
exports.FloatingInputGroup = FloatingInputGroup;
exports.FloatingInputLeftContent = FloatingInputLeftContent;
exports.FloatingInputRightContent = FloatingInputRightContent;
exports.FloatingLabel = FloatingLabel;
exports.Footer = Footer;
exports.Header = Header;
exports.HeaderAvatar = HeaderAvatar;
exports.HeaderButton = HeaderButton;
exports.HeaderCombobox = HeaderCombobox;
exports.HeaderContent = HeaderContent;
exports.HeaderCreateAccountButton = HeaderCreateAccountButton;
exports.HeaderLogo = HeaderLogo;
exports.HeaderSignInButton = HeaderSignInButton;
exports.HeaderUserAvatar = HeaderUserAvatar;
exports.IconButton = IconButton;
exports.Input = Input;
exports.InputClearButton = InputClearButton;
exports.InputGroup = InputGroup;
exports.InputLeftContent = InputLeftContent;
exports.Link = Link;
exports.Loading = Loading;
exports.LocaleInput = LocaleInput;
exports.NavigationMenu = NavigationMenu;
exports.NavigationMenuItem = NavigationMenuItem;
exports.NavigationMenuLink = NavigationMenuLink;
exports.NavigationMenuList = NavigationMenuList;
exports.Pagination = Pagination;
exports.PhoneInput = PhoneInput;
exports.Popover = Popover;
exports.PopoverClose = PopoverClose;
exports.PopoverContent = PopoverContent;
exports.PopoverTrigger = PopoverTrigger;
exports.RadioButtonGroup = RadioButtonGroup;
exports.RadioButtonGroupItem = RadioButtonGroupItem;
exports.RadioGroup = RadioGroup;
exports.RadioGroupItem = RadioGroupItem;
exports.ResponsiveAutocomplete = ResponsiveAutocomplete;
exports.ResponsiveCombobox = ResponsiveCombobox;
exports.SHEET_CONTENT_SIDE = SHEET_CONTENT_SIDE;
exports.ScrollArea = ScrollArea;
exports.ScrollBar = ScrollBar;
exports.Select = Select;
exports.SelectContent = SelectContent;
exports.SelectGroup = SelectGroup;
exports.SelectIcon = SelectIcon;
exports.SelectItem = SelectItem;
exports.SelectLabel = SelectLabel;
exports.SelectSeparator = SelectSeparator;
exports.SelectTrigger = SelectTrigger;
exports.SelectValue = SelectValue;
exports.Sheet = Sheet;
exports.SheetClose = SheetClose;
exports.SheetContent = SheetContent;
exports.SheetTrigger = SheetTrigger;
exports.Skeleton = Skeleton;
exports.Switch = Switch;
exports.TAB_VARIANT = TAB_VARIANT;
exports.Tabs = Tabs;
exports.TabsContent = TabsContent;
exports.TabsList = TabsList;
exports.TabsTrigger = TabsTrigger;
exports.TimePicker = TimePicker;
exports.Timeline = Timeline;
exports.Toaster = Toaster;
exports.Tooltip = Tooltip;
exports.TooltipContent = TooltipContent;
exports.TooltipTrigger = TooltipTrigger;
exports.cn = cn;
exports.defaultTheme = defaultTheme;
exports.extendPalette = extendPalette;
exports.extendTheme = extendTheme;
exports.getTheme = getTheme;
exports.mediaQueries = mediaQueries;
exports.setTheme = setTheme;
exports.toThemeVars = toThemeVars;
exports.useCountries = useCountries;
exports.useToast = useToast;
exports.useTranslation = useTranslation;